webpackJsonp([16,14],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(246);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactDom = __webpack_require__(137);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(54);
	
	var _reactRedux = __webpack_require__(135);
	
	var _reactCookie = __webpack_require__(448);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	__webpack_require__(406);
	
	__webpack_require__(417);
	
	__webpack_require__(416);
	
	__webpack_require__(413);
	
	__webpack_require__(415);
	
	__webpack_require__(414);
	
	var _store = __webpack_require__(241);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(238);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	// import 'semantic-ui-css/semantic.css';
	
	var stateDiv = document.getElementById('__INITIAL_STATE__');
	if (stateDiv) {
	  var stateStr = stateDiv.textContent || stateDiv.innerText || stateDiv.innerHTML || '{}';
	  stateStr = stateStr.replace(/\\u003c/g, '<');
	  initialState = JSON.parse(stateStr);
	}
	
	var store = (0, _store2.default)(_reactRouter.browserHistory, initialState, window);
	var routes = (0, _routes2.default)(store);
	
	if (window.localStorage !== undefined) {
	  var referrer = _lodash2.default.get(initialState, 'auth.referrer', null);
	  if (referrer) {
	    _reactCookie2.default.save('referrer', referrer, { path: '/', maxAge: 604800 });
	  }
	}
	var user = _lodash2.default.get(initialState, 'auth.user', null);
	if (!user) {
	  var registrationParams = _lodash2.default.get(initialState, 'auth.registrationParams', null);
	  if (registrationParams) {
	    _reactCookie2.default.save('registrationParams', JSON.stringify(registrationParams), { path: '/', maxAge: 604800 });
	  }
	}
	
	(0, _reactRouter.match)({ history: _reactRouter.browserHistory, routes: routes }, function (err, redirect, props) {
	  if (err) {
	    throw err;
	  }
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(_reactRouter.Router, props)
	  ), document.getElementById('app'));
	});

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	var Qs, _, config, extend, routeList, updateObj, updateURLQuery, urlPath;
	
	Qs = __webpack_require__(442);
	
	_ = __webpack_require__(17);
	
	extend = __webpack_require__(167);
	
	config = __webpack_require__(140);
	
	exports.routes = {
	  print: __webpack_require__(278),
	  dashboard: __webpack_require__(255),
	  dashboard2: __webpack_require__(256),
	  query: __webpack_require__(281),
	  manager: __webpack_require__(266),
	  ecommerce: __webpack_require__(257),
	  ecommerce2: __webpack_require__(258),
	  embrServer: __webpack_require__(260),
	  employee: __webpack_require__(261),
	  fileServer: __webpack_require__(263),
	  order: __webpack_require__(272),
	  order2: __webpack_require__(273),
	  order3: __webpack_require__(274),
	  website: __webpack_require__(286),
	  website2: __webpack_require__(287),
	  email: __webpack_require__(259),
	  printer: __webpack_require__(279),
	  updater: __webpack_require__(284),
	  webcam: __webpack_require__(285),
	  alpha: __webpack_require__(249),
	  autobagger: __webpack_require__(251),
	  sanmar: __webpack_require__(282),
	  manager2: __webpack_require__(267),
	  ping: __webpack_require__(277),
	  netsuite: __webpack_require__(271),
	  packingSlip: __webpack_require__(276),
	  graphql: __webpack_require__(264),
	  mockupServer: __webpack_require__(269),
	  mockupQuery: __webpack_require__(268),
	  mockupTools: __webpack_require__(270),
	  promoStandards: __webpack_require__(280),
	  coupa: __webpack_require__(254),
	  statement: __webpack_require__(283),
	  integrations: __webpack_require__(265),
	  authServer: __webpack_require__(250),
	  camera: __webpack_require__(252),
	  featureFlag: __webpack_require__(262),
	  common: __webpack_require__(253),
	  orderForm: __webpack_require__(275)
	};
	
	exports.url = function(service, path, params) {
	  var externalPort, host, port, protocol, ref, ref1, ref2, ref3, ref4, ref5, url;
	  if (params == null) {
	    params = {};
	  }
	  protocol = ((ref = config[service]) != null ? ref.protocol : void 0) || 'http';
	  host = ((ref1 = config[service]) != null ? ref1.host : void 0) || 'localhost';
	  port = ((ref2 = config[service]) != null ? ref2.port : void 0) || '';
	  externalPort = (ref3 = config[service]) != null ? ref3.externalPort : void 0;
	  if ((ref4 = config[service]) != null ? ref4.dockerHost : void 0) {
	    host = (ref5 = config[service]) != null ? ref5.dockerHost : void 0;
	  }
	  url = protocol + "://" + host;
	  if (!externalPort && port) {
	    url += ":" + port;
	  }
	  if ((externalPort != null) && externalPort !== 80) {
	    url += ":" + externalPort;
	  }
	  return url + urlPath(path, params);
	};
	
	exports.path = urlPath = function(path, params, hash) {
	  var key, qs, seen, val;
	  if (params == null) {
	    params = {};
	  }
	  if (hash == null) {
	    hash = {};
	  }
	  params = extend({}, params);
	  seen = {};
	  path = path.replace(/((\/|\.):\w+\??)/g, function(m, p1) {
	    var leading, param, required;
	    leading = m[0];
	    required = !~p1.indexOf('?');
	    param = p1.replace(/[\/\.:?]/g, '');
	    seen[param] = true;
	    if (required && (params[param] == null)) {
	      return leading + ":" + param;
	    }
	    if (params[param] != null) {
	      return "" + leading + params[param];
	    } else {
	      return '';
	    }
	  });
	  for (key in params) {
	    val = params[key];
	    if (seen[key]) {
	      delete params[key];
	    }
	  }
	  if (qs = Qs.stringify(params)) {
	    path += "?" + qs;
	  }
	  if (qs = Qs.stringify(hash)) {
	    path += "#?" + qs;
	  }
	  return path;
	};
	
	exports.params = function(path, route) {
	  var i, idx, len, match, matchRoute, param, params, result, value;
	  params = route.match(/\/:\w+\??/g, route);
	  matchRoute = route.replace(/\/:\w+\??/g, '/(.*)');
	  match = path.match(matchRoute);
	  result = {};
	  for (idx = i = 0, len = params.length; i < len; idx = ++i) {
	    param = params[idx];
	    param = param.replace(/^\/:/, '');
	    value = match[idx + 1];
	    result[param] = value;
	  }
	  return result;
	};
	
	exports.routeList = routeList = function(routeObject) {
	  var key, list, val;
	  if (typeof routeObject === 'string') {
	    return [routeObject];
	  }
	  list = [];
	  for (key in routeObject) {
	    val = routeObject[key];
	    if (typeof val === 'string') {
	      list.push(val);
	    } else if (typeof val === 'object') {
	      list.push.apply(list, routeList(val));
	    }
	  }
	  return list;
	};
	
	updateObj = function(obj, update) {
	  var key, results, value;
	  results = [];
	  for (key in update) {
	    value = update[key];
	    if (_.isNull(value)) {
	      results.push(delete obj[key]);
	    } else if (_.isPlainObject(value) && _.isPlainObject(obj[key])) {
	      results.push(updateObj(obj[key], value));
	    } else {
	      results.push(obj[key] = value);
	    }
	  }
	  return results;
	};
	
	exports.updateURLQuery = updateURLQuery = function(path, query, update, options) {
	  var pathQuery, queryObj, ref;
	  ref = path.split('?'), path = ref[0], pathQuery = ref[1];
	  queryObj = Qs.parse(pathQuery, options);
	  queryObj = _.merge(queryObj, query);
	  updateObj(queryObj, update);
	  return (path + "?" + (Qs.stringify(queryObj, options))).replace(/\?$/, '');
	};


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.entries = entries;
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _isomorphicFetch = __webpack_require__(436);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = /*#__PURE__*/regeneratorRuntime.mark(entries); // Callback style wrapped fetch API for JSON request
	
	function entries(obj) {
	  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
	
	  return regeneratorRuntime.wrap(function entries$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _iteratorNormalCompletion = true;
	          _didIteratorError = false;
	          _iteratorError = undefined;
	          _context.prev = 3;
	          _iterator = Object.keys(obj)[Symbol.iterator]();
	
	        case 5:
	          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	            _context.next = 12;
	            break;
	          }
	
	          key = _step.value;
	          _context.next = 9;
	          return [key, obj[key]];
	
	        case 9:
	          _iteratorNormalCompletion = true;
	          _context.next = 5;
	          break;
	
	        case 12:
	          _context.next = 18;
	          break;
	
	        case 14:
	          _context.prev = 14;
	          _context.t0 = _context['catch'](3);
	          _didIteratorError = true;
	          _iteratorError = _context.t0;
	
	        case 18:
	          _context.prev = 18;
	          _context.prev = 19;
	
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	
	        case 21:
	          _context.prev = 21;
	
	          if (!_didIteratorError) {
	            _context.next = 24;
	            break;
	          }
	
	          throw _iteratorError;
	
	        case 24:
	          return _context.finish(21);
	
	        case 25:
	          return _context.finish(18);
	
	        case 26:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked, this, [[3, 14, 18, 26], [19,, 21, 25]]);
	}
	
	var _btoa = void 0;
	if (typeof btoa === 'undefined' && typeof Buffer === 'function') {
	  _btoa = function _btoa(str) {
	    return new Buffer(str).toString('base64');
	  };
	} else if (typeof btoa === 'function') {
	  _btoa = btoa;
	}
	
	var defaultFetchOptions = {
	  credentials: 'same-origin',
	  headers: {
	    'Accept': 'application/json, text/plain, */*',
	    'Content-Type': 'application/json'
	  }
	};
	
	function validateResponse(response) {
	  if (!response.ok) {
	    var error = new Error(response.statusText);
	    error.response = response;
	    error.statusCode = response.status;
	    throw error;
	  }
	  return response;
	}
	
	function httpRequest(method, url) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var requestCb = arguments[3];
	
	  if (!requestCb) {
	    requestCb = options;
	    options = {};
	  }
	  var xsrfToken = void 0;
	  if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object') {
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = document.cookie.split(';')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var cookieEntry = _step2.value;
	
	        var _cookieEntry$split = cookieEntry.split('='),
	            _cookieEntry$split2 = _slicedToArray(_cookieEntry$split, 2),
	            name = _cookieEntry$split2[0],
	            value = _cookieEntry$split2[1];
	
	        if (name.trim() === 'XSRF-TOKEN' && value.trim()) {
	          xsrfToken = value.trim();
	        }
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	  // Break out of the promise chain, not letting the promise catch any error not related to fetch itself
	  var cb = function cb() {
	    _lodash2.default.defer(_lodash2.default.spread(requestCb), arguments);
	  };
	  var fetchOptions = _lodash2.default.merge({}, defaultFetchOptions, options, { method: method });
	  if (fetchOptions.auth) {
	    if (fetchOptions.auth.user || fetchOptions.auth.pass) {
	      var encoded = _btoa(fetchOptions.auth.user + ':' + fetchOptions.auth.pass);
	      fetchOptions.headers.Authorization = 'Basic ' + encoded;
	    }
	  }
	  if (xsrfToken) {
	    fetchOptions.headers['X-XSRF-TOKEN'] = xsrfToken;
	  }
	  if (options.data || options.body) {
	    fetchOptions.body = JSON.stringify(options.data || options.body);
	  }
	  var headers = {};
	  if (typeof window === 'undefined' && url.indexOf(/https?:\/\//) !== 0 && fetchOptions.defaultOrigin) {
	    url = '' + fetchOptions.defaultOrigin + url;
	  }
	  (0, _isomorphicFetch2.default)(url, fetchOptions).then(validateResponse).then(function (response) {
	    if (response.headers) {
	      var headerEntries = void 0;
	      if (response.headers && response.headers.entries) {
	        headerEntries = response.headers.entries();
	      } else if (response.headers && response.headers._headers) {
	        headerEntries = entries(response.headers._headers);
	      } else {
	        headerEntries = [];
	      }
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = headerEntries[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var _step3$value = _slicedToArray(_step3.value, 2),
	              key = _step3$value[0],
	              value = _step3$value[1];
	
	          headers[key] = value;
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	    var meta = {};
	    meta.statusCode = response.status;
	    meta.headers = headers;
	    if (response.status === 204) {
	      return cb(null, null, meta, response);
	    } else {
	      response.text().then(function (text) {
	        var result = void 0;
	        try {
	          result = JSON.parse(text);
	        } catch (e) {
	          result = text;
	        }
	        cb(null, result, meta, response);
	      });
	    }
	  }).catch(function (err) {
	    if (err.response) {
	      err.response.json().then(function (json) {
	        json.response = err.response;
	        json.statusCode = err.statusCode;
	        cb(json);
	      }).catch(function () {
	        cb(err);
	      });
	    } else {
	      if (err.message === 'Failed to fetch') {
	        err.message = 'There are issues with your Internet connection. Please try again later.';
	      }
	      cb(err);
	    }
	  });
	}
	
	exports.default = {
	  get: function get(url, options, cb) {
	    httpRequest('GET', url, options, cb);
	  },
	  post: function post(url, options, cb) {
	    httpRequest('POST', url, options, cb);
	  },
	  put: function put(url, options, cb) {
	    httpRequest('PUT', url, options, cb);
	  },
	  delete: function _delete(url, options, cb) {
	    httpRequest('DELETE', url, options, cb);
	  },
	  patch: function patch(url, options, cb) {
	    httpRequest('PATCH', url, options, cb);
	  },
	  request: httpRequest,
	  defaultOptions: function defaultOptions(options) {
	    if (options) {
	      defaultFetchOptions = _lodash2.default.merge({}, defaultFetchOptions, options);
	    }
	    return defaultFetchOptions;
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(438).Buffer))

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(133);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(54);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _PageOverlay = __webpack_require__(229);
	
	var _PageOverlay2 = _interopRequireDefault(_PageOverlay);
	
	var _HomePageHero = __webpack_require__(236);
	
	var _HomePageHero2 = _interopRequireDefault(_HomePageHero);
	
	var _CareersHero = __webpack_require__(235);
	
	var _CareersHero2 = _interopRequireDefault(_CareersHero);
	
	__webpack_require__(411);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBar2 = function (_React$Component) {
	  _inherits(NavBar2, _React$Component);
	
	  function NavBar2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NavBar2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NavBar2.__proto__ || Object.getPrototypeOf(NavBar2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuActive: false
	    }, _this.setMenuActive = function (menuActive) {
	      return function () {
	        _this.setState({ menuActive: menuActive });
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NavBar2, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          user = _props.user,
	          landing = _props.landing,
	          careers = _props.careers;
	
	      var ecommerceUser = user && (user.shopify || user.wooCommerce);
	      return _react2.default.createElement(
	        "div",
	        { className: (0, _classnames2.default)("NavBar2", { landing: landing, careers: careers }) },
	        (landing || careers) && _react2.default.createElement(
	          "div",
	          { className: "sp-index--video-container" },
	          landing && _react2.default.createElement(
	            "video",
	            {
	              className: "sp-video sp-video--index sp-desktop-only",
	              preload: "auto",
	              autoPlay: "true",
	              loop: "true",
	              muted: "muted"
	            },
	            _react2.default.createElement("source", {
	              src: "https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/homepage-new.mp4",
	              type: "video/mp4"
	            })
	          ),
	          careers && _react2.default.createElement(
	            "video",
	            {
	              className: "sp-video sp-video--index sp-desktop-only",
	              preload: "auto",
	              autoPlay: "true",
	              loop: "true",
	              muted: "muted"
	            },
	            _react2.default.createElement("source", {
	              src: "https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/career.webm",
	              type: "video/webm"
	            }),
	            _react2.default.createElement("source", {
	              src: "https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/career.mp4",
	              type: "video/mp4"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "ui container p-v-1_5" },
	          _react2.default.createElement(
	            "div",
	            { className: "ui fluid menu b-a-n" },
	            _react2.default.createElement(
	              "div",
	              { className: "item p-a-0" },
	              ecommerceUser ? _react2.default.createElement(
	                "a",
	                { href: (0, _ooRoutes.url)("ecommerce", _ooRoutes.routes.ecommerce.dashboard.base) },
	                _react2.default.createElement("img", {
	                  className: "ui image small sp-logo",
	                  src: __webpack_require__(138)
	                })
	              ) : _react2.default.createElement(
	                _reactRouter.Link,
	                { to: _ooRoutes.routes.website2.home.base },
	                _react2.default.createElement("img", {
	                  className: "ui image small sp-logo",
	                  src: __webpack_require__(138)
	                })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "right menu computer-only" },
	              _react2.default.createElement(
	                "h5",
	                { className: "item m-a-0 fw-700" },
	                _react2.default.createElement(
	                  "a",
	                  { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.pricing) },
	                  "PRICING"
	                )
	              ),
	              _react2.default.createElement(
	                "h5",
	                { className: "item m-a-0 fw-700" },
	                _react2.default.createElement(
	                  "a",
	                  { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.catalog) },
	                  "CATALOG"
	                )
	              ),
	              _react2.default.createElement(
	                "h5",
	                { className: "item m-r-2 m-v-0 m-l-0 fw-700" },
	                _react2.default.createElement(
	                  "a",
	                  { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.api) },
	                  "API"
	                )
	              ),
	              user ? _react2.default.createElement(
	                "h5",
	                { className: "item m-a-0 fw-700" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: (0, _ooRoutes.url)("manager", _ooRoutes.routes.manager2.base),
	                    className: "ui white inverted basic button p-v-1"
	                  },
	                  "MY ACCOUNT"
	                )
	              ) : _react2.default.createElement(
	                "h5",
	                { className: "item m-a-0 fw-700" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.auth.login),
	                    className: "ui white inverted basic button p-v-1"
	                  },
	                  "LOG IN"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "right menu tablet-only mobile-only" },
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "item m-a-0 fs-2 p-a-0",
	                  onClick: this.setMenuActive(true)
	                },
	                _react2.default.createElement("i", { className: "sidebar icon m-a-0" })
	              )
	            )
	          )
	        ),
	        landing && _react2.default.createElement(_HomePageHero2.default, { user: user }),
	        careers && _react2.default.createElement(_CareersHero2.default, null),
	        _react2.default.createElement(
	          _PageOverlay2.default,
	          {
	            anchor: "right",
	            className: "ui active dimmer",
	            fluid: true,
	            active: this.state.menuActive,
	            style: { top: 0 },
	            animationDuration: 200
	          },
	          _react2.default.createElement(
	            "div",
	            { className: "OverlayMenu" },
	            _react2.default.createElement(
	              "div",
	              { className: "p-a-1_5" },
	              _react2.default.createElement(
	                "div",
	                { className: "ui two column grid" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "left aligned middle aligned column" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "ui image" },
	                    _react2.default.createElement("img", {
	                      src: __webpack_require__(567)
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "right aligned middle aligned column" },
	                  _react2.default.createElement("i", {
	                    className: "i cancel icon m-r-0",
	                    onClick: this.setMenuActive(false)
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "ui divider m-v-0" }),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "left-aligned p-a-1_5",
	                onClick: this.setMenuActive(false)
	              },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.pricing),
	                  className: "link fs-4 sp-primary-text-color d-b m-b-2"
	                },
	                "Pricing"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.catalog),
	                  className: "link fs-4 sp-primary-text-color d-b m-b-2"
	                },
	                "Catalog"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.api),
	                  className: "link fs-4 sp-primary-text-color d-b m-b-2"
	                },
	                "API"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "p-v-1 p-h-1_5" },
	              _react2.default.createElement(
	                "a",
	                {
	                  href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.auth.login),
	                  className: "ui fluid inverted basic primary button m-b-1_5"
	                },
	                "LOG IN"
	              ),
	              _react2.default.createElement(
	                "a",
	                {
	                  href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.auth.register),
	                  className: "ui fluid primary button"
	                },
	                "GET STARTED"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return NavBar2;
	}(_react2.default.Component);
	
	NavBar2.propTypes = {
	  landing: _propTypes2.default.bool
	};
	exports.default = NavBar2;

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.scrollBarWidth = exports.hasScrollBar = exports.scroll = exports.http = undefined;
	
	var _http = __webpack_require__(66);
	
	Object.defineProperty(exports, 'http', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_http).default;
	  }
	});
	exports.capitalize = capitalize;
	exports.getErrorMessage = getErrorMessage;
	exports.formatError = formatError;
	exports.prettyDate = prettyDate;
	exports.prettyDuration = prettyDuration;
	exports.prettyPrice = prettyPrice;
	exports.toKeyName = toKeyName;
	exports.relativeMousePosition = relativeMousePosition;
	exports.modalMousePosition = modalMousePosition;
	exports.absoluteMousePosition = absoluteMousePosition;
	exports.prettySize = prettySize;
	exports.prettyNumber = prettyNumber;
	exports.prettyDesignType = prettyDesignType;
	exports.restResponseCb = restResponseCb;
	exports.productPrintTypes = productPrintTypes;
	
	var _scroll = __webpack_require__(139);
	
	Object.defineProperty(exports, 'scroll', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_scroll).default;
	  }
	});
	Object.defineProperty(exports, 'hasScrollBar', {
	  enumerable: true,
	  get: function get() {
	    return _scroll.hasScrollBar;
	  }
	});
	Object.defineProperty(exports, 'scrollBarWidth', {
	  enumerable: true,
	  get: function get() {
	    return _scroll.scrollBarWidth;
	  }
	});
	exports.numberToEnglish = numberToEnglish;
	exports.renderArtwork = renderArtwork;
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _moment = __webpack_require__(178);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(437);
	
	var _constants = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KEY_NAMES = {
	  8: 'BACKSPACE',
	  13: 'ENTER',
	  27: 'ESCAPE'
	};
	
	function capitalize(str, word) {
	  if (word) {
	    return str.toLowerCase().replace(/\b\w/g, function (letter) {
	      return letter.toUpperCase();
	    });
	  }
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
	// Deprecated
	function getErrorMessage(err) {
	  if (!err) {
	    return null;
	  }
	  if (_lodash2.default.isString(err)) {
	    return err;
	  }
	  if (err.message) {
	    return err.message;
	  }
	  if (err.error) {
	    return err = getErrorMessage(err.error);
	  }
	  if (err.issues) {
	    return _lodash2.default.map(err.issues, function (issue) {
	      return getErrorMessage(issue);
	    });
	  } else {
	    return JSON.stringify(err);
	  }
	}
	
	function formatError(err) {
	  if (!err) {
	    return null;
	  }
	  if (_lodash2.default.isString(err)) {
	    return err;
	  }
	  if (err.message) {
	    return err.message;
	  }
	  if (err.error) {
	    return formatError(err.error);
	  }
	  if (err.issues) {
	    return _lodash2.default.map(err.issues, function (issue) {
	      return formatError(issue);
	    });
	  } else {
	    return JSON.stringify(err);
	  }
	}
	
	function prettyDate(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'MM/DD/YYYY';
	
	  return (0, _moment2.default)(new Date(date)).format(format);
	}
	
	function prettyDuration(input) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'h:mm';
	  var trim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (input.length === 2) {
	    input = (0, _moment2.default)(input[1]).diff((0, _moment2.default)(input[0]), 'minutes');
	  }
	  return _moment2.default.duration(input, 'minutes').format(format, { trim: trim });
	}
	
	function prettyPrice(price) {
	  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	  return '$' + (price / 100).toFixed(decimals);
	}
	
	function toKeyName(keyCode) {
	  return KEY_NAMES[keyCode] || keyCode;
	}
	
	function relativeMousePosition(event, element) {
	  var offsetLeft = 0,
	      offsetTop = 0;
	  var offsetElement = element;
	  while (offsetElement.offsetParent) {
	    offsetLeft += offsetElement.offsetLeft;
	    offsetTop += offsetElement.offsetTop;
	    offsetElement = offsetElement.offsetParent;
	  }
	  return { x: event.pageX - offsetLeft, y: event.pageY - offsetTop - window.pageYOffset };
	}
	
	function modalMousePosition(event, element) {
	  var offsetLeft = 0,
	      offsetTop = 0;
	  var offsetElement = element;
	  while (offsetElement.offsetParent) {
	    offsetLeft += offsetElement.offsetLeft;
	    offsetTop += offsetElement.offsetTop;
	    offsetElement = offsetElement.offsetParent;
	  }
	  var modalElem = document.getElementsByClassName('ui dimmer modals')[0] || {};
	  return { x: event.pageX - offsetLeft, y: event.pageY - window.pageYOffset - offsetTop + (modalElem.scrollTop || 0) };
	}
	
	function absoluteMousePosition(event, element) {
	  var offsetLeft = 0,
	      offsetTop = 0;
	  var offsetElement = element;
	  while (offsetElement.offsetParent) {
	    offsetLeft += offsetElement.offsetLeft;
	    offsetTop += offsetElement.offsetTop;
	    offsetElement = offsetElement.offsetParent;
	  }
	  return { x: event.pageX - offsetLeft, y: event.pageY - offsetTop };
	}
	
	function prettySize(size) {
	  return _constants.DISPLAY_SIZE_MAP[size] || _constants.INFANT_SIZES[size] || _constants.GARMENT_ACCESSORY_SIZES[size] || size;
	}
	
	function prettyNumber(number) {
	  var sign = '';
	  if (number < 0) {
	    sign = '-';
	  }
	  number = Math.abs(number);
	  var output = '';
	  while (number >= 1000) {
	    output = _lodash2.default.padLeft((number % 1000).toString(), 3, '0') + ',' + output;
	    number = Math.floor(number / 1000);
	  }
	  output = '' + sign + number + ',' + output;
	  return output.slice(0, output.length - 1);
	}
	
	function prettyDesignType(type) {
	  return {
	    screenprint: 'Screenprint',
	    dtg: 'DTG',
	    case: 'Case',
	    mug: 'Mug',
	    poster: 'Poster',
	    embr: 'Embroidery'
	  }[type] || type;
	}
	
	function restResponseCb(cb) {
	  return function (err, response, responseMeta) {
	    if (err) {
	      return cb(err);
	    }
	    var meta = {};
	    meta.count = parseInt(responseMeta.headers['x-sp-count']);
	    meta.pages = parseInt(responseMeta.headers['x-sp-pages']);
	    return cb(null, response, meta);
	  };
	}
	
	function productPrintTypes(product) {
	  var printTypes = [];
	  if (product.properties.screenprint) {
	    printTypes.push('Screenprint');
	  }
	  if (product.properties.dtg) {
	    printTypes.push('DTG');
	  }
	  if (product.properties.embr) {
	    printTypes.push('Embroidery');
	  }
	  if (product.properties.poster) {
	    printTypes.push('Poster');
	  }
	  if (product.properties.sublimation) {
	    printTypes.push('Sublimation');
	  }
	  return printTypes;
	}
	
	function numberToEnglish(n) {
	  // for semantic ui formatting
	  switch (n) {
	    case 1:
	      return "one";
	    case 2:
	      return "two";
	    case 3:
	      return "three";
	    case 4:
	      return "four";
	    case 5:
	      return "five";
	    case 6:
	      return "six";
	    case 7:
	      return "seven";
	    case 8:
	      return "eight";
	    case 9:
	      return "nine";
	    case 10:
	      return "ten";
	    case 11:
	      return "eleven";
	    case 12:
	      return "twelve";
	    case 13:
	      return "thirteen";
	    case 14:
	      return "fourteen";
	    case 15:
	      return "fifteen";
	    case 16:
	      return "sixteen";
	  }
	}
	
	function renderArtwork(artworkUrl) {
	  return (0, _ooRoutes.url)('order', _ooRoutes.routes.order.artwork.render.artwork.base, { url: artworkUrl });
	}

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _reactRouter = __webpack_require__(54);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isUrl(to) {
	  return to && (to.indexOf('http://') === 0 || to.indexOf('https://') === 0);
	}
	
	var SPLink = function (_React$Component) {
	  _inherits(SPLink, _React$Component);
	
	  function SPLink() {
	    _classCallCheck(this, SPLink);
	
	    return _possibleConstructorReturn(this, (SPLink.__proto__ || Object.getPrototypeOf(SPLink)).apply(this, arguments));
	  }
	
	  _createClass(SPLink, [{
	    key: 'render',
	    value: function render() {
	      if (isUrl(this.props.to)) {
	        var props = Object.assign({}, this.props, { href: this.props.to });
	        return _react2.default.createElement('a', props);
	      } else {
	        return _react2.default.createElement(_reactRouter.Link, this.props);
	      }
	    }
	  }]);
	
	  return SPLink;
	}(_react2.default.Component);
	
	exports.default = SPLink;

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasScrollBar = hasScrollBar;
	exports.scrollBarWidth = scrollBarWidth;
	exports.setBackgroundScrollable = setBackgroundScrollable;
	function documentBody() {
	  // mobile browser compatibility
	  return document.body || document.getElementsByTagName('body')[0];
	}
	
	function hasScrollBar() {
	  return documentBody().scrollHeight > documentBody().clientHeight;
	}
	
	// returns 0 if scroll bar is overlaid over div in some browser styles
	function scrollBarWidth() {
	  var outer = document.createElement("div");
	  outer.style.visibility = "hidden";
	  outer.style.width = "100px";
	  outer.style.height = "100px";
	  outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
	  // force scrollbars
	  outer.style.overflow = "scroll";
	  documentBody().appendChild(outer);
	  var widthWithScroll = outer.offsetWidth;
	  var widthNoScroll = outer.clientWidth;
	  // remove divs
	  outer.parentNode.removeChild(outer);
	  return widthWithScroll - widthNoScroll;
	}
	
	function setBackgroundScrollable(scrollable, options) {
	  if (scrollable) {
	    documentBody().style.overflowY = 'auto';
	    documentBody().style.paddingRight = 'initial';
	    if (options && options.fixed) {
	      documentBody().style.position = 'initial';
	    }
	  } else {
	    // Disable scroll and add padding in place of scrollbar
	    if (hasScrollBar()) {
	      documentBody().style.overflowY = 'hidden';
	      documentBody().style['padding-right'] = scrollBarWidth() + 'px';
	      if (options && options.fixed) {
	        documentBody().style.position = 'fixed';
	      }
	    }
	  }
	}

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	var base, config, env, extend;
	
	extend = __webpack_require__(167);
	
	env = ("production") || 'development';
	
	base = {
	  print: {
	    port: 3003
	  },
	  home: {
	    port: 3005,
	    externalPort: 80
	  },
	  pretreat: {
	    port: 3016,
	    protocol: 'https',
	    host: 'localhost.ooapi.com'
	  },
	  dashboard: {
	    port: 3010,
	    externalPort: 80
	  },
	  dashboard2: {
	    port: 3057,
	    devPort: 3157,
	    externalPort: 80
	  },
	  query: {
	    port: 3054,
	    externalPort: 80
	  },
	  manager: {
	    port: 3014,
	    externalPort: 80
	  },
	  employee: {
	    port: 3015,
	    externalPort: 80
	  },
	  order: {
	    port: 3016,
	    externalPort: 80
	  },
	  order2: {
	    port: 3056,
	    devPort: 3156,
	    externalPort: 80
	  },
	  order3: {
	    port: 3056,
	    devPort: 3156,
	    externalPort: 80
	  },
	  graphql: {
	    port: 3096,
	    devPort: 3196,
	    externalPort: 80
	  },
	  website: {
	    port: 3017,
	    externalPort: 80
	  },
	  shopify: {
	    port: 3018,
	    externalPort: 80
	  },
	  ecommerce: {
	    port: 3018,
	    externalPort: 80
	  },
	  email: {
	    port: 3019,
	    externalPort: 80
	  },
	  printer: {
	    port: 3022,
	    protocol: 'https',
	    host: 'localhost.sp-lrps.com'
	  },
	  updater: {
	    port: 3023,
	    protocol: 'https',
	    host: 'localhost.sp-lrps.com'
	  },
	  webcam: {
	    port: 3024,
	    protocol: 'https',
	    host: 'localhost.ooapi.com'
	  },
	  pretreat2: {
	    port: 3025,
	    protocol: 'https',
	    host: 'localhost.ooapi.com'
	  },
	  fingerprint: {
	    port: 3026,
	    protocol: 'https',
	    host: 'localhost.ooapi.com'
	  },
	  pretreat3: {
	    port: 3027,
	    protocol: 'https',
	    host: 'dtg-pretreat.sp-lrps.com'
	  },
	  pretreat4: {
	    port: 3027,
	    protocol: 'https',
	    host: {
	      INDY: 'localhost.sp-lrps.com',
	      DALLAS: 'localhost.sp-lrps.com',
	      FRESNO: 'localhost.sp-lrps.com',
	      SCRANTON: 'localhost.sp-lrps.com'
	    }
	  },
	  ping: {
	    port: 3035,
	    protocol: 'https',
	    host: 'localhost.ooapi.com'
	  },
	  packingSlip: {
	    externalPort: 80,
	    port: 3036
	  },
	  analytics: {
	    google: {
	      id: 'UA-59639825-2'
	    }
	  },
	  crm: {
	    port: 3051,
	    devPort: 3151,
	    externalPort: 80
	  },
	  ecommerce2: {
	    port: 3052,
	    devPort: 3152,
	    externalPort: 80
	  },
	  orderTracking: {
	    port: 3053,
	    devPort: 3153
	  },
	  website2: {
	    port: 3055,
	    devPort: 3155,
	    externalPort: 80
	  },
	  alpha: {
	    port: 3058,
	    devPort: 3158,
	    externalPort: 80,
	    allowedHosts: ['http://localhost:8000']
	  },
	  manager2: {
	    port: 3059,
	    devPort: 3159,
	    externalPort: 80,
	    allowedHosts: ['http://localhost:8000']
	  },
	  sanmar: {
	    port: 3060,
	    devPort: 3160,
	    externalPort: 80,
	    allowedHosts: ['http://localhost:8000']
	  },
	  promoStandards: {
	    port: 3063,
	    protocol: 'https'
	  },
	  coupa: {
	    port: 3067
	  },
	  statement: {
	    port: 3068
	  },
	  integrations: {
	    port: 3069
	  },
	  stripe: {
	    'scalable-press': {
	      publishableKey: 'pk_test_7c9xhEYhEFMeQa26PPfZpKsu'
	    },
	    teechip: {
	      publishableKey: 'pk_test_DekwIejcJWFlraPn0vxsaG1S'
	    },
	    plutocase: {
	      publishableKey: 'pk_test_yGN7SOZns1uad3B532tMtysM'
	    }
	  },
	  captcha: {
	    'scalable-press': {
	      siteKey: '6LdUvaIZAAAAAJTGexoR8GJ6YD6NvM-sxZD1pII3'
	    }
	  },
	  tags: {
	    google: {
	      id: 'GTM-T2JHQH'
	    }
	  },
	  raven: {
	    dns: 'https://73a9138742184e90b7dfcd9b35dc57d0@app.getsentry.com/38075'
	  },
	  s3: {
	    uploadPolicy: {
	      bucket: 'oo-dev',
	      AWSAccessKeyId: "AKIAIGUVXPCYFI3OP3LQ",
	      Policy: "eyJleHBpcmF0aW9uIjoiMzAwMC0wMS0wMVQwMDowMDowMFoiLCJjb25kaXRpb25zIjpbeyJidWNrZXQiOiJvby1kZXYifSxbInN0YXJ0cy13aXRoIiwiJGtleSIsInVwbG9hZHMvIl0seyJhY2wiOiJwdWJsaWMtcmVhZCJ9XX0=",
	      Signature: "WGWVI1JFqJc+cQR95CONkDvXM6I=",
	      acl: "public-read"
	    }
	  },
	  dtg: {
	    storage: {
	      port: 3007,
	      syncInterval: 3000,
	      protocol: 'https',
	      host: {
	        INDY: {
	          primary: "dtg2-primary-indy.sp-lrps.com",
	          secondary: "dtg2-secondary-indy.sp-lrps.com"
	        },
	        DALLAS: {
	          primary: "dtg2-primary-dallas.sp-lrps.com",
	          secondary: "dtg2-secondary-dallas.sp-lrps.com"
	        },
	        FRESNO: {
	          primary: "dtg2-primary-fresno.sp-lrps.com",
	          secondary: "dtg2-secondary-fresno.sp-lrps.com"
	        },
	        SCRANTON: {
	          primary: "dtg2-primary-scranton.sp-lrps.com",
	          secondary: "dtg2-secondary-scranton.sp-lrps.com"
	        }
	      }
	    },
	    nas: {
	      print: {
	        backup: 'localhost.sp-lrps.com',
	        primary: 'localhost.sp-lrps.com'
	      }
	    }
	  },
	  autobagger: {
	    port: 3061,
	    host: {
	      INDY: 'localhost.sp-lrps.com',
	      DALLAS: 'localhost.sp-lrps.com',
	      FRESNO: 'localhost.sp-lrps.com',
	      SCRANTON: 'localhost.sp-lrps.com'
	    }
	  },
	  camera: {
	    port: 3062,
	    protocol: 'http'
	  },
	  embrServer: {
	    port: 3038,
	    protocol: 'https',
	    INDY: {
	      ZSK: {
	        url: 'localhost.sp-lrps.com'
	      },
	      TAJIMA: {
	        url: 'localhost.sp-lrps.com'
	      }
	    },
	    host: {
	      INDY: 'localhost.sp-lrps.com',
	      DALLAS: 'localhost.sp-lrps.com',
	      INDY_VM: 'localhost.sp-lrps.com'
	    }
	  },
	  fileServer: {
	    port: 3039,
	    protocol: 'https',
	    host: 'localhost.ooapi.com'
	  },
	  mockupServer: {
	    port: 3040
	  },
	  garmentMockupTool: {
	    host: 'localhost',
	    port: 3042
	  },
	  mockupQuery: {
	    port: 3043
	  },
	  authServer: {
	    port: 3044,
	    externalPort: 80
	  }
	};
	
	config = {
	  development: extend(true, {}, base, {
	    home: {
	      externalPort: 8000
	    },
	    dashboard: {
	      externalPort: 8000
	    },
	    dashboard2: {
	      externalPort: 8000
	    },
	    query: {
	      externalPort: 8000
	    },
	    manager: {
	      externalPort: 8000
	    },
	    employee: {
	      externalPort: 8000
	    },
	    order: {
	      externalPort: 8000
	    },
	    order2: {
	      externalPort: 8000
	    },
	    order3: {
	      externalPort: 8000
	    },
	    graphql: {
	      externalPort: 8000
	    },
	    website: {
	      externalPort: 8000
	    },
	    website2: {
	      externalPort: 8000
	    },
	    shopify: {
	      externalPort: 8000
	    },
	    ecommerce: {
	      externalPort: 8000
	    },
	    ecommerce2: {
	      externalPort: 8000
	    },
	    alpha: {
	      externalPort: 8000
	    },
	    sanmar: {
	      externalPort: 8000
	    },
	    manager2: {
	      externalPort: 8000
	    },
	    email: {
	      externalPort: 8000
	    },
	    crm: {
	      externalPort: 8000
	    },
	    authServer: {
	      externalPort: 8000
	    }
	  }),
	  test: extend(true, {}, base, {
	    home: {
	      externalPort: 8000
	    },
	    dashboard: {
	      externalPort: 8000
	    },
	    dashboard2: {
	      externalPort: 8000
	    },
	    query: {
	      externalPort: 8000
	    },
	    manager: {
	      externalPort: 8000
	    },
	    order: {
	      externalPort: 8000
	    },
	    order2: {
	      externalPort: 8000
	    },
	    order3: {
	      externalPort: 8000
	    },
	    graphql: {
	      externalPort: 8000
	    },
	    website: {
	      externalPort: 8000
	    },
	    website2: {
	      externalPort: 8000
	    },
	    shopify: {
	      externalPort: 8000
	    },
	    ecommerce: {
	      externalPort: 8000
	    },
	    ecommerce2: {
	      externalPort: 8000
	    },
	    alpha: {
	      externalPort: 8000
	    },
	    manager2: {
	      externalPort: 8000
	    },
	    email: {
	      externalPort: 8000
	    },
	    crm: {
	      externalPort: 8000
	    },
	    employee: {
	      port: 2015,
	      externalPort: 2015
	    },
	    print: {
	      port: 2003
	    },
	    autobagger: {
	      port: 2061
	    },
	    authServer: {
	      externalPort: 8000
	    }
	  }),
	  docker: extend(true, {}, base),
	  stage: extend(true, {}, base, {
	    print: {
	      protocol: 'https',
	      externalPort: 80,
	      host: 'api-tanktop.ooapi.com'
	    },
	    employee: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    dashboard: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    dashboard2: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    query: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    manager: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    website: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    website2: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    order: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    order2: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    order3: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    graphql: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    ecommerce: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    ecommerce2: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    alpha: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    sanmar: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    manager2: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    promoStandards: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    coupa: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https',
	      externalPort: 443
	    },
	    statement: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https',
	      externalPort: 443
	    },
	    integrations: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https',
	      externalPort: 443
	    },
	    email: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    mockupServer: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https',
	      externalPort: 443
	    },
	    garmentMockupTool: {
	      host: 'garment-stage.ooapi.com',
	      protocol: 'https'
	    },
	    mockupQuery: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    authServer: {
	      host: 'tanktop.ooapi.com',
	      protocol: 'https'
	    },
	    autobagger: {
	      protocol: 'https',
	      externalPort: 443,
	      host: {
	        INDY: 'ops-stage-indy.sp-lrps.com',
	        DALLAS: 'ops-stage-dallas.sp-lrps.com',
	        FRESNO: 'ops-stage-fresno.sp-lrps.com',
	        SCRANTON: 'ops-stage-scranton.sp-lrps.com'
	      }
	    },
	    pretreat4: {
	      protocol: 'https',
	      host: {
	        INDY: 'ops-stage-indy.sp-lrps.com',
	        DALLAS: 'ops-stage-dallas.sp-lrps.com',
	        FRESNO: 'ops-stage-fresno.sp-lrps.com',
	        SCRANTON: 'ops-stage-scranton.sp-lrps.com'
	      }
	    },
	    camera: {
	      port: 5062,
	      protocol: 'https'
	    }
	  }),
	  production: extend(true, {}, base, {
	    print: {
	      port: 5003,
	      protocol: 'https',
	      host: 'api.scalablepress.com',
	      externalPort: 80
	    },
	    home: {
	      port: 5005,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    dashboard: {
	      port: 5010,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    dashboard2: {
	      port: 5057,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    query: {
	      port: 5054,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    dymo: {
	      port: 5013
	    },
	    manager: {
	      port: 5014,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    employee: {
	      port: 5015,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    order: {
	      port: 5016,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    order2: {
	      port: 5056,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    order3: {
	      port: 5056,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    graphql: {
	      port: 5096,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    alpha: {
	      port: 5058,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      allowedHosts: ['https://scalablepress.com']
	    },
	    sanmar: {
	      port: 5060,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      allowedHosts: ['https://scalablepress.com']
	    },
	    manager2: {
	      port: 5059,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    website: {
	      port: 5017,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    website2: {
	      port: 5055,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    shopify: {
	      port: 5018,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    ecommerce: {
	      port: 5018,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    ecommerce2: {
	      port: 5052,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    email: {
	      port: 5019,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    orderTracking: {
	      port: 5053
	    },
	    packingSlip: {
	      port: 5036,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    embrServer: {
	      port: 5038,
	      protocol: 'https',
	      INDY: {
	        ZSK: {
	          url: 'embr-local-zsk.sp-lrps.com'
	        },
	        TAJIMA: {
	          url: 'embr-local.sp-lrps.com'
	        }
	      },
	      host: {
	        INDY: 'embr-local.sp-lrps.com',
	        DALLAS: 'embr-local-dallas.sp-lrps.com',
	        INDY_VM: 'embr-vm-indy.sp-lrps.com'
	      }
	    },
	    fileServer: {
	      port: 5039,
	      protocol: 'https',
	      host: 'file-local.ooapi.com'
	    },
	    mockupServer: {
	      port: 5040,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      externalPort: 443
	    },
	    garmentMockupTool: {
	      protocol: 'https',
	      host: 'garment.ooapi.com',
	      port: 5042
	    },
	    mockupQuery: {
	      port: 5043,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      externalPort: 80
	    },
	    promoStandards: {
	      port: 5063,
	      protocol: 'https',
	      host: 'scalablepress.com'
	    },
	    coupa: {
	      port: 5067,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      externalPort: 443
	    },
	    statement: {
	      port: 5068,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      externalPort: 443
	    },
	    integrations: {
	      port: 5069,
	      protocol: 'https',
	      host: 'scalablepress.com',
	      externalPort: 443
	    },
	    authServer: {
	      protocol: 'https',
	      host: 'scalablepress.com',
	      port: 5044
	    },
	    s3: {
	      uploadPolicy: {
	        bucket: 'oo-prod',
	        AWSAccessKeyId: "AKIAW7GVFDTWA4K5GOPR",
	        Policy: 'eyJleHBpcmF0aW9uIjoiMzAwMC0wMS0wMVQwMDowMDowMFoiLCJjb25kaXRpb25zIjpbeyJidWNrZXQiOiJvby1wcm9kIn0sWyJzdGFydHMtd2l0aCIsIiRrZXkiLCJ1cGxvYWRzLyJdLHsiYWNsIjoicHVibGljLXJlYWQifV19',
	        Signature: 'pEo7Ego6M6ULxJUM7bCcdgBgvH8=',
	        acl: "public-read"
	      }
	    },
	    analytics: {
	      google: {
	        id: 'UA-59639825-1'
	      }
	    },
	    tags: {
	      google: {
	        id: 'GTM-5Q4H6Z'
	      }
	    },
	    stripe: {
	      'scalable-press': {
	        publishableKey: 'pk_live_74oPQDeV8Dh6cXaRxswhFFCF'
	      },
	      teechip: {
	        publishableKey: 'pk_live_eviy2W7AxSk9b4UFNuuHRq0n'
	      },
	      plutocase: {
	        publishableKey: 'pk_live_FcrcxR1TMTKZqm0uVYf9wwdS'
	      }
	    },
	    captcha: {
	      'scalable-press': {
	        siteKey: '6LcPnQEVAAAAADIaqh_FRsbJut0Meg93KMYYxpnF'
	      }
	    },
	    raven: {
	      dns: 'https://1906ecbf593b417f9c1977a329f65238@app.getsentry.com/34815'
	    },
	    dtg: {
	      storage: {
	        port: 5007,
	        syncInterval: 10000,
	        protocol: 'https',
	        host: {
	          INDY: {
	            primary: "dtg2-primary-indy.sp-lrps.com",
	            secondary: "dtg2-secondary-indy.sp-lrps.com"
	          },
	          DALLAS: {
	            primary: "dtg2-primary-dallas.sp-lrps.com",
	            secondary: "dtg2-secondary-dallas.sp-lrps.com"
	          },
	          FRESNO: {
	            primary: "dtg2-primary-fresno.sp-lrps.com",
	            secondary: "dtg2-secondary-fresno.sp-lrps.com"
	          },
	          SCRANTON: {
	            primary: "dtg2-primary-scranton.sp-lrps.com",
	            secondary: "dtg2-secondary-scranton.sp-lrps.com"
	          }
	        }
	      },
	      nas: {
	        print: {
	          backup: 'dtg2-print-backup.sp-lrps.com',
	          primary: 'dtg2-print-primary.sp-lrps.com'
	        }
	      }
	    },
	    autobagger: {
	      port: 5061,
	      protocol: 'https',
	      externalPort: 443,
	      host: {
	        INDY: 'ops-prod-indy.sp-lrps.com',
	        DALLAS: 'ops-prod-dallas.sp-lrps.com',
	        FRESNO: 'ops-prod-fresno.sp-lrps.com',
	        SCRANTON: 'ops-prod-scranton.sp-lrps.com'
	      }
	    },
	    camera: {
	      port: 5062,
	      protocol: 'https'
	    },
	    pretreat4: {
	      protocol: 'https',
	      host: {
	        INDY: 'ops-prod-indy.sp-lrps.com',
	        DALLAS: 'ops-prod-dallas.sp-lrps.com',
	        FRESNO: 'ops-prod-fresno.sp-lrps.com',
	        SCRANTON: 'ops-prod-scranton.sp-lrps.com'
	      }
	    }
	  })
	};
	
	module.exports = config[env] || {};
	
	module.exports.dockerConfig = config.docker;
	
	module.exports.env = env;


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(232);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _classnames = __webpack_require__(133);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scroll = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var POS_STYLE = {
	  top: { top: 0 },
	  bottom: { bottom: 0 },
	  left: { left: 0 },
	  right: { right: 0 }
	};
	
	var FLUID_STYE = {
	  top: { width: '100vw' },
	  bottom: { width: '100vw' },
	  left: { height: '100vh' },
	  right: { height: '100vh' }
	};
	
	var PageOverlay = function (_React$Component) {
	  _inherits(PageOverlay, _React$Component);
	
	  function PageOverlay() {
	    _classCallCheck(this, PageOverlay);
	
	    return _possibleConstructorReturn(this, (PageOverlay.__proto__ || Object.getPrototypeOf(PageOverlay)).apply(this, arguments));
	  }
	
	  _createClass(PageOverlay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(next) {
	      // Disable scroll and add padding in place of scrollbar
	      if (this.props.disableScrolling) {
	        if (this.props.active && !next.active) {
	          (0, _scroll.setBackgroundScrollable)(true, { fixed: this.props.lockScrolling });
	        }
	        if (!this.props.active && next.active && (0, _scroll.hasScrollBar)()) {
	          (0, _scroll.setBackgroundScrollable)(false, { fixed: this.props.lockScrolling });
	        }
	      }
	    }
	  }, {
	    key: 'animate',
	    value: function animate(node, open, cb) {
	      var duration = this.props.animationDuration;
	      var anchor = this.props.anchor;
	      var dimension = Object.keys(FLUID_STYE[anchor])[0] === 'width' ? 'height' : 'width';
	      var animateInterval = window.requestAnimationFrame || window.mozRequestAnimationFrame;
	      if (animateInterval && node.getBoundingClientRect && node.style) {
	        var _step = function _step(timestamp) {
	          if (!start) {
	            start = timestamp;
	            end = start + duration;
	          }
	          var progress = void 0;
	          if (timestamp < end) {
	            progress = (timestamp - start) / (end - start);
	          } else {
	            progress = 1;
	          }
	          var value = void 0;
	          if (open) {
	            value = min + (max - min) * progress;
	          } else {
	            value = max - (max - min) * progress;
	          }
	          node.style[anchor] = value + 'px';
	
	          if (timestamp < end) {
	            animateInterval(_step);
	          } else {
	            cb();
	          }
	        };
	
	        var min = -node.getBoundingClientRect()[dimension];
	        var max = parseInt(node.style[anchor]);
	        var start = void 0,
	            end = void 0;
	
	        animateInterval(_step);
	      } else {
	        cb();
	      }
	    }
	  }, {
	    key: 'animateOnOpen',
	    value: function animateOnOpen(node) {
	      this.animate(node, true, function (i) {
	        return i;
	      });
	    }
	  }, {
	    key: 'animateBeforeClose',
	    value: function animateBeforeClose(node, cb) {
	      this.animate(node, false, cb);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animated = POS_STYLE[this.props.anchor] && this.props.animationDuration > 0;
	      return _react2.default.createElement(
	        _reactPortal2.default,
	        {
	          onClose: this.props.active && this.props.onDeactivate || function (n) {
	            return n;
	          },
	          className: (0, _classnames2.default)('PageOverlay', this.props.className),
	          isOpened: this.props.active || false,
	          beforeClose: animated && this.animateBeforeClose.bind(this) || false,
	          onOpen: animated && this.animateOnOpen.bind(this) || function (n) {
	            return n;
	          },
	          style: Object.assign({ position: 'fixed', zIndex: this.props.zIndex || '99999' }, POS_STYLE[this.props.anchor], this.props.fluid && FLUID_STYE[this.props.anchor], this.props.style),
	          closeOnOutsideClick: this.props.closeOnOutsideClick
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PageOverlay;
	}(_react2.default.Component);
	
	exports.default = PageOverlay;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _Link = __webpack_require__(136);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _util = __webpack_require__(134);
	
	__webpack_require__(407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CUSTOMER_LOGOS = [__webpack_require__(559), __webpack_require__(562), __webpack_require__(558), __webpack_require__(560), __webpack_require__(565), __webpack_require__(561), __webpack_require__(564), __webpack_require__(563)];
	
	var Testimonials = function (_React$Component) {
	  _inherits(Testimonials, _React$Component);
	
	  function Testimonials() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Testimonials);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Testimonials.__proto__ || Object.getPrototypeOf(Testimonials)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      index: 0
	    }, _this.changeIndex = function (index) {
	      return function () {
	        if (index < 0) {
	          index = CUSTOMER_LOGOS.length - 1;
	        }
	        if (index >= CUSTOMER_LOGOS.length) {
	          index = 0;
	        }
	        _this.setState({ index: index });
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Testimonials, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Testimonials' },
	        _react2.default.createElement('div', { className: 'p-v-2' }),
	        _react2.default.createElement('div', { className: 'p-v-2 computer-only' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'ui container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'center-aligned m-b-2' },
	            'Over 10 million items printed'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'center-aligned' },
	            _react2.default.createElement(
	              'a',
	              { href: (0, _ooRoutes.url)('website', _ooRoutes.routes.website.auth.register), className: 'ui primary button' },
	              'REQUEST AN ACCOUNT'
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'p-v-2 computer-only' }),
	        _react2.default.createElement('div', { className: 'p-v-2 computer-only' }),
	        _react2.default.createElement('div', { className: 'p-v-2' })
	      );
	    }
	  }]);
	
	  return Testimonials;
	}(_react2.default.Component);
	
	Testimonials.propTypes = {};
	exports.default = Testimonials;

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(54);
	
	var _ooRoutes = __webpack_require__(24);
	
	__webpack_require__(408);
	
	var _logo = __webpack_require__(566);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _Testimonials = __webpack_require__(233);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer2 = function (_React$Component) {
	  _inherits(Footer2, _React$Component);
	
	  function Footer2() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Footer2);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Footer2.__proto__ || Object.getPrototypeOf(Footer2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Footer2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        { className: "Footer2" },
	        !this.props.hideTestimonials && _react2.default.createElement(_Testimonials2.default, { user: this.props.user }),
	        _react2.default.createElement(
	          "div",
	          { className: "ui container links" },
	          _react2.default.createElement(
	            "div",
	            { className: "top" },
	            _react2.default.createElement("div", { className: "p-v-2" }),
	            _react2.default.createElement("div", { className: "p-v-2 computer-only" }),
	            _react2.default.createElement(
	              "div",
	              { className: "ui grid" },
	              _react2.default.createElement(
	                "div",
	                { className: "three wide computer three wide tablet six wide mobile column" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "m-b-1" },
	                  "RESOURCES"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://scalablepress.com/catalog" },
	                    "Catalog"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "three wide computer three wide tablet six wide mobile column" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "m-b-1" },
	                  "DECORATION"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.screenprint) },
	                    "Screen printing"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.dtg) },
	                    "DTG printing"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.sublimation) },
	                    "Sublimation"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.poster) },
	                    "Poster printing"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.embroidery) },
	                    "Embroidery"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "three wide computer three wide tablet six wide mobile column" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "m-b-1" },
	                  "INTEGRATIONS"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website2.home.api) },
	                    "API"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    "a",
	                    { href: "https://scalablepress.com/catalog" },
	                    "Online ordering"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "three wide computer three wide tablet six wide mobile column" },
	                _react2.default.createElement(
	                  "h3",
	                  { className: "m-b-1" },
	                  "COMPANY"
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "m-b-0_5" },
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: (0, _ooRoutes.path)(_ooRoutes.routes.website2.home.careers.base) },
	                    "Careers"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("div", { className: "p-v-2 computer-only" }),
	            _react2.default.createElement("div", { className: "p-v-2" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "bottom p-v-1_5" },
	            _react2.default.createElement(
	              "div",
	              { className: "ui mobile vertically reversed grid" },
	              _react2.default.createElement(
	                "div",
	                { className: "six wide computer six wide tablet twelve wide mobile column center-aligned-m" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "copyright" },
	                  _react2.default.createElement("img", { src: _logo2.default, className: "m-r-0_5 d-ib" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "d-ib" },
	                    "\xA9 Scalable Press"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "six wide computer six wide tablet twelve wide mobile right aligned column column center-aligned-m" },
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.company.privacy),
	                    className: "computer-only tablet-only"
	                  },
	                  "Privacy"
	                ),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.company.terms),
	                    className: "m-l-1_5 computer-only tablet-only"
	                  },
	                  "Terms of use"
	                ),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "https://www.youtube.com/channel/UChgbj4qI33PmPJ_DNEqddSg",
	                    className: "m-l-1_5"
	                  },
	                  _react2.default.createElement("i", { className: "youtube icon" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://twitter.com/scalablepress", className: "m-l-1_5" },
	                  _react2.default.createElement("i", { className: "twitter icon" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "https://www.instagram.com/scalablepress/",
	                    className: "m-l-1_5"
	                  },
	                  _react2.default.createElement("i", { className: "instagram icon" })
	                ),
	                _react2.default.createElement(
	                  "a",
	                  {
	                    href: "https://www.linkedin.com/company/4864727/",
	                    className: "m-l-1_5"
	                  },
	                  _react2.default.createElement("i", { className: "linkedin icon" })
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "mobile-only m-t-1_5" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.company.privacy),
	                      className: "m-r-1_5"
	                    },
	                    "Privacy"
	                  ),
	                  _react2.default.createElement(
	                    "a",
	                    { href: (0, _ooRoutes.url)("website", _ooRoutes.routes.website.company.terms) },
	                    "Terms of use"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer2;
	}(_react2.default.Component);
	
	Footer2.propTypes = {};
	exports.default = Footer2;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _NavBar = __webpack_require__(91);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	__webpack_require__(409);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CareersHero = function (_React$Component) {
	  _inherits(CareersHero, _React$Component);
	
	  function CareersHero() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CareersHero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CareersHero.__proto__ || Object.getPrototypeOf(CareersHero)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CareersHero, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'CareersHero' },
	        _react2.default.createElement(
	          'div',
	          { className: 'center-content center-aligned-m' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(
	              'h5',
	              { className: 'm-t-0 m-b-1' },
	              'JOIN SCALABLE PRESS'
	            ),
	            _react2.default.createElement('div', { className: 'primary-bg-color accent-bar m-b-1 m-b-2_5-m d-ib' }),
	            _react2.default.createElement(
	              'h1',
	              { className: 'm-a-0 m-b-2' },
	              'WE\'RE 1% OF THE WAY THERE.'
	            ),
	            _react2.default.createElement('div', { className: 'p-b-0_5' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'm-t-0 m-b-2 fs-2 sub-header' },
	              'At Scalable Press, we build forward-thinking technology to reinvent the mass customization industry. Long term, our goal is to make ordering customized products as simple and inexpensive as ordering normal products.'
	            ),
	            _react2.default.createElement('div', { className: 'p-b-0_5' }),
	            _react2.default.createElement(
	              'a',
	              { href: '#open-positions' },
	              _react2.default.createElement(
	                'div',
	                { className: 'ui primary button' },
	                'VIEW OPEN POSITIONS'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CareersHero;
	}(_react2.default.Component);
	
	CareersHero.propTypes = {};
	exports.default = CareersHero;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(46);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _Link = __webpack_require__(136);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _NavBar = __webpack_require__(91);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	__webpack_require__(410);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomePageHero = function (_React$Component) {
	  _inherits(HomePageHero, _React$Component);
	
	  function HomePageHero() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomePageHero);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HomePageHero.__proto__ || Object.getPrototypeOf(HomePageHero)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(HomePageHero, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'HomePageHero' },
	        _react2.default.createElement(
	          'div',
	          { className: 'image-background' },
	          _react2.default.createElement(
	            'div',
	            { className: 'center-content center-aligned' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'm-b-1' },
	              'FAST, AFFORDABLE',
	              _react2.default.createElement('br', null),
	              'PRINT-ON-DEMAND FULFILLMENT'
	            ),
	            _react2.default.createElement('div', { className: 'p-b-0_5' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'center-aligned m-t-0 m-b-2 fs-2 sub-header' },
	              'Scalable Press lets you order 1000s of print-on-demand products from different suppliers through a single-invoice ordering platform'
	            ),
	            _react2.default.createElement('div', { className: 'p-b-0_5' }),
	            _react2.default.createElement(
	              'a',
	              { href: (0, _ooRoutes.url)('website', _ooRoutes.routes.website.auth.register), className: 'ui primary button levitated' },
	              'REQUEST AN ACCOUNT'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'facilities center-aligned secondary-text-color computer-only' },
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'divider m-b-0_5' },
	                _react2.default.createElement(
	                  'i',
	                  null,
	                  '10+ SUPPLIERS DISTRIBUTED GLOBALLY'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'cities fw-700' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Los Angeles, CA'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Dallas, TX'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Toronto, ON'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Exeter, UK'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Prague, CZ'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Zhejiang, CN'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'city' },
	                  'Melbourne, AU'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fulfillment center-aligned mobile-only tablet-only p-v-1' },
	          _react2.default.createElement(
	            'h5',
	            { className: 'm-b-0_5' },
	            'WE ARE NATIONAL AND WE SHIP FAST'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            '5 fulfillment facilities across US'
	          )
	        )
	      );
	    }
	  }]);
	
	  return HomePageHero;
	}(_react2.default.Component);
	
	HomePageHero.propTypes = {};
	exports.default = HomePageHero;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(135);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _NavBar = __webpack_require__(91);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _Footer = __webpack_require__(234);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var menuItems = [{
	  name: 'Product Catalog',
	  url: (0, _ooRoutes.url)('website', _ooRoutes.routes.website.catalog.base)
	}, {
	  name: 'API',
	  url: (0, _ooRoutes.url)('website', _ooRoutes.routes.website2.home.api)
	}, {
	  name: 'Login',
	  url: (0, _ooRoutes.url)('website', _ooRoutes.routes.website.auth.login)
	}];
	
	var loggedInMenuItems = [{
	  name: 'Designs',
	  url: (0, _ooRoutes.url)('manager', _ooRoutes.routes.manager.design.base)
	}, {
	  name: 'Orders',
	  url: (0, _ooRoutes.url)('manager', _ooRoutes.routes.manager.order.base)
	}, {
	  name: 'Billing',
	  url: (0, _ooRoutes.url)('manager', _ooRoutes.routes.manager.billing.base)
	}, {
	  name: 'Place Order',
	  url: (0, _ooRoutes.url)('order2', _ooRoutes.routes.order2.cart.base)
	}, {
	  name: 'Settings',
	  url: (0, _ooRoutes.url)('manager', _ooRoutes.routes.manager.settings.base)
	}];
	
	var Layout = function (_React$Component) {
	  _inherits(Layout, _React$Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
	  }
	
	  _createClass(Layout, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'Layout' },
	        _react2.default.createElement(_NavBar2.default, {
	          user: this.props.user,
	          landing: this.props.location.pathname === _ooRoutes.routes.website2.home.base,
	          careers: this.props.location.pathname === _ooRoutes.routes.website2.home.careers.base || this.props.location.pathname === _ooRoutes.routes.website2.home.jobs
	        }),
	        this.props.children,
	        _react2.default.createElement(_Footer2.default, {
	          hideTestimonials: this.props.location.pathname === _ooRoutes.routes.website2.home.careers.base || this.props.location.pathname === _ooRoutes.routes.website2.home.jobs,
	          user: this.props.user
	        })
	      );
	    }
	  }]);
	
	  return Layout;
	}(_react2.default.Component);
	
	function select(state) {
	  return {
	    user: state.auth.user
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(select)(Layout);

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createRoutes;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(54);
	
	var _public = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	  require.ensure = function (modules, cb) {
	    cb(require);
	  };
	}
	
	function createRoutes(store) {
	  var pages = {
	    HomePage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(575).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(1, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    ScreenprintPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(580).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(8, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    DTGPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(574).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(13, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    SublimationPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(582).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(10, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    PosterPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(577).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(12, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    ApiPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(571).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(3, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    WooCommercePage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(583).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(9, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    ShopifyPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(581).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(11, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    PricingPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(578).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(5, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    CareersPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(572).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(4, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    CatalogPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(573).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(2, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    RegisterPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(579).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(6, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    },
	    LoginPage: {
	      getComponent: function getComponent(nextState, cb) {
	        (function(/* nsure */) {var __WEBPACK_REMAINING_CHUNKS__ = 2;var __WEBPACK_CALLBACK__ = function() {if(--__WEBPACK_REMAINING_CHUNKS__ < 1) (function (require) {
	          cb(null, __webpack_require__(576).default);
	        }(__webpack_require__));}.bind(this);__webpack_require__.e(0, __WEBPACK_CALLBACK__);__webpack_require__.e(7, __WEBPACK_CALLBACK__);}).call(this);
	      }
	    }
	  };
	
	  function route(page, path) {
	    var props = {
	      path: path,
	      getComponent: page.getComponent
	    };
	
	    if (path) {
	      return _react2.default.createElement(_reactRouter.Route, props);
	    }
	    return _react2.default.createElement(_reactRouter.IndexRoute, props);
	  }
	
	  return _react2.default.createElement(
	    _reactRouter.Route,
	    {
	      path: _public.routes.website2.home.base,
	      component: __webpack_require__(237).default
	    },
	    route(pages.HomePage),
	    route(pages.PricingPage, _public.routes.website2.home.pricing),
	    route(pages.CareersPage, _public.routes.website2.home.careers.base),
	    route(pages.CareersPage, _public.routes.website2.home.jobs),
	    route(pages.CatalogPage, _public.routes.website2.home.catalog),
	    route(pages.RegisterPage, _public.routes.website2.home.auth.register),
	    route(pages.LoginPage, _public.routes.website2.home.auth.login)
	  );
	}

/***/ }),

/***/ 239:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = auth;
	function auth() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return state;
	}

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(130);
	
	var _reactRouterRedux = __webpack_require__(141);
	
	var _vias = __webpack_require__(55);
	
	var _auth = __webpack_require__(239);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	  routing: _reactRouterRedux.routerReducer,
	  auth: _auth2.default,
	  vias: _vias.viasReducer
	});

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAppStore;
	
	var _reactRouterRedux = __webpack_require__(141);
	
	var _redux = __webpack_require__(130);
	
	var _vias = __webpack_require__(55);
	
	var _reduxRavenMiddleware = __webpack_require__(540);
	
	var _reduxRavenMiddleware2 = _interopRequireDefault(_reduxRavenMiddleware);
	
	var _ooConfig = __webpack_require__(140);
	
	var _ooConfig2 = _interopRequireDefault(_ooConfig);
	
	var _reducers = __webpack_require__(240);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _models = __webpack_require__(245);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAppStore(history) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var browserWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var middlewares = [(0, _reactRouterRedux.routerMiddleware)(history)];
	  if (_ooConfig2.default.env !== 'development') {
	    middlewares.push((0, _reduxRavenMiddleware2.default)(_ooConfig2.default.raven.dns));
	  }
	  var mainMiddlewares = _redux.applyMiddleware.apply(undefined, middlewares);
	
	  var finalCreateStore = (0, _redux.compose)(mainMiddlewares, browserWindow.devToolsExtension ? browserWindow.devToolsExtension() : function (noop) {
	    return noop;
	  })(_redux.createStore);
	
	  var store = finalCreateStore(_reducers2.default, initialState);
	
	  (0, _vias.viasConnect)(store, _models.Product);
	  (0, _reactRouterRedux.syncHistoryWithStore)(history, store);
	
	  return store;
	}

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vias = __webpack_require__(55);
	
	var _http = __webpack_require__(66);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _ooRoutes = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vias.Model('MockupTemplate', {
	  id: '_id'
	}, {
	  get: function get(alias, key, options, cb) {
	    _http2.default.get((0, _ooRoutes.url)('query', _ooRoutes.routes.query.mockupTemplate.base, { mockupTemplateId: key }), cb);
	  }
	}, {
	  searchByIdentifier: {
	    shape: _vias.DOCUMENT_SHAPE,
	    action: function action(data, options, cb) {
	      _http2.default.get((0, _ooRoutes.url)('query', _ooRoutes.routes.query.mockupTemplate.byIdentifier, { identifier: data }), cb);
	    }
	  }
	});

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vias = __webpack_require__(55);
	
	var _http = __webpack_require__(66);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _ooRoutes = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vias.Model('Pricing', {
	  id: '_id'
	}, {
	  get: function get(alias, key, options, cb) {
	    _http2.default.get((0, _ooRoutes.url)('query', _ooRoutes.routes.query.data.pricing.detail, { pricingId: key }), cb);
	  }
	}, {
	  searchByName: {
	    shape: _vias.DOCUMENT_SHAPE,
	    action: function action(data, options, cb) {
	      _http2.default.get((0, _ooRoutes.url)('query', _ooRoutes.routes.query.data.pricing.detail, { identifier: data }), cb);
	    }
	  },
	  getAll: {
	    shape: _vias.ARRAY_SHAPE,
	    action: function action(data, options, cb) {
	      _http2.default.get((0, _ooRoutes.url)('query', _ooRoutes.routes.query.data.pricing.base), cb);
	    }
	  }
	});

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vias = __webpack_require__(55);
	
	var _lodash = __webpack_require__(17);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _http = __webpack_require__(66);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _ooRoutes = __webpack_require__(24);
	
	var _util = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vias.Model('Product', {
	  id: '_id'
	}, {
	  get: function get(alias, key, options, cb) {
	    _http2.default.get((0, _ooRoutes.url)('print', _ooRoutes.routes.print.products.detail, { identifier: key }), (0, _util.restResponseCb)(cb));
	  }
	}, {
	  search: {
	    shape: _vias.ARRAY_SHAPE,
	    action: function action(query, options, cb) {
	      _http2.default.get((0, _ooRoutes.url)('print', _ooRoutes.routes.print.v3.products.search, query), (0, _util.restResponseCb)(cb));
	    }
	  }
	});

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Product = __webpack_require__(244);
	
	Object.defineProperty(exports, 'Product', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Product).default;
	  }
	});
	
	var _MockupTemplate = __webpack_require__(242);
	
	Object.defineProperty(exports, 'MockupTemplate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_MockupTemplate).default;
	  }
	});
	
	var _Pricing = __webpack_require__(243);
	
	Object.defineProperty(exports, 'Pricing', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pricing).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	var AOS_DESIGN_TYPES, CARRIER, DEBIT_TYPE, DESIGN_TYPES, EVENT_STATUS, ITEM_STATUS, LITTLERAYMONDS_FULFILLMENT_INDY, ORDER_STATUS, PRINTERS, SERVICES, SERVICE_TO_CODE, SHIPPING_ESTIMATES, SHIPPING_RANGES, STANDARD_RANGE, THIRD_PARTY_FACILITY_ARTSADD, THIRD_PARTY_FACILITY_CG, THIRD_PARTY_FACILITY_DTG2GO, THIRD_PARTY_FACILITY_DTGCSVPARTNERS, THIRD_PARTY_FACILITY_DUBOW, THIRD_PARTY_FACILITY_EPI, THIRD_PARTY_FACILITY_LASUB, THIRD_PARTY_FACILITY_MWW, THIRD_PARTY_FACILITY_SAP, THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS, THIRD_PARTY_FACILITY_STAKES, THIRD_PARTY_FACILITY_TECTONICS, THIRD_PARTY_FACILITY_TECTONICS_API, THIRD_PARTY_FACILITY_YL, THIRD_PARTY_FACILITY_YOUNGSINC, _, _exts, alias, ext, i, int, j, k, ref, results, results1, results2;
	
	_ = __webpack_require__(17);
	
	THIRD_PARTY_FACILITY_MWW = 'MWW';
	
	THIRD_PARTY_FACILITY_ARTSADD = 'ARTSADD';
	
	THIRD_PARTY_FACILITY_DTG2GO = 'DTG2GO';
	
	THIRD_PARTY_FACILITY_LASUB = 'LASUB';
	
	THIRD_PARTY_FACILITY_STAKES = 'STAKES';
	
	THIRD_PARTY_FACILITY_TECTONICS = 'TECTONICS';
	
	THIRD_PARTY_FACILITY_YL = 'YL';
	
	THIRD_PARTY_FACILITY_CG = 'CG';
	
	THIRD_PARTY_FACILITY_DTGCSVPARTNERS = 'DTGCSVPARTNERS';
	
	THIRD_PARTY_FACILITY_SAP = 'SAP';
	
	THIRD_PARTY_FACILITY_EPI = 'EPI';
	
	THIRD_PARTY_FACILITY_TECTONICS_API = 'TECTONICS_API';
	
	THIRD_PARTY_FACILITY_DUBOW = 'DUBOW';
	
	LITTLERAYMONDS_FULFILLMENT_INDY = 'LITTLERAYMONDS_FULFILLMENT_INDY';
	
	THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS = 'SCREENPRINTPARTNERS';
	
	THIRD_PARTY_FACILITY_YOUNGSINC = 'YOUNGSINC';
	
	exports.MAX_CREDIT_LINE = 100000;
	
	exports.DEFAULT_ECOMMERCE_QUOTE_QUANTITY = 25;
	
	exports.BABY_GARMENT_SIZES = ['3m', '6m', '9m', '12m', '18m', '24m'];
	
	exports.GARMENT_SIZES = ["one", "xxsml", "xsml", "sml", "med", "lrg", "xlg", "xxl", "xxxl", "xxxxl", "xxxxxl", "xxxxxxl"].concat(exports.BABY_GARMENT_SIZES);
	
	exports.MUG_SIZES = ["11oz", "15oz"];
	
	exports.ALL_SIZES = exports.GARMENT_SIZES.concat(exports.MUG_SIZES);
	
	exports.SIZE_MAP = {
	  one: "Custom",
	  xxsml: "2XS",
	  xsml: "XSM",
	  sml: "SML",
	  med: "MED",
	  lrg: "LRG",
	  xlg: "XLG",
	  xxl: "2XL",
	  xxxl: "3XL",
	  xxxxl: "4XL",
	  xxxxxl: "5XL",
	  xxxxxxl: "6XL"
	};
	
	exports.DISPLAY_SIZE_MAP = {
	  one: "Custom",
	  xxsml: "2XS",
	  xsml: "XS",
	  sml: "S",
	  med: "M",
	  lrg: "L",
	  xlg: "XL",
	  xxl: "2XL",
	  xxxl: "3XL",
	  xxxxl: "4XL",
	  xxxxxl: "5XL",
	  xxxxxxl: "6XL"
	};
	
	exports.INFANT_SIZES = {
	  'xsml': 'NB',
	  'sml': '6M',
	  'med': '12M',
	  'lrg': '18M',
	  'xlg': '24M'
	};
	
	exports.TODDLER_SIZES = {
	  'xsml': '2T',
	  'sml': '3T',
	  'med': '4T',
	  'lrg': '5T',
	  'xlg': '6T',
	  'xxl': '7T'
	};
	
	exports.GARMENT_ACCESSORY_SIZES = {
	  'med': 'OS'
	};
	
	exports.DESIGN_TYPE_MAP = {
	  'dtg': 'Garment',
	  'screenprint': 'Garment',
	  'embr': 'Garment',
	  'mug': 'Mug',
	  'case': 'Case',
	  'poster': 'Poster',
	  'socks-short': 'Garment',
	  'socks-medium': 'Garment',
	  'socks-long': 'Garment',
	  'tube-scraf': 'Garment',
	  'tie': 'Garment',
	  'tote': 'Garment',
	  'magnet': 'Magnet',
	  'coaster': 'Coaster',
	  'pillow-large': 'Pillow',
	  'pillow-small': 'Pillow',
	  'beach-towel': 'Towel',
	  'small-towel': 'Towel',
	  'mousepad': 'Mousepad',
	  'bracelet-a': 'Jewelry',
	  'bracelet-b': 'Jewelry',
	  'necklace-a': 'Jewelry',
	  'necklace-b': 'Jewelry',
	  'necklace-c': 'Jewelry',
	  'necklace-d': 'Jewelry',
	  'earrings-a': 'Jewelry',
	  'earrings-b': 'Jewelry',
	  'sublimated-men-crew': 'Garment',
	  'sublimated-tank': 'Garment'
	};
	
	exports.AOS_PRODUCT_CATEGORIES = ['coaster', 'cutting-board', 'necklace', 'bracelet', 'earring', 'magnet', 'metal-print', 'mousepad', 'pillowcase', 'sock', 'sandal', 'scarf', 'tie', 'towel'];
	
	exports.ECOMMERCE = ['shopify', 'wooCommerce'];
	
	exports.SUPPORTED_WOO_VER = ['2.2.x', '2.3.x', '2.4.x', '2.5.x'];
	
	exports.FACILITIES = ['FRESNO', 'SCRANTON', 'INDY', 'DALLAS', 'FREMONT', THIRD_PARTY_FACILITY_MWW, THIRD_PARTY_FACILITY_ARTSADD, THIRD_PARTY_FACILITY_CG, THIRD_PARTY_FACILITY_DTG2GO, THIRD_PARTY_FACILITY_LASUB, THIRD_PARTY_FACILITY_SAP, THIRD_PARTY_FACILITY_STAKES, THIRD_PARTY_FACILITY_TECTONICS, THIRD_PARTY_FACILITY_YL, THIRD_PARTY_FACILITY_DTGCSVPARTNERS, THIRD_PARTY_FACILITY_EPI, THIRD_PARTY_FACILITY_DUBOW, LITTLERAYMONDS_FULFILLMENT_INDY, THIRD_PARTY_FACILITY_TECTONICS_API, THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS, THIRD_PARTY_FACILITY_YOUNGSINC];
	
	exports.ROLES = {
	  NONE: -1,
	  USER: 0,
	  EMPLOYEE: 1,
	  MANAGE: 6,
	  ADMIN: 11
	};
	
	exports.GROUP = {
	  'ADMIN': 1,
	  'PRODUCTION': 1,
	  'SALES': 1,
	  'CS': 1
	};
	
	exports.FACILITY_SHORT_CODES = {
	  INDY: "IN",
	  FREMONT: "FR",
	  SCRANTON: "PA",
	  FRESNO: "CA",
	  DALLAS: "TX",
	  FR: "FREMONT",
	  IN: "INDY",
	  PA: "SCRANTON",
	  CA: "FRESNO",
	  TX: "DALLAS",
	  MWW: THIRD_PARTY_FACILITY_MWW,
	  ARTSADD: THIRD_PARTY_FACILITY_ARTSADD,
	  CG: THIRD_PARTY_FACILITY_CG,
	  DTG2GO: THIRD_PARTY_FACILITY_DTG2GO,
	  YL: THIRD_PARTY_FACILITY_YL,
	  STAKES: THIRD_PARTY_FACILITY_STAKES,
	  TECTONICS: THIRD_PARTY_FACILITY_TECTONICS,
	  LASUB: THIRD_PARTY_FACILITY_LASUB,
	  DTGCSVPARTNERS: THIRD_PARTY_FACILITY_DTGCSVPARTNERS,
	  SAP: THIRD_PARTY_FACILITY_SAP,
	  EPI: THIRD_PARTY_FACILITY_EPI,
	  DUBOW: THIRD_PARTY_FACILITY_DUBOW,
	  LITTLERAYMONDSINDY: LITTLERAYMONDS_FULFILLMENT_INDY,
	  TECTONICS_API: THIRD_PARTY_FACILITY_TECTONICS_API,
	  SCREENPRINTPARTNERS: THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS,
	  YOUNGSINC: THIRD_PARTY_FACILITY_YOUNGSINC
	};
	
	exports.COMPANIES = ['fuel-pod', 'inkpop', 'scalable-press', 'teechip', 'plutocase', 'sl-wholesale', 'sl-retail', 'fanmall', 'photos'];
	
	exports.PRINT_LOCATION = ['center', 'center-left', 'center-right', 'left-pocket', 'right-pocket', 'bottom', 'bottom-left', 'bottom-right', 'top-left', 'top-right'];
	
	exports.PRINTER_PROBLEMS = ['missing garment', 'flawed garments', 'wrong artwork used', 'missing print', 'ink colors', 'print detail loss', 'print placement', 'print size', 'print quality', 'stains', 'curing issue', 'personalization', 'packing issue', 'wrong address', 'late delivery'];
	
	exports.CLAIM_REASONS = ['order not delivered', 'late delivery', 'missing items', 'wrong items', 'misprinted/flawed items', 'other'];
	
	exports.TAG_EXCLUSIONS = {
	  'polyester': 'dtg',
	  'dtg-banned': 'dtg',
	  'screenprint-banned': 'screenprint'
	};
	
	exports.TAG_WARNINGS = {
	  'dtg-warn': 'dtg'
	};
	
	exports.UPDATER_SERVICES = ['oo-printer', 'sp-ping', 'oo-webcam', 'oo-pretreat', 'oo-pretreat2', 'oo-dtg/rip', 'oo-dtg/upload', 'oo-artwork/consume', 'oo-fingerprint', 'sp-embr-server'];
	
	exports.INTERNAL_PROBLEMS = [
	  {
	    problem: 'incorrect information given to customer',
	    division: 'customer service'
	  }, {
	    problem: 'incorrect charge or refund',
	    division: 'customer service'
	  }, {
	    problem: 'incorrect preview image update',
	    division: 'customer service'
	  }, {
	    problem: 'incorrect holds issue resolution',
	    division: 'customer service'
	  }, {
	    problem: 'incorrect internal notes',
	    division: 'customer service'
	  }, {
	    problem: 'incorrect delivery data adjustment',
	    division: 'customer service'
	  }, {
	    problem: 'forgot to take order off hold',
	    division: 'customer service'
	  }, {
	    problem: 'forgot charge or refund',
	    division: 'customer service'
	  }, {
	    problem: 'forgot preview image update',
	    division: 'customer service'
	  }, {
	    problem: 'forgot holds issue resolution',
	    division: 'customer service'
	  }, {
	    problem: 'forgot internal notes',
	    division: 'customer service'
	  }, {
	    problem: 'forgot delivery date adjustment',
	    division: 'customer service'
	  }, {
	    problem: 'cancellation without approval',
	    division: 'customer service'
	  }, {
	    problem: 'mishandled customer interaction',
	    division: 'customer service'
	  }, {
	    problem: 'other',
	    division: 'customer service'
	  }, {
	    problem: 'incorrect holds assignment',
	    division: 'approve order'
	  }, {
	    problem: 'incorrect printer assignment',
	    division: 'approve order'
	  }, {
	    problem: 'incorrect dimensions/placement',
	    division: 'approve order'
	  }, {
	    problem: 'other',
	    division: 'approve order'
	  }, {
	    problem: 'incorrect text',
	    division: 'approve artwork'
	  }, {
	    problem: 'incorrect colors',
	    division: 'approve artwork'
	  }, {
	    problem: 'incorrect images',
	    division: 'approve artwork'
	  }, {
	    problem: 'other',
	    division: 'approve artwork'
	  }
	];
	
	exports.SEVERITY = ['minor', 'medium', 'significant', 'devastating'];
	
	exports.BLANK_SUPPLIERS = ['ALPHA', 'BODEK', 'CUTTER', 'HERITAGE', 'SANMAR', 'SS', 'TSC', 'INVENTORY', 'SUPPLEMENTARY', 'EXTRACTOR', 'DROPOFF'];
	
	exports.ACTIVE_BLANK_SUPPLIERS = ['ALPHA', 'SANMAR', 'SS'];
	
	exports.TRUCK_LINES = {
	  DALLAS: [
	    {
	      supplier: 'ALPHA',
	      warehouse: 'TD'
	    }, {
	      supplier: 'SS',
	      warehouse: 'TX'
	    }
	  ],
	  INDY: [
	    {
	      supplier: 'ALPHA',
	      warehouse: 'CC'
	    }, {
	      supplier: 'SS',
	      warehouse: 'IL'
	    }
	  ],
	  SCREENPRINTPARTNERS: [],
	  FREMONT: [],
	  SCRANTON: [],
	  FRESNO: []
	};
	
	exports.PRINTER_ZIP = {
	  'FRESNO': '93725',
	  'FREMONT': '94538',
	  'INDY': '46226',
	  'SCRANTON': '18507',
	  'DALLAS': '75019',
	  'LITTLERAYMONDS_FULFILLMENT_INDY': '46226'
	};
	
	exports.FACILITY_FULL_NAME = {
	  INDY: "Indianapolis, IN",
	  FREMONT: "Fremont, CA",
	  SCRANTON: "Scranton, PA",
	  FRESNO: "Fresno, CA",
	  DALLAS: "Dallas, TX"
	};
	
	exports.TIMEZONES = {
	  INDY: 'America/Indiana/Indianapolis',
	  FREMONT: 'America/Los_Angeles',
	  FRESNO: 'America/Los_Angeles',
	  SCRANTON: 'America/New_York',
	  DALLAS: 'America/Chicago'
	};
	
	exports.INVENTORY_CHECKPOINTS = {
	  ORDER_CREATED: "order created",
	  ORDERPART_CREATED: "order part created",
	  STOCK_UPDATE: "stock update",
	  ORDER_ACCEPTED: "order accepted"
	};
	
	exports.ROUTER_GROUPING_PREFERENCES = ['cheapest', 'fastest'];
	
	exports.PRINT_SIDES = ['front', 'back', 'right', 'left', 'sleeve-left', 'sleeve-right', 'hat-left', 'hat-right', 'outside-left', 'outside-right', 'inside-left', 'inside-right'];
	
	exports.EMBR_SIDES = ['front', 'front-left', 'front-right', 'back', 'right', 'left'];
	
	exports.GARMENT_ARTWORK_SIZES = {
	  front: {
	    'standard': {
	      width: 14,
	      height: 16
	    },
	    'small': {
	      width: 10,
	      height: 12
	    },
	    'pocket': {
	      width: 10,
	      height: 10
	    },
	    'youth-pocket': {
	      width: 10,
	      height: 6
	    }
	  },
	  back: {
	    'standard': {
	      width: 14,
	      height: 16
	    },
	    'small': {
	      width: 10,
	      height: 12
	    },
	    'pocket': {
	      width: 14,
	      height: 16
	    },
	    'youth-pocket': {
	      width: 10,
	      height: 12
	    }
	  },
	  left: {
	    'standard': {
	      width: 4,
	      height: 4
	    }
	  },
	  right: {
	    'standard': {
	      width: 4,
	      height: 4
	    }
	  }
	};
	
	exports.PRINT_TYPES = {
	  Screenprint: "Screenprint",
	  DTG_Print: "DTG Print",
	  CASE: "Case",
	  MUG: "Mug",
	  POSTER: "Poster"
	};
	
	AOS_DESIGN_TYPES = ['socks-short', 'socks-medium', 'socks-long', 'tube-scarf', 'tie', 'tote', 'magnet', 'coaster', 'pillow-large', 'pillow-small', 'beach-towel', 'small-towel', 'mousepad', 'bracelet-a', 'bracelet-b', 'necklace-a', 'necklace-b', 'necklace-c', 'necklace-d', 'earrings-a', 'earrings-b'];
	
	DESIGN_TYPES = ['screenprint', 'dtg', 'case', 'mug', 'poster', 'embr'].concat(AOS_DESIGN_TYPES);
	
	exports.AOS_DESIGN_TYPES = AOS_DESIGN_TYPES;
	
	exports.DESIGN_TYPES = DESIGN_TYPES;
	
	exports.PRODUCT_TYPES = ['Garment', 'Case', 'Mug', 'Poster', 'Jewelry', 'Housewares', 'Accessories', 'Footwear', 'ThirdParty'];
	
	exports.PRODUCT_PRINT_TYPES = ['screenprint', 'dtg', 'sublimation', 'poster', 'embr'];
	
	exports.PRODUCT_TYPE_TO_DESIGN_TYPE = {
	  Garment: ['screenprint', 'dtg', 'embr'],
	  Case: ['case'],
	  Mug: ['mug'],
	  Poster: ['poster']
	};
	
	exports.CARRIER = CARRIER = {
	  UPS: 'UPS',
	  USPS: 'USPS',
	  FEDEX: 'FEDEX',
	  DHL: 'DHLGM'
	};
	
	exports.SHIPPING_ESTIMATES = SHIPPING_ESTIMATES = {
	  '01': '(1 day)',
	  '13': '(1 day)',
	  '02': '(2 days)',
	  '12': '(3 days)',
	  '03': '(1-5 days)',
	  '3313': '(3-8 days)',
	  '3316': '(3-8 days)',
	  'US-PMI': '(6-10 days)',
	  'US-FCI': '(7-21 days)',
	  'US-XM': '(2 days)',
	  'US-PM': '(1-3 days)',
	  'US-PS': '(2-8 days)',
	  'US-FC': '(1-5 days) [13 oz max.]',
	  'standard': '(3-8 days)',
	  'WILLCALL': 'willcall n/a'
	};
	
	exports.STANDARD_RANGE = STANDARD_RANGE = [3, 8];
	
	exports.SHIPPING_RANGES = SHIPPING_RANGES = {
	  '01': [1],
	  '13': [1],
	  '02': [2],
	  '12': [3],
	  '03': [1, 5],
	  '3313': STANDARD_RANGE,
	  '3316': STANDARD_RANGE,
	  'US-PMI': [6, 10],
	  'US-FCI': [7, 21],
	  'US-XM': [2],
	  'US-PM': [1, 3],
	  'US-PS': [2, 8],
	  'US-FC': [1, 5]
	};
	
	exports.SERVICE_TO_CODE = SERVICE_TO_CODE = {
	  "UPS-GND": '03',
	  "UPS-1DA": '01',
	  "UPS-3DS": '12',
	  "UPS-2DA": '02',
	  "WILLCALL": 'WILLCALL'
	};
	
	exports.SERVICES = SERVICES = {
	  'standard': {
	    description: 'Standard Shipping'
	  },
	  '01': {
	    description: 'UPS Next Day Air',
	    carrier: CARRIER.UPS
	  },
	  '02': {
	    description: 'UPS 2-Day Air',
	    carrier: CARRIER.UPS
	  },
	  '03': {
	    description: 'UPS Ground',
	    carrier: CARRIER.UPS
	  },
	  '07': {
	    description: 'UPS Worldwide Express',
	    carrier: CARRIER.UPS
	  },
	  '08': {
	    description: 'UPS Worldwide Express Expedited',
	    carrier: CARRIER.UPS
	  },
	  '11': {
	    description: 'UPS Standard',
	    carrier: CARRIER.UPS
	  },
	  '12': {
	    description: 'UPS 3-Day Select',
	    carrier: CARRIER.UPS
	  },
	  '13': {
	    description: 'UPS Next Day Air Saver',
	    carrier: CARRIER.UPS
	  },
	  '14': {
	    description: 'UPS Next Day Air AM',
	    carrier: CARRIER.UPS
	  },
	  '54': {
	    description: 'UPS Worldwide Express Plus',
	    carrier: CARRIER.UPS
	  },
	  '59': {
	    description: 'UPS 2-Day Air AM',
	    carrier: CARRIER.UPS
	  },
	  '65': {
	    description: 'UPS Saver',
	    carrier: CARRIER.UPS
	  },
	  '92': {
	    description: 'UPS SurePost < 1LB',
	    carrier: CARRIER.UPS
	  },
	  '93': {
	    description: 'UPS SurePost > 1LB',
	    carrier: CARRIER.UPS
	  },
	  'US-FC': {
	    description: "USPS First Class",
	    carrier: CARRIER.USPS
	  },
	  'US-PP': {
	    description: "USPS Parcel Post",
	    carrier: CARRIER.USPS
	  },
	  'US-PM': {
	    description: "USPS Priority Mail",
	    carrier: CARRIER.USPS
	  },
	  'US-PS': {
	    description: "USPS Parcel Select",
	    carrier: CARRIER.USPS
	  },
	  'US-XM': {
	    description: "USPS Express Mail",
	    carrier: CARRIER.USPS
	  },
	  'US-EMI': {
	    description: "USPS Express Mail International",
	    carrier: CARRIER.USPS
	  },
	  'US-PMI': {
	    description: "USPS Priority Mail International",
	    carrier: CARRIER.USPS
	  },
	  'US-FCI': {
	    description: "USPS First Class International",
	    carrier: CARRIER.USPS
	  },
	  '3313': {
	    description: 'DHL Smartmail Parcel Expedited',
	    carrier: CARRIER.DHL,
	    max: 1,
	    whitelist: ['US']
	  },
	  '3314': {
	    description: 'DHL Smartmail Parcel',
	    carrier: CARRIER.DHL,
	    max: 1,
	    whitelist: ['US']
	  },
	  '3315': {
	    description: 'DHL Smartmail Parcel Plus',
	    carrier: CARRIER.DHL,
	    min: 1,
	    whitelist: ['US']
	  },
	  '3316': {
	    description: 'DHL Smartmail Parcel Plus Expedited',
	    carrier: CARRIER.DHL,
	    min: 1,
	    whitelist: ['US']
	  },
	  '3359': {
	    description: 'DHL GM Packet Plus',
	    carrier: CARRIER.DHL,
	    blacklist: ['US']
	  },
	  '3360': {
	    description: 'DHL GM Packet Plus Large',
	    carrier: CARRIER.DHL,
	    blacklist: ['US']
	  },
	  '3363': {
	    description: 'DHL GM Packet Priority',
	    carrier: CARRIER.DHL,
	    blacklist: ['US']
	  },
	  '3365': {
	    description: 'DHL GM Parcel Priority',
	    carrier: CARRIER.DHL,
	    blacklist: ['US']
	  },
	  'FDX-FO': {
	    description: 'FedEx First Overnight',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'FDX-PO': {
	    description: 'FedEx Priority Overnight',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'FDX-SO': {
	    description: 'FedEx Standard Overnight',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'FDX-2DA': {
	    description: 'FedEx 2-Day AM',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'FDX-2D': {
	    description: 'FedEx 2-Day',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'FDX-ES': {
	    description: 'FedEx Express Saver',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'FDX-GND': {
	    description: 'FedEx Ground',
	    carrier: CARRIER.FEDEX,
	    whitelist: ['US']
	  },
	  'WILLCALL': {
	    description: 'Custom Willcall',
	    carrier: 'None'
	  }
	};
	
	exports.SHIPPING_BULK_LIMIT = 20;
	
	exports.DTG_SHIPPING_BULK_LIMIT = 72;
	
	exports.SHIPPING_SPLIT_LIMIT = 10;
	
	exports.MARSHAL_BIN_LIMIT = 72;
	
	PRINTERS = {
	  INDY: {
	    address: {
	      name: 'Little Raymonds Print Shop',
	      address1: '2900 N Shadeland Ave',
	      address2: 'Ste B1',
	      city: 'Indianapolis',
	      state: 'IN',
	      zip: '46219'
	    },
	    types: {
	      'dtg': true,
	      'screenprint': true,
	      'mug': true
	    }
	  },
	  FRESNO: {
	    address: {
	      name: 'Little Raymonds Print Shop',
	      address1: '2904 S Angus Ave',
	      city: 'Fresno',
	      state: 'CA',
	      zip: '93725'
	    },
	    types: {
	      'screenprint': true
	    }
	  },
	  SCRANTON: {
	    address: {
	      name: 'Little Raymonds Print Shop',
	      address1: '510 Gleason Rd',
	      city: 'Moosic',
	      state: 'PA',
	      zip: '18507'
	    },
	    types: {
	      'dtg': true,
	      'screenprint': true
	    }
	  },
	  FREMONT: {
	    address: {
	      name: 'Little Raymonds Print Shop',
	      address1: '41455 Christy St',
	      city: 'Fremont',
	      state: 'CA',
	      zip: '94538'
	    },
	    types: {
	      'case': true,
	      'poster': true
	    }
	  },
	  DALLAS: {
	    address: {
	      name: 'Little Raymonds Print Shop',
	      address1: '850 Northlake Dr',
	      address2: 'Suite 500',
	      city: 'Coppell',
	      state: 'TX',
	      zip: '75019'
	    },
	    types: {}
	  }
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_MWW] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_ARTSADD] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_DTG2GO] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[LITTLERAYMONDS_FULFILLMENT_INDY] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_YL] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_STAKES] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_TECTONICS] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_LASUB] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_CG] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_SAP] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_DTGCSVPARTNERS] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_SCREENPRINT_PARTNERS] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_EPI] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_DUBOW] = {
	  address: {
	    name: 'Fulfillment Center',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_TECTONICS_API] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	PRINTERS[THIRD_PARTY_FACILITY_YOUNGSINC] = {
	  address: {
	    name: 'Little Raymonds Print Shop',
	    address1: '7800 Records Street',
	    address2: 'Suite C',
	    city: 'Indianapolis',
	    state: 'IN',
	    zip: '46226'
	  },
	  types: {}
	};
	
	exports.PRINTERS = PRINTERS;
	
	exports.BULB_POWERS = [
	  {
	    display: '10%',
	    value: 10
	  }, {
	    display: '20%',
	    value: 20
	  }, {
	    display: '30%',
	    value: 30
	  }, {
	    display: '40%',
	    value: 40
	  }, {
	    display: '50%',
	    value: 50
	  }, {
	    display: '60%',
	    value: 60
	  }, {
	    display: '70%',
	    value: 70
	  }, {
	    display: '80%',
	    value: 80
	  }, {
	    display: '90%',
	    value: 90
	  }, {
	    display: '100%',
	    value: 100
	  }
	];
	
	exports.BULB_ZONES = {
	  zone1: [0, 1, 2],
	  zone2: [3, 4, 5],
	  zone3: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
	  MIN: 0,
	  MAX: 100,
	  DEFAULT: 100,
	  SIZE: 27
	};
	
	exports.POSTER_STATUS = {
	  created: 'created',
	  ripping: 'ripping',
	  uploaded: 'uploaded',
	  ripped: 'ripped',
	  downloaded: 'downloaded',
	  printed: 'printed',
	  qced: 'qced'
	};
	
	exports.PRINTER_STATUS = ['printing', 'out-of-service'];
	
	exports.DEPARTMENTS = ['screenprint', 'dtg', 'shipping/receiving', 'digital/sublimation', 'embroidery', 'non production'];
	
	exports.POSITIONS = ['BDR Rep', 'AR Rep', 'Sales Supervisor', 'CS Rep', 'Approval Rep', 'Procurement Rep', 'Claim Rep', 'CS Supervisor', 'Supervisor', 'Screenprint Press Operator', 'Screenprint QC', 'Screenprint Press Assistant', 'Screenprint Picker', 'Screen Reclaim', 'Screen Coater', 'Screen Prep', 'Screen Washout', 'Screen Taper', 'DTG Lead', 'DTG Printer', 'DTG Pretreater', 'DTG Heat Presser', 'DTG QC', 'DTG Picker', 'Shipping Lead', 'Shipping Associate', 'Shipping Racker', 'Shipping Marshaler', 'Receiving Lead', 'Receiving Associate', 'Engineer', 'Designer', 'QA Engineer', 'Other', 'Non Production'];
	
	exports.SUPERVISOR_POSITIONS = ['Sales Supervisor', 'CS Supervisor', 'Supervisor'];
	
	exports.PRODUCT_TEMPLATES = {
	  'gildan-cotton-t-shirt': {
	    'front': 'men-tshirt-front'
	  },
	  'canvas-unisex-t-shirt': {
	    'front': 'men-tshirt-front'
	  }
	};
	
	exports.FINGERPRINT_SAMPLE_NUMBER = 4;
	
	exports.FINGERPRINT_S3_PATH = '/fingerprints';
	
	exports.CRM_ACTIVITY_TYPE = ["email", "phone"];
	
	exports.CRM_ACTIVITY_PURPOSE = ["introduction", "pricing", "demo", "follow up", "other", "customer service call", "left message", "invalid number", "invalid email", "contacted"];
	
	module.exports.STATUS_LOG_ACTIONS = {
	  dtg: {
	    'inventory-receiving-sticker': 'RECEIVED',
	    'blank-received': 'RECEIVED',
	    'dtg-artwork-not-ready': 'RIP_ISSUE',
	    'dtg-print-rip-down': 'RIP_ISSUE',
	    'dtg-print-not-ready': 'RIP_ISSUE',
	    'pretreat-fetch': 'PRETREAT',
	    'dtg-print-complete': 'PRINT',
	    'qc-fetch': 'QC',
	    'rack-qc-store': 'STORED',
	    'dtg-cart': 'CART_LOADED'
	  },
	  screenprint: {
	    'inventory-receiving-sticker': 'RECEIVED',
	    'first-store': 'STORED',
	    'rack-screenprint-store': 'STORED',
	    'rack-exception-store': 'STORED'
	  },
	  mug: {
	    'mug-taped': 'PRINTED',
	    'rack-qc-store': 'STORED'
	  },
	  "case": {
	    'rack-exception-store': 'STORED'
	  },
	  poster: {},
	  embr: {}
	};
	
	module.exports.SUGGESTED_SWAP_SETTING = {
	  '2000': ['5000', '3931', 'HD6R', '363'],
	  '2001': ['3001C', '3600', 'N6210'],
	  '2400': ['4930', 'G540'],
	  '3931': ['HD6R', '363', '5250', '5280', '2000', '5000'],
	  '5000': ['2000', '3931', 'HD6R', '363'],
	  '5250': ['5280', '3931', 'HD6R', '363', '2000', '5000'],
	  '18500': ['996M', 'P170'],
	  '3931B': ['363B', '5450', '2000B', '5000B'],
	  '5000B': ['3931B', '2000B', '5450', '363B'],
	  '2000L': ['L3930R'],
	  '39VR': ['G64V', '982'],
	  '2102': ['6004', '3900'],
	  'L3930R': ['2000L'],
	  '18000': ['562', 'P1607'],
	  '4930': ['G540'],
	  '39TKR': ['2200']
	};
	
	module.exports.MILESTONE_TIMELINE = {
	  'dtg': [
	    {
	      milestone: 'IMPORTED',
	      max: 5 * 24,
	      average: 12
	    }, {
	      milestone: 'REJECTION',
	      max: 5 * 24,
	      average: 12,
	      occasional: true
	    }, {
	      milestone: 'BLANK_ORDERED',
	      max: 7 * 24,
	      average: 48
	    }, {
	      milestone: 'RECEIVED',
	      max: 7 * 24,
	      average: 12
	    }, {
	      milestone: 'CART_LOADED',
	      max: 5 * 24,
	      average: 24
	    }, {
	      milestone: 'RIP_ISSUE',
	      max: 5 * 24,
	      average: 48,
	      alert: true,
	      occasional: true
	    }, {
	      milestone: 'PRETREAT',
	      max: 3 * 24,
	      average: 2,
	      occasional: true
	    }, {
	      milestone: 'PRINT',
	      max: 3 * 24,
	      average: 1
	    }, {
	      milestone: 'QC',
	      max: 3 * 24,
	      average: 1
	    }, {
	      milestone: 'STORED',
	      max: 5 * 24,
	      average: 6
	    }, {
	      milestone: 'SHIPPED'
	    }
	  ],
	  'screenprint': [
	    {
	      milestone: 'IMPORTED',
	      max: 5 * 24,
	      average: 12
	    }, {
	      milestone: 'REJECTION',
	      max: 5 * 24,
	      average: 12,
	      occasional: true
	    }, {
	      milestone: 'BLANK_ORDERED',
	      max: 7 * 24,
	      average: 48
	    }, {
	      milestone: 'RECEIVED',
	      max: 7 * 24,
	      average: 24
	    }, {
	      milestone: 'STORED',
	      max: 7 * 24,
	      average: 6
	    }, {
	      milestone: 'SHIPPED'
	    }
	  ],
	  'mug': [
	    {
	      milestone: 'IMPORTED',
	      max: 5 * 24,
	      average: 36
	    }, {
	      milestone: 'REJECTION',
	      max: 5 * 24,
	      average: 12,
	      occasional: true
	    }, {
	      milestone: 'PRINTED',
	      max: 3 * 24,
	      average: 3
	    }, {
	      milestone: 'STORED',
	      max: 7 * 24,
	      average: 3
	    }, {
	      milestone: 'SHIPPED'
	    }
	  ],
	  'case': [
	    {
	      milestone: 'IMPORTED',
	      max: 15 * 24,
	      average: 36
	    }, {
	      milestone: 'REJECTION',
	      max: 5,
	      average: 12,
	      alert: true,
	      occasional: true
	    }, {
	      milestone: 'STORED',
	      max: 7 * 24,
	      average: 3
	    }, {
	      milestone: 'SHIPPED'
	    }
	  ],
	  'poster': [
	    {
	      milestone: 'IMPORTED',
	      max: 15 * 24,
	      average: 84
	    }, {
	      milestone: 'REJECTION',
	      max: 5 * 24,
	      average: 84,
	      alert: true,
	      occasional: true
	    }, {
	      milestone: 'SHIPPED'
	    }
	  ]
	};
	
	exports.SCREENPRINT_SIZING_RULES = {
	  standard: {
	    front: {
	      width: 14,
	      height: 16
	    },
	    back: {
	      width: 14,
	      height: 16
	    }
	  },
	  small: {
	    front: {
	      width: 10,
	      height: 12
	    },
	    back: {
	      width: 10,
	      height: 12
	    }
	  },
	  pocket: {
	    front: {
	      countPlacement: true,
	      width: 14,
	      height: 10
	    },
	    back: {
	      width: 14,
	      height: 16
	    }
	  },
	  'youth-pocket': {
	    front: {
	      countPlacement: true,
	      width: 10,
	      height: 8
	    },
	    back: {
	      width: 10,
	      height: 12
	    }
	  },
	  chest: {
	    front: {
	      width: 14,
	      height: 4
	    },
	    back: {
	      width: 14,
	      height: 16
	    }
	  },
	  zipper: {
	    front: {
	      width: 14,
	      height: 4
	    },
	    back: {
	      width: 14,
	      height: 16
	    }
	  }
	};
	
	exports.DOMESTIC_COUNTRIES = ['PR', 'VI', 'GU', 'AA', 'AP', 'US'];
	
	exports.EU_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
	
	exports.SCREENPRINT_COLOR_LIMIT = 8;
	
	exports.EMBR_COLOR_LIMIT = 15;
	
	exports.OOSHIRTS_USER_ID = '57a26d2a7470cb473a565dae';
	
	exports.ORDER_STATUS = ORDER_STATUS = ['quote', 'order', 'validated', 'unpaid', 'paid', 'on-hold', 'artwork-created', 'printing', 'shipped', 'cancelled'];
	
	exports.ITEM_STATUS = ITEM_STATUS = ORDER_STATUS.concat(['reprint']);
	
	exports.EVENT_STATUS = EVENT_STATUS = ITEM_STATUS.concat(['garment-substitution', 'address-changed', 'returned', 'delivered', 'printing-email', 'order-cancelled-email', 'order-confirm-email', 'order-shipped-email', 'order-invoice-email', 'shipment-returned-email', 'order-on-hold-email', 'order-artwork-created-email', 'order-approval-delayed-email', 'artwork-preparation', 'artwork-on-hold', 'order-on-hold', 'artwork-complete', 'order-approved', 'blanks-placed', 'blanks-received', 'pretreat', 'printed', 'taped', 'baked', 'qc', 'stored', 'rejection', 'ripped', 'stitch', 'on-hold', 'screenprintable-cs-approved', 'screenprintable-cs-rejected', 'address-auto-approved', 'address-auto-rejected', 'address-cs-approved', 'address-cs-rejected', 'ip-auto-approved', 'ip-auto-unresolved', 'ip-auto-rejected', 'ip-cs-approved', 'ip-cs-rejected', 'artwork-draft', 'artwork-qc-approve', 'artwork-qc-reject', 'artwork-created', 'user-approved', 'user-rejected', 'change-request', 'cs-approved', 'user-cs-request', 'order-released', 'blanks-arrived', 'blanks-shipped', 'screens-made', 'on-press', 'personalization-complete', 'qc-defects', 'qc-complete', 'order-name-changed', 'shipping-method-changed', 'design-change', 'partial-receipt', 'reassigned', 'reassigned-facility']);
	
	exports.ARTWORK_API_FORMATS = {
	  'png': {
	    ids: ['PNG', 'PNG8', 'PNG24', 'PNG32'],
	    type: 'raster'
	  },
	  'jpg': {
	    alias: ['jpeg'],
	    ids: ['JPEG'],
	    type: 'raster'
	  },
	  'gif': {
	    ids: ['GIF'],
	    type: 'raster'
	  },
	  'bmp': {
	    ids: ['BMP', 'BMP2', 'BMP3'],
	    type: 'raster'
	  },
	  'ico': {
	    ids: ['ICO'],
	    type: 'raster'
	  },
	  'jp2': {
	    ids: ['JP2'],
	    type: 'raster'
	  },
	  'eps': {
	    ids: ['PS', 'EPT', 'EPS', 'EPS2', 'EPS3'],
	    type: 'vector'
	  },
	  'svg': {
	    ids: ['SVG'],
	    type: 'vector'
	  },
	  'pdf': {
	    alias: ['ai'],
	    ids: ['PPM', 'PDF'],
	    type: 'vector'
	  },
	  'dst': {
	    ids: ['DST'],
	    type: 'vector'
	  }
	};
	
	_exts = [];
	
	ref = exports.ARTWORK_API_FORMATS;
	for (ext in ref) {
	  alias = ref[ext].alias;
	  _exts.push(ext);
	  if (alias) {
	    _exts.push.apply(_exts, alias);
	  }
	}
	
	exports.ARTWORK_API_EXTENSIONS = _exts;
	
	exports.PROMO_EMAILS_TEMPLATES = ['inactivity-follow-up', 'new-user-follow-up'];
	
	exports.SUBLIMATION_COLORS = [
	  {
	    hex: 'F6F6F6',
	    name: 'White'
	  }, {
	    hex: '000000',
	    name: 'Black'
	  }, {
	    hex: 'CCCCCC',
	    name: 'Ash'
	  }, {
	    hex: '999999',
	    name: 'Athletic Heather'
	  }, {
	    hex: '595959',
	    name: 'Charcoal Grey'
	  }, {
	    hex: '031F30',
	    name: 'J Navy'
	  }, {
	    hex: '014695',
	    name: 'Royal'
	  }, {
	    hex: 'B3D2E7',
	    name: 'Light Blue'
	  }, {
	    hex: 'FB4788',
	    name: 'Cyber Pink'
	  }, {
	    hex: 'C62047',
	    name: 'True Red'
	  }, {
	    hex: '660099',
	    name: 'Purple'
	  }, {
	    hex: '70D651',
	    name: 'Kiwi'
	  }, {
	    hex: '009A3D',
	    name: 'Kelly'
	  }, {
	    hex: '003300',
	    name: 'Forest Green'
	  }, {
	    hex: 'FECA3D',
	    name: 'Gold'
	  }, {
	    hex: 'FF6600',
	    name: 'Burnt Orange'
	  }, {
	    hex: '584130',
	    name: 'Chocolate'
	  }, {
	    hex: 'EABDD3',
	    name: 'Classic Pink'
	  }
	];
	
	exports.CASE_DIMENSIONS = {
	  width: 4,
	  height: 6
	};
	
	exports.MUG_DIMENSIONS = {
	  width: 8.36,
	  height: 3.48
	};
	
	exports.ARTWORK_DESIGN_PLACEMENT = ['center-small', 'center-medium', 'center-large', 'center-full', 'bottom'];
	
	exports.DTG_REJECT_WARNING_THRESHOLD = 2;
	
	exports.PRETREAT_MANAGER = {
	  deleteValue: 0,
	  min: 5,
	  max: 100
	};
	
	exports.GARMENT_SINGLE_SIZE_IDENTIFIERS = ['bagedge-canvas-promo-tote'];
	
	exports.SUB_USER_PERMISSION = {
	  shop: 'place orders',
	  billing: 'view or perform billing related functionalities',
	  order: 'view order history page',
	  claim: 'view or perform claims related functionality',
	  view: 'view all order, designs, invoices of parent user'
	};
	
	exports.INVENTORY_RACK_LAYOUTS = {
	  PRIME_VARIABLE: {
	    type: 'prime-inventory',
	    name: 'Prime Inventory',
	    size: Number.MAX_VALUE,
	    locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', '1A', '2A', '3A', '4A', '5A', '6A', '1B', '2B', '3B', '4B', '5B', '6B', '1C', '2C', '3C', '4C', '5C', '6C', '1D', '2D', '3D', '4D', '5D', '6D', '1E', '2E', '3E', '4E', '5E', '6E', '1F', '2F', '3F', '4F', '5F', '6F']
	  },
	  PRETREATED_PRIME_VARIABLE: {
	    type: 'pretreated-prime-inventory',
	    name: 'Prime Inventory - Pretreated',
	    size: Number.MAX_VALUE,
	    locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', '1A', '2A', '3A', '4A', '5A', '6A', '1B', '2B', '3B', '4B', '5B', '6B', '1C', '2C', '3C', '4C', '5C', '6C', '1D', '2D', '3D', '4D', '5D', '6D', '1E', '2E', '3E', '4E', '5E', '6E', '1F', '2F', '3F', '4F', '5F', '6F']
	  },
	  SUPPLEMENTARY_VARIABLE: {
	    type: 'supplementary-inventory',
	    name: 'Supplementary Inventory',
	    size: Number.MAX_VALUE,
	    locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', '1A', '2A', '3A', '4A', '5A', '6A', '1B', '2B', '3B', '4B', '5B', '6B', '1C', '2C', '3C', '4C', '5C', '6C', '1D', '2D', '3D', '4D', '5D', '6D', '1E', '2E', '3E', '4E', '5E', '6E', '1F', '2F', '3F', '4F', '5F', '6F']
	  }
	};
	
	exports.SHIPMENT_OVERFLOW_MAX = 6;
	
	exports.SHIPMENT_OVERFLOW_MIN = 2;
	
	exports.RACK_LAYOUTS = {
	  DTG_LAYOUT: {
	    type: 'storage',
	    name: 'DTG',
	    unmarshalled: {
	      size: 10.24,
	      locations: ["31", "32", "33"]
	    },
	    marshalled: {
	      size: 8,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 30; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  MARSHAL_LAYOUT: {
	    type: 'marshal',
	    name: 'Marshalling',
	    unmarshalled: {
	      size: 0,
	      locations: []
	    },
	    marshalled: {
	      size: 8,
	      itemLimit: 6,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 72; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  BULK_MARSHAL_LAYOUT: {
	    type: 'marshal',
	    name: 'Bulk Marshalling',
	    bulk: true,
	    unmarshalled: {
	      size: 0,
	      locations: []
	    },
	    marshalled: {
	      size: 24,
	      itemLimit: 24,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 24; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  BULK_MARSHAL_LAYOUT_V2: {
	    type: 'marshal',
	    name: 'Bulk Marshalling V2 (18 bins)',
	    bulk: true,
	    unmarshalled: {
	      size: 0,
	      locations: []
	    },
	    marshalled: {
	      size: 18,
	      itemLimit: 24,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 18; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  MEGA_MARSHAL_LAYOUT: {
	    type: 'marshal',
	    name: 'Mega Marshalling',
	    mega: true,
	    unmarshalled: {
	      size: 0,
	      locations: []
	    },
	    marshalled: {
	      size: 100,
	      itemLimit: 72,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 6; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  PACKAGE_MARSHAL_LAYOUT: {
	    type: 'marshal',
	    name: 'Bad address bulk Marshalling',
	    "package": true,
	    unmarshalled: {
	      size: 0,
	      locations: []
	    },
	    marshalled: {
	      size: 10,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 24; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  MEGARACK_LAYOUT: {
	    type: 'storage',
	    name: 'Megarack',
	    unmarshalled: {
	      size: 38.4,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 217; i <= 220; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    },
	    marshalled: {
	      size: 3.6,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 216; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    }
	  },
	  SCAN_LAYOUT: {
	    type: 'dtg-sort',
	    name: 'DTG Receiving',
	    unmarshalled: {
	      size: 24,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 6; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  SCREENPRINT_SORT_LAYOUT: {
	    type: 'screenprint-sort',
	    name: 'Screenprint Receiving',
	    unmarshalled: {
	      size: 24,
	      locations: (function() {
	        var i, results;
	        results = [];
	        for (int = i = 1; i <= 12; int = ++i) {
	          results.push(int.toString());
	        }
	        return results;
	      })()
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  INVENTORY_LAYOUT: {
	    type: 'marshal-sort',
	    name: '6x7 Screenprint Inventory',
	    unmarshalled: {
	      size: 24,
	      locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7', 'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7', 'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7']
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  INVENTORY_LAYOUT_5x4: {
	    type: 'marshal-sort',
	    name: '5x4 Screenprint Inventory',
	    unmarshalled: {
	      size: 24,
	      locations: ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D1', 'D2', 'D3', 'D4', 'E1', 'E2', 'E3', 'E4']
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  INVENTORY_LAYOUT_5x7: {
	    type: 'marshal-sort',
	    name: '5x7 Screenprint Inventory',
	    unmarshalled: {
	      size: 24,
	      locations: ['1A', '1B', '1C', '1D', '1E', '2A', '2B', '2C', '2D', '2E', '3A', '3B', '3C', '3D', '3E', '4A', '4B', '4C', '4D', '4E', '5A', '5B', '5C', '5D', '5E', '6A', '6B', '6C', '6D', '6E', '7A', '7B', '7C', '7D', '7E']
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  INDY_INVENTORY_LAYOUT: {
	    type: 'marshal-sort',
	    name: '5x5 Screenprint Inventory',
	    unmarshalled: {
	      size: 24,
	      locations: ['A1', 'A2', 'A3', 'A4', 'A5', 'B1', 'B2', 'B3', 'B4', 'B5', 'C1', 'C2', 'C3', 'C4', 'C5', 'D1', 'D2', 'D3', 'D4', 'D5', 'E1', 'E2', 'E3', 'E4', 'E5', 'F1', 'F2', 'F3', 'F4', 'F5', 'G1', 'G2', 'G3', 'G4', 'G5', 'H1', 'H2', 'H3', 'H4', 'H5', 'I1', 'I2', 'I3', 'I4', 'I5', 'J1', 'J2', 'J3', 'J4', 'J5']
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  MANUAL_P9_STORE_LAYOUT: {
	    type: 'manual-order-store',
	    name: 'Manual P9 Order Store',
	    unmarshalled: {
	      size: 100000,
	      locations: [1, 2, 3, 4, 5, 6].map(function(bin) {
	        return bin.toString();
	      })
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  FLOATING_LAYOUT: {
	    type: 'marshal-sort',
	    name: 'Floating Screenprint Inventory',
	    unmarshalled: {
	      size: 100000000,
	      locations: ['X1', 'X2', 'X3', 'X4', 'X5', 'X6', 'X7', 'Y1', 'Y2', 'Y3', 'Y4', 'Y5', 'Y6', 'Y7', 'Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7']
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  FLOATING_LAYOUT_1x5: {
	    type: 'marshal-sort',
	    name: '1x5 Floating Screenprint Inventory',
	    unmarshalled: {
	      size: 100000000,
	      locations: ['X1', 'X2', 'X3', 'X4', 'X5']
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  OVERFLOW_SORT_LAYOUT: {
	    type: 'overflow-sort',
	    name: 'Overflow Sort Gaylord',
	    unmarshalled: {
	      size: 100000000,
	      locations: (function() {
	        results = [];
	        for (i = 1; i <= 800; i++){ results.push(i); }
	        return results;
	      }).apply(this).map(function(bin) {
	        return bin.toString();
	      })
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  CUSTOMIZATION_OVERFLOW_SORT_LAYOUT: {
	    type: 'overflow-sort-custom',
	    name: 'Overflow Sort Customization Gaylord',
	    unmarshalled: {
	      size: 100000000,
	      locations: (function() {
	        results1 = [];
	        for (j = 1; j <= 800; j++){ results1.push(j); }
	        return results1;
	      }).apply(this).map(function(bin) {
	        return bin.toString();
	      })
	    },
	    marshalled: {
	      size: 1,
	      locations: []
	    }
	  },
	  PACKAGE_STORAGE_LAYOUT: {
	    type: 'storage',
	    name: 'Infinity Bad address',
	    unmarshalled: {
	      size: 0,
	      locations: []
	    },
	    marshalled: {
	      size: 1000000,
	      locations: (function() {
	        results2 = [];
	        for (k = 1; k <= 800; k++){ results2.push(k); }
	        return results2;
	      }).apply(this).map(function(bin) {
	        return bin.toString();
	      })
	    }
	  }
	};
	
	exports.BOX_RACK_LAYOUTS = {
	  POST_PRINT_BOXES_LAYOUT_4x4: {
	    type: 'postprint-box-store',
	    name: '4x4 Post Print Boxes',
	    locations: ['A1', 'A2', 'A3', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D1', 'D2', 'D3', 'D4']
	  },
	  POST_PRINT_BOXES_LAYOUT_1x5: {
	    type: 'postprint-box-store',
	    name: '1x5 Post Print Boxes',
	    locations: ['A1', 'A2', 'A3', 'A4', 'A5']
	  }
	};
	
	exports.INTERNET_STATUS = {
	  refreshInterval: 30 * 1000,
	  timeoutThresholdMS: 5 * 60 * 1000,
	  signals: {
	    error: {
	      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_0.svg'
	    },
	    one: {
	      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_1.svg',
	      lowerBound: 4000
	    },
	    two: {
	      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_2.svg',
	      lowerBound: 2000
	    },
	    three: {
	      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_3.svg',
	      lowerBound: 1000
	    },
	    four: {
	      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_4.svg',
	      lowerBound: 400
	    },
	    five: {
	      url: 'https://s3-us-west-2.amazonaws.com/oo-prod/public/assets/workstation/icons/signal_5.svg',
	      lowerBound: 0
	    }
	  }
	};
	
	exports.GENERIC_PRODUCT_NAMES = {
	  'fruit-of-the-loom-cotton-t': 'Classic T-Shirt',
	  'jerzees-100-cotton-t-shirt': 'Classic T-Shirt',
	  'hanes-tagless-t-shirt': 'Classic T-Shirt',
	  'hanes-comfort-soft-t-shirt': 'Classic T-Shirt',
	  'anvil-fashion-fit-t-shirt': 'Classic T-Shirt',
	  'gildan-ultra-cotton-t-shirt': 'Classic T-Shirt',
	  'gildan-cotton-t-shirt': 'Classic T-Shirt',
	  'american-apparel-t-shirt': 'Premium Fit Mens Tee',
	  'next-level-fitted-crew': 'Premium Fit Mens Tee',
	  'canvas-unisex-t-shirt': 'Premium Fit Mens Tee',
	  'alternative-apparel-basic-crew-t-shirt': 'Premium Fit Tee',
	  'fruit-of-the-loom-hd-v-neck-t-shirt': 'V-Neck T-Shirt',
	  'fruit-of-the-loom-sofspun-r-v-neck': 'V-Neck T-Shirt',
	  'gildan-v-neck-t-shirt': 'V-Neck T-Shirt',
	  'anvil-fashion-v-neck-t': 'V-Neck T-Shirt',
	  'canvas-v-neck-t-shirt': 'V-Neck T-Shirt',
	  'next-level-mens-cotton-v': 'V-Neck T-Shirt',
	  'fruit-of-the-loom-ladies-heavy-cotton-t-shirt': 'Ladies T-Shirt',
	  'anvil-ladies-mid-scoop-t-shirt': 'Ladies T-Shirt',
	  'gildan-ultra-ladies-t-shirt': 'Ladies T-Shirt',
	  'gildan-ladies-missy-t-shirt': 'Ladies T-Shirt',
	  'hanes-ladies-comfort-soft-t': 'Ladies T-Shirt',
	  'american-apparel-girly-t': 'Premium Fit Ladies Tee',
	  'next-level-boyfriend-tee': 'Premium Fit Ladies Tee',
	  'bella-ladies-favorite-t-shirt': 'Premium Fit Ladies Tee',
	  'next-level-ladies-racerback-tank': 'Ladies Flowy Tank',
	  'bella-flowy-racerback-tank': 'Ladies Flowy Tank',
	  'jerzees-50-50-hoodie': 'Hooded Sweatshirt',
	  'gildan-50-50-hoodie': 'Hooded Sweatshirt',
	  'hanes-50-50-hoodie': 'Hooded Sweatshirt',
	  'gildan-sweatshirt-crew': 'Long Sleeve Tee',
	  'jerzees-50-50-fleece-crew': 'Long Sleeve Tee',
	  'jerzees-sweatshirt-crew': 'Long Sleeve Tee',
	  'hanes-50-50-fleece-crew': 'Long Sleeve Tee',
	  'fruit-of-the-loom-long-sleeve': 'Sleeveless Tee',
	  'gildan-ultra-cotton-long-sleeve-t-shirt': 'Sleeveless Tee',
	  'jerzees-long-sleeve-t': 'Sleeveless Tee',
	  'gildan-long-sleeve-t-shirt': 'Sleeveless Tee',
	  'jerzees-sleeveless-t-shirt': 'Sleeveless Tee',
	  'gildan-sleeveless-t-shirt': 'Sleeveless Tee',
	  'fruit-of-the-loom-hd-tank': 'Unisex Tank',
	  'gildan-cotton-tank-top': 'Unisex Tank',
	  'next-level-mens-jersey-tank': 'Unisex Tank',
	  'fruit-of-the-loom-youth-cotton-t': 'Youth T-Shirt',
	  'jerzees-hi-densi-t-youth-t': 'Youth T-Shirt',
	  'hanes-youth-comfort-soft-t': 'Youth T-Shirt',
	  'gildan-youth-ultra-cotton-t': 'Youth T-Shirt',
	  'gildan-youth-cotton-t': 'Youth T-Shirt',
	  'bagedge-canvas-promo-tote': 'Tote Bag',
	  'rabbit-skins-infant-bodysuit': 'Infant Onesie'
	};
	
	exports.RIP_X_PLACEMENT = ['L', 'R', 'C', 'LC', 'RC'];
	
	exports.RIP_VERTICAL_PLACEMENT = ['top', 'center', 'bottom'];
	
	exports.PLATENS = ['4x4', '4x16', '7x8', '10x12', '14x16', '16x20', 'HAT'];
	
	exports.RIP_LOCATIONS = ['BROTHER_CLOUD', 'CLOUD', 'FRESNO', 'SCRANTON', 'INDY', 'DALLAS'];
	
	exports.INACTIVE_RIP_LOCATIONS = ['BROTHER_CLOUD', 'FRESNO', 'SCRANTON'];
	
	exports.EMBR_POSITIONS = ['LC', 'RC', 'CF', 'BC', 'LS', 'RS'];
	
	exports.EMBR_LOCATIONS = ['CLOUD', 'INDY'];
	
	exports.EMBR_PRICING_RULES = {
	  numFreeStitches: 10000,
	  numExtraStitchesPerTier: 1000
	};
	
	exports.AGENT_PERMISSIONS = {
	  sales: {
	    claim: true,
	    order: true,
	    billing: false,
	    shop: false
	  },
	  purchase: {
	    claim: true,
	    order: true,
	    billing: true,
	    shop: true
	  }
	};
	
	exports.SP_MOCKUP_COMPLETION_EXCHANGE = 'sp-mockup-completion';
	
	exports.STORE_CREDIT_TYPE = ['promotion', 'claim', 'check', 'ach-wire', 'write-off', 'check-refund', 'admin-reversal', 'adfairy-credit', 'adfairy-payoneer', 'adfairy-paypal', 'adfairy-discount', 'adlauncher-credit', 'adlauncher-payoneer', 'adlauncher-paypal', 'google-credit', 'google-payoneer', 'google-paypal', 'teechip-cash', 'sp-cash'];
	
	exports.DEBIT_TYPE = DEBIT_TYPE = {
	  order: 'order',
	  adjustment: 'adjustment',
	  rollback: 'rollback',
	  refund: 'refund',
	  adFairyCashAdjustment: 'adfairy-cash-adjustment',
	  affiliateCommission: 'affiliate-commission',
	  fee: 'fee',
	  preSaleRefund: 'pre-sale-refund',
	  postSaleRefund: 'post-sale-refund',
	  claim: 'claim'
	};
	
	exports.DEBIT_TYPES = _.map(DEBIT_TYPE);
	
	exports.NONSPUSERSEMAILS = ['support@teechip.com', 'admin@scalablelicensing.com', 'doug@shirts.io', 'aanderson@alphabroder.com', 'decosupportsp@alphabroder.com', /ooshirts\.com/i, /scalablepress\.com/i, /teechip\.com/i, /inkpop\.com/i];
	
	exports.DTG_RIP_PROFILE_SETTING = 'dtg-rip-profile';
	
	exports.DTG_LEGACY_RIP_GROUP = 'cadlink5';
	
	exports.BLACKLIST_KEYWORD_LEVELS = ['IGNORED', 'MEDIUM', 'HIGH'];


/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/alpha/',
	  views: {
	    design: '/alpha/views/design',
	    confirmed: '/alpha/views/order/confirmed',
	    approval: '/alpha/views/order/approval',
	    order: {
	      status: '/alpha/views/order/status'
	    },
	    deco: {
	      detail: '/alpha/views/deco/detail',
	      coordinator: '/alpha/views/deco/coordinator'
	    },
	    test: {
	      design: '/alpha/views/test/user/design',
	      decoTest: '/alpha/views/test/decoCoordinator',
	      approval: '/alpha/views/test/user/approval/order'
	    }
	  },
	  widget: {
	    base: '/alpha/widget/base.js',
	    demo: '/alpha/widget/demo.html',
	    test: '/alpha/widget/test'
	  },
	  data: {
	    artwork: {
	      bulk: '/alpha/data/artwork/bulk/'
	    },
	    design: {
	      bulk: '/alpha/data/design/bulk/',
	      search: '/alpha/data/design/search/:searchQuery',
	      save: '/alpha/data/design/save',
	      populate: '/alpha/data/design/populate',
	      artwork: {
	        upload: '/alpha/data/design/artwork'
	      }
	    },
	    shippingForm: {
	      base: '/alpha/data/shippingForm/:shippingFormId',
	      bulk: '/alpha/data/shippingForm/bulk'
	    },
	    deco: {
	      order: {
	        list: '/alpha/v2/data/order/list'
	      }
	    },
	    order: {
	      bulk: '/alpha/v2/data/order/bulk',
	      detail: '/alpha/v2/data/order/detail/:orderId',
	      search: '/alpha/v2/data/order/search/:searchQuery',
	      artworkApprove: '/alpha/v2/data/order/detail/:orderId/artworkApprove',
	      change: '/alpha/v2/data/order/detail/:orderId/change',
	      csApprove: '/alpha/v2/data/order/detail/:orderId/csApprove',
	      csRequest: '/alpha/v2/data/order/detail/:orderId/csRequest'
	    },
	    retrieveFDM4: '/alpha/v2/data/retrieveFDM4'
	  }
	};


/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	module.exports = {
	  auth: {
	    authorize: '/authServer/auth/authorize',
	    permissions: '/authServer/auth/permissions'
	  },
	  role: {
	    base: '/authServer/role/',
	    detail: '/authServer/role/:roleId/detail',
	    byIdentifier: '/authServer/role/byIdentifier/:roleIdentifier',
	    bulk: '/authServer/role/byIdentifier/bulk',
	    grant: '/authServer/role/grant/:roleId/:permissionIdentifier/:accessibility',
	    revoke: '/authServer/role/grant/:roleId/:permissionIdentifier/:accessibility'
	  },
	  health: {
	    base: '/authServer/__health'
	  }
	};


/***/ }),

/***/ 251:
/***/ (function(module, exports) {

	module.exports = {
	  printLabel: '/internal/autobagger/printLabel'
	};


/***/ }),

/***/ 252:
/***/ (function(module, exports) {

	module.exports = {
	  list: '/camera/list',
	  preview: '/camera/:port/preview',
	  capture: '/camera/:port/capture',
	  reset: '/camera/reset'
	};


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

	module.exports = {
	  fontPreview: '/internal/common/fontPreview',
	  resizeImage: '/internal/common/resizeImage'
	};


/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/coupa',
	  punchout: '/coupa/punchout',
	  checkout: '/coupa/checkout',
	  purchaseOrder: '/coupa/purchaseOrder'
	};


/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/internal/dashboard',
	  artwork: {
	    download: '/internal/dashboard/artwork/download',
	    barcode: {
	      base: '/internal/dashboard/artwork/barcode/:barcode.png'
	    },
	    mockup: {
	      demo: {
	        base: '/internal/dashboard/artwork/mockup/demo',
	        blank: '/internal/dashboard/artwork/mockup/blank',
	        generate: '/internal/dashboard/artwork/mockup/generate'
	      }
	    },
	    moderation: {
	      base: '/internal/dashboard/artwork/moderation/',
	      job: '/internal/dashboard/artwork/moderation/job/',
	      context: '/internal/dashboard/artwork/moderation/:artworkId/context',
	      similarity: '/internal/dashboard/artwork/moderation/:artworkId/similarity',
	      waiting: '/internal/dashboard/artwork/moderation/waiting/'
	    },
	    user: {
	      detail: '/internal/dashboard/artwork/user/:userId'
	    }
	  },
	  order: {
	    base: '/internal/dashboard/order',
	    stuck: '/internal/dashboard/order/stuck',
	    flow: '/internal/dashboard/order/flow',
	    count: '/internal/dashboard/order/count',
	    breakdown: '/internal/dashboard/order/breakdown',
	    reprint: '/internal/dashboard/order/:orderId/reprint',
	    shipping: {
	      base: '/internal/dashboard/order/:orderId/shipping',
	      prices: '/internal/dashboard/order/:orderId/shipping/prices',
	      shippingWorkstation: '/internal/dashboard/order/:orderId/shipping/shippingWorkstation'
	    },
	    issues: {
	      shipping: {
	        base: '/internal/dashboard/order/issues/shipping',
	        errors: '/internal/dashboard/order/issues/shipping/errors'
	      },
	      artwork: {
	        cancel: '/internal/dashboard/order/issues/artwork/cancel'
	      },
	      inventory: {
	        base: '/internal/dashboard/order/issues/inventory'
	      }
	    },
	    orderForm: {
	      orderPart: '/internal/dashboard/order/orderForm/:orderFormId/orderPart'
	    }
	  },
	  design: {
	    base: '/internal/dashboard/design',
	    conversion: {
	      base: '/internal/dashboard/design/artwork/conversion',
	      queue: '/internal/dashboard/design/artwork/conversion/queue'
	    },
	    qc: {
	      base: '/internal/dashboard/design/qc',
	      job: '/internal/dashboard/design/qc/job',
	      message: '/internal/dashboard/design/qc/:designId/message',
	      approve: '/internal/dashboard/design/qc/:designId/approve',
	      reject: '/internal/dashboard/design/qc/:designId/reject',
	      waiting: '/internal/dashboard/design/qc/waiting'
	    },
	    vectorization: {
	      base: '/internal/dashboard/design/vectorization',
	      queue: '/internal/dashboard/design/vectorization/queue'
	    },
	    mockup: {
	      demo: {
	        base: '/internal/dashboard/design/mockup/demo'
	      }
	    }
	  },
	  user: {
	    base: '/internal/dashboard/user',
	    review: '/internal/dashboard/user/review.csv',
	    detail: '/internal/dashboard/user/:userId',
	    assume: '/internal/dashboard/user/:userId/assume',
	    pricing: '/internal/dashboard/user/:userId/pricing',
	    credit: '/internal/dashboard/user/:userId/credit',
	    addAsChild: '/internal/dashboard/user/:userId/addAsChild',
	    resellerLicense: '/internal/dashboard/user/resellerLicense',
	    referrer: '/internal/dashboard/user/referrer',
	    delayReport: {
	      base: '/internal/dashboard/user/delayReport',
	      addJob: '/internal/dashboard/user/delayReport/addJob'
	    }
	  },
	  creditLineApplication: {
	    base: '/internal/dashboard/creditLineApplication',
	    list: '/internal/dashboard/creditLineApplication/list',
	    processedAfter: '/internal/dashboard/creditLineApplication/processedAfter',
	    processedAfterCSV: '/internal/dashboard/creditLineApplication/processedAfter.csv',
	    process: '/internal/dashboard/creditLineApplication/:creditLineApplicationId/process'
	  },
	  employee: {
	    base: '/internal/dashboard/employee',
	    performance: '/internal/dashboard/employee/performance',
	    supervisor: '/internal/dashboard/employee/supervisor',
	    timesheets: '/internal/dashboard/employee/timesheets',
	    csvTimesheets: '/internal/dashboard/employee/csvTimesheets',
	    shifts: '/internal/dashboard/employee/shifts',
	    present: '/internal/dashboard/employee/present',
	    salesReport: '/internal/dashboard/employee/salesReport'
	  },
	  facility: {
	    shipments: '/internal/dashboard/facility/shipments',
	    inventory: {
	      flow: '/internal/dashboard/facility/inventory/flow'
	    },
	    updater: '/internal/dashboard/facility/updater',
	    projects: {
	      data: '/internal/dashboard/facility/projects/data'
	    }
	  },
	  claim: {
	    base: '/internal/dashboard/claim',
	    count: '/internal/dashboard/claim/count',
	    detail: '/internal/dashboard/claim/:claimId',
	    resolve: '/internal/dashboard/claim/:claimId/resolve',
	    reprint: '/internal/dashboard/claim/:claimId/reprint'
	  },
	  workstation: {
	    printerTest: {
	      base: '/internal/workstation/printerTest'
	    },
	    loginToken: {
	      base: '/internal/workstation/token'
	    },
	    pick: {
	      screenprint: {
	        sticker: '/internal/workstation/pick/screenprint/sticker'
	      },
	      status: '/internal/workstation/pick/barcode/:barcode/:facility/status',
	      barcode: '/internal/workstation/pick/barcode/:barcode/:facility',
	      sticker: '/internal/workstation/pick/sticker'
	    },
	    stickering: {
	      replacements: '/internal/workstation/stickering/replacements',
	      replacementsStatus: '/internal/workstation/stickering/replacementsStatus',
	      stickers: '/internal/workstation/stickering/stickers'
	    },
	    employee: {
	      base: '/internal/workstation/employee',
	      base2: '/internal/workstation/employee2'
	    },
	    embr: {
	      detail: '/internal/workstation/embr/:embrId/detail',
	      artwork: '/internal/workstation/embr/:embrId/artwork',
	      printEmbr: '/internal/workstation/embr/:embrId/printEmbr',
	      jobSheet: '/internal/workstation/embr/:referenceId/jobSheet',
	      qc: {
	        base: '/internal/workstation/embr/qc',
	        escalate: '/internal/workstation/embr/qc/escalate'
	      }
	    },
	    manual: {
	      base: '/internal/workstation/manual'
	    },
	    inventory: {
	      rack: {
	        storeInstruction: '/internal/workstation/inventory/rack/:rackId/storeInstruction',
	        marshalStatus: '/internal/workstation/inventory/rack/:rackId/marshalStatus',
	        marshalInstruction: '/internal/workstation/inventory/rack/:rackId/bin/:bin/marshalInstruction',
	        storeMarshalInstruction: '/internal/workstation/inventory/rack/storeMarshalInstruction/:facility',
	        floatStatus: '/internal/workstation/inventory/rack/floatStatus/:facility',
	        fitStatus: '/internal/workstation/inventory/rack/:rackId/fitStatus',
	        pull: '/internal/workstation/inventory/rack/pull',
	        shortPull: '/internal/workstation/inventory/rack/shortPull',
	        update: '/internal/workstation/inventory/rack/update',
	        update2: '/internal/workstation/inventory/rack/update2',
	        remove: '/internal/workstation/inventory/rack/remove',
	        pullStatus: '/internal/workstation/inventory/rack/pullStatus',
	        storedStatus: '/internal/workstation/inventory/rack/storedStatus',
	        countStatus: '/internal/workstation/inventory/rack/countStatus',
	        countSheet: '/internal/workstation/inventory/rack/countSheet',
	        cycleCount: {
	          base: '/internal/workstation/inventory/rack/cycleCount',
	          base2: '/internal/workstation/inventory/rack/cycleCount2'
	        }
	      },
	      orderPart: {
	        pickAt: '/internal/workstation/inventory/orderPart/:orderPartId/pickAt',
	        location: '/internal/workstation/inventory/orderPart/:orderPartId/location',
	        orderStatus: '/internal/workstation/inventory/orderPart/order/:ooOrderId/orderStatus',
	        swap: '/internal/workstation/inventory/orderPart/:orderPartId/swap',
	        swapStatus: '/internal/workstation/inventory/orderPart/swapStatus'
	      },
	      orderPartRejection: {
	        approve: '/internal/workstation/inventory/orderPartRejection/approve'
	      },
	      barcode: {
	        cart: '/internal/workstation/inventory/barcode/cart',
	        employee: '/internal/workstation/inventory/barcode/employee'
	      },
	      box: {
	        store: '/internal/workstation/inventory/box/:boxId/store',
	        pullList: '/internal/workstation/inventory/box/:facility/pullList',
	        pull: '/internal/workstation/inventory/box/:boxId/pull'
	      },
	      blankOrder: {
	        base: '/internal/workstation/inventory/blankOrder',
	        barcode: '/internal/workstation/inventory/blankOrder/barcode/:barcode',
	        generate: '/internal/workstation/inventory/blankOrder/:facility/generate',
	        query: '/internal/workstation/inventory/blankOrder/:facility/query',
	        exception: '/internal/workstation/inventory/blankOrder/:blankOrderId/exception',
	        history: '/internal/workstation/inventory/blankOrder/:blankOrderId/history',
	        packingSlip: '/internal/workstation/inventory/blankOrder/:blankOrderId/packingSlip',
	        cancel: '/internal/workstation/inventory/blankOrder/:blankOrderId/cancel',
	        shortage: '/internal/workstation/inventory/blankOrder/:blankOrderId/shortage',
	        "package": {
	          base: '/internal/workstation/inventory/blankOrder/package',
	          barcode: '/internal/workstation/inventory/blankOrder/package/barcode/:barcode',
	          manual: '/internal/workstation/inventory/blankOrder/package/manual',
	          receive: '/internal/workstation/inventory/blankOrder/:blankOrderId/package/:packageId/receive',
	          reprintStickers: '/internal/inventory/blankOrder/:blankOrderId/package/:packageId/reprintStickers',
	          extraSticker: '/internal/inventory/blankOrder/extraSticker',
	          stickerData: '/internal/workstation/inventory/blankOrder/:blankOrderId/package/:packageId/stickerData',
	          tracking: '/internal/workstation/inventory/blankOrder/package/tracking/:barcode',
	          tracking2: '/internal/workstation/inventory/blankOrder/package/tracking2/:context/:facility'
	        }
	      },
	      blankOrderItem: {
	        findByProductItem: '/internal/workstation/inventory/blankOrderItem/:productItemId/findByProductItem',
	        cancel: '/internal/workstation/inventory/blankOrderItem/:blankOrderItemId/cancel'
	      },
	      shortage: {
	        base: '/internal/workstation/inventory/shortage'
	      },
	      orders: {
	        base: '/internal/workstation/inventory/orders'
	      },
	      dock: {
	        base: '/internal/workstation/inventory/dock',
	        prime: '/internal/workstation/inventory/primeDock'
	      },
	      dock2: {
	        ups: '/internal/workstation/inventory/dock2/ups',
	        truckline: '/internal/workstation/inventory/dock2/truckline',
	        primeInventory: '/internal/workstation/inventory/dock2/primeInventory',
	        primePick: '/internal/workstation/inventory/dock2/primePick'
	      },
	      swap: {
	        base: '/internal/workstation/inventory/swap'
	      },
	      receiving: {
	        base: '/internal/workstation/inventory/receiving',
	        base2: '/internal/workstation/inventory/receiving2'
	      },
	      extraInventory: {
	        base: '/internal/workstation/inventory/extraInventory'
	      },
	      extraStickers: {
	        base: '/internal/workstation/inventory/extraStickers'
	      },
	      storing: {
	        screenprint: '/internal/workstation/inventory/storing/screenprint',
	        preprint: '/internal/workstation/inventory/storing/preprint'
	      },
	      sort: {
	        screenprint: '/internal/workstation/inventory/sort/screenprint',
	        preprint: '/internal/workstation/inventory/sort/preprint',
	        exception: '/internal/workstation/inventory/sort/exception'
	      },
	      pull: {
	        dtg: '/internal/workstation/inventory/pullDtg',
	        dtg2: '/internal/workstation/inventory/pullDtg2',
	        screenprint: '/internal/workstation/inventory/pullScreenprint',
	        screenprint2: '/internal/workstation/inventory/pullScreenprint2',
	        embr: '/internal/workstation/inventory/pullEmbr',
	        embr2: '/internal/workstation/inventory/pullEmbr2',
	        status: '/internal/workstation/inventory/pull/status'
	      },
	      pick: {
	        base: '/internal/workstation/inventory/pick'
	      },
	      missing: {
	        list: '/internal/workstation/inventory/missing'
	      },
	      csv: {
	        prime: '/internal/workstation/inventory/primeCSV'
	      }
	    },
	    shipping: {
	      base: '/internal/workstation/shipping',
	      base2: '/internal/workstation/shipping2',
	      bulk: '/internal/workstation/shipping/bulk',
	      scan: '/internal/workstation/shipping/scan',
	      barcode: '/internal/workstation/shipping/barcode/:barcode',
	      label: '/internal/workstation/shipping/:formId/label',
	      print: '/internal/workstation/shipping/print',
	      printShippingForm: '/internal/workstation/shipping/shippingForm/:shippingFormId/print',
	      ship: '/internal/workstation/shipping/shippingForm/:shippingFormId/ship',
	      splitShip: '/internal/workstation/shipping/shippingForm/:shippingFormId/splitShip',
	      shipList: {
	        base: '/internal/workstation/shipping/shipList'
	      },
	      short: {
	        activate: '/internal/workstation/shipping/shippingForm/:shippingFormId/shortActivate',
	        init: '/internal/workstation/shipping/shippingForm/:shippingFormId/shortInit',
	        confirm: '/internal/workstation/shipping/shippingForm/:shippingFormId/shortConfirm'
	      },
	      shippingForm: {
	        base: '/internal/workstation/shippingForm',
	        tracking: '/internal/workstation/shippingForm/tracking',
	        shippingCode: '/internal/workstation/shippingForm/:shippingFormId/shippingCode',
	        shippingBilling: '/internal/workstation/shippingForm/:shippingFormId/shippingBilling',
	        "void": '/internal/workstation/shippingForm/:shippingFormId/void',
	        unship: '/internal/workstation/shippingForm/:shippingFormId/unship',
	        cancel: '/internal/workstation/shippingForm/:shippingFormId/cancel',
	        barcode: '/internal/workstation/shippingForm/:shippingFormId/barcode',
	        bulkCancelOrUpdateSLA: '/internal/workstation/shippingForm/:shippingFormId/bulkCancelOrUpdateSLA',
	        bulkUpdateSLA: '/internal/workstation/shippingForm/:shippingFormId/bulkUpdateSLA',
	        instructions: '/internal/workstation/shippingForm/:shippingFormId/instructions'
	      },
	      force: '/internal/workstation/shipping/force'
	    },
	    report: {
	      base: '/internal/workstation/report'
	    },
	    reship: {
	      base: '/internal/workstation/reship',
	      check: '/internal/workstation/reship/check',
	      create: '/internal/workstation/reship/create',
	      checkBin: '/internal/workstation/reship/checkBin',
	      barcode: {
	        "return": '/internal/workstation/reship/barcode/:barcode/return',
	        check: '/internal/workstation/reship/barcode/:barcode/check'
	      },
	      expired: '/internal/workstation/reship/:reshipId/expired',
	      confirm: '/internal/workstation/reship/:reshipId/confirm'
	    },
	    dtg: {
	      base3: '/internal/workstation/dtg3',
	      print: '/internal/workstation/dtg/print',
	      notify: '/internal/workstation/dtg/notify',
	      rips: '/internal/workstation/dtg/barcode/:barcode/rips',
	      barcode: '/internal/workstation/dtg/barcode/:barcode',
	      pretreat: {
	        productItem: '/internal/workstation/dtg/pretreat/productItem/:productItemId'
	      },
	      rip2: {
	        barcode: '/internal/workstation/dtg/rip2/barcode/:barcode',
	        artwork: '/internal/workstation/dtg/rip2/:ripId/artwork',
	        detail: '/internal/workstation/dtg/rip2/:ripId/detail',
	        history: '/internal/workstation/dtg/rip2/:ripId/history',
	        hardReset: '/internal/workstation/dtg/rip2/:ripId/hardReset'
	      },
	      rip: {
	        download: '/internal/workstation/dtg/rip/:printId/download',
	        rerip: '/internal/workstation/dtg/rip/:printId/rerip',
	        debug: '/internal/workstation/dtg/rip/:printId/debug',
	        artwork: '/internal/workstation/dtg/rip/:printId/artwork',
	        enqueue: '/internal/workstation/dtg/rip/enqueue'
	      },
	      ripProfile: {
	        detail: '/internal/dashbord2/workstation/dtg/ripProfile/:ripProfileId',
	        search: '/internal/dashbord2/workstation/dtg/ripProfile/-/search',
	        bulkById: '/internal/dashbord2/workstation/dtg/ripProfile/bulkById'
	      },
	      cart: '/internal/workstation/dtg/cart',
	      pallet: '/internal/workstation/dtg/pallet',
	      qc: {
	        base: '/internal/workstation/dtg/qc',
	        base3: '/internal/workstation/dtg/qc3',
	        report: '/internal/workstation/dtg/qc/report',
	        escalate: '/internal/workstation/dtg/qc/escalate',
	        countRejects: '/internal/workstation/dtg/qc/countRejects',
	        escalateReason: '/internal/workstation/dtg/qc/escalateReason'
	      },
	      artwork2: '/internal/workstation/dtg/artwork2'
	    },
	    pretreat: {
	      base4: '/internal/workstation/pretreat4',
	      viper: '/internal/workstation/pretreat/viper',
	      synergy: '/internal/workstation/pretreat/synergy'
	    },
	    custom: {
	      base: '/internal/workstation/custom',
	      barcode: '/internal/workstation/custom/barcode/:barcode',
	      complete: '/internal/workstation/custom/:formId/complete',
	      printPart: '/internal/workstation/custom/printPart'
	    },
	    qc: {
	      base: '/internal/workstation/qc',
	      accept: '/internal/workstation/qc/:orderPartId/accept',
	      reject: '/internal/workstation/qc/:orderPartId/reject',
	      photo: '/internal/workstation/qc/:orderPartId/',
	      spot: '/internal/workstation/qc/spot'
	    },
	    rack2: {
	      store: '/internal/workstation/rack/:rackId/bin/:bin/store',
	      transfer: '/internal/workstation/rack/:rackId/bin/:bin/transfer',
	      remove: '/internal/workstation/rack/:rackId/bin/:bin/remove',
	      storeInstruction: '/internal/workstation/rack2/:rackId/storeInstruction',
	      marshalStatus: '/internal/workstation/rack2/:rackId/marshalStatus',
	      shippingStatus: '/internal/workstation/rack2/:rackId/shippingStatus',
	      marshalDirectInstruction: '/internal/workstation/rack2/marshalDirectInstruction',
	      marshalInstruction: '/internal/workstation/rack2/:rackId/bin/:bin/marshalInstruction',
	      retrieveInstruction: '/internal/workstation/rack2/:rackId/retrieveInstruction',
	      product: {
	        storeInstruction: '/internal/workstation/rack/product/storeInstruction',
	        store: '/internal/workstation/rack/:rackId/bin/:bin/product/store',
	        update: '/internal/workstation/rack/:rackId/bin/:bin/product/update',
	        uploadCSV: '/internal/workstation/rack/product/uploadCSV/:facility',
	        parseCSV: '/internal/workstation/rack/product/parseCSV/:facility',
	        assign: '/internal/workstation/rack/product/assign',
	        remove: '/internal/workstation/rack2/:rackId/bin/:bin/product/remove'
	      },
	      overflowSort: {
	        storeInstruction: '/internal/workstation/rack/overflowSort/rack/:rackId/storeInstruction',
	        stage2Instruction: '/internal/workstation/rack/overflowSort/rack/:rackId/stage2Instruction',
	        empty: '/internal/workstation/rack/overflowSort/rack/:rackId/empty',
	        shippingStatus: '/internal/workstation/rack/overflowSort/rack/:rackId/shippingStatus'
	      }
	    },
	    rack: {
	      header: {
	        sticker: '/internal/workstation/rack/:rackId/header/sticker'
	      },
	      bin: {
	        base: '/internal/workstation/rack/bin',
	        sticker: '/internal/workstation/rack/:rackId/bin/sticker'
	      },
	      create: '/internal/workstation/rack/create',
	      "delete": '/internal/workstation/rack/delete',
	      empty: '/internal/workstation/rack/empty',
	      shipping: '/internal/workstation/rack/shipping',
	      shippingAutobag: '/internal/workstation/rack/shippingAutobag',
	      shippingSplit: '/internal/workstation/rack/shippingSplit',
	      store: {
	        exception: '/internal/workstation/rack/store/exception',
	        rackSortKickout: '/internal/workstation/rack/store/rackSortKickout'
	      },
	      reconcilePick: '/internal/workstation/rack/reconcilePick',
	      reconcile: '/internal/workstation/rack/reconcile',
	      marshal: '/internal/workstation/rack/marshal',
	      rejection: {
	        approve: '/internal/workstation/rack/rejection/approve'
	      },
	      missing: {
	        list: '/internal/workstation/rack/missing',
	        reports: '/internal/workstation/rack/missing/reports'
	      },
	      barcode: '/internal/workstation/rack/barcode/:barcode',
	      orderPart: {
	        base: '/internal/workstation/rack/orderPart',
	        location: '/internal/workstation/rack/orderPart/:orderPartId',
	        status: '/internal/workstation/rack/orderPart/:orderPartId/status',
	        overflowStatus: '/internal/workstation/rack/orderPart/:orderPartId/overflowStatus',
	        history: '/internal/workstation/rack/orderPart/:orderPartId/history',
	        kickoutResolve: '/internal/workstation/rack/orderPart/:orderPartId/kickoutResolve',
	        resticker: {
	          query: '/internal/workstation/rack/orderPart/resticker/query',
	          orderData: '/internal/workstation/rack/orderPart/resticker/orderData',
	          garments: '/internal/workstation/rack/orderPart/resticker/garments'
	        }
	      },
	      shipList: '/internal/workstation/rack/shipList'
	    },
	    product: {
	      base: '/internal/workstation/product',
	      edit: '/internal/workstation/product/edit'
	    },
	    productItem: {
	      base: '/internal/workstation/productItem',
	      tag: {
	        base: '/internal/workstation/productItem/tag',
	        edit: '/internal/workstation/productItem/tag/edit'
	      },
	      pretreat: {
	        base: '/internal/workstation/productItem/pretreat',
	        edit: '/internal/workstation/productItem/pretreat/edit'
	      },
	      embr: {
	        base: '/internal/workstation/productItem/embr',
	        edit: '/internal/workstation/productItem/embr/edit'
	      },
	      sizing: {
	        edit: '/internal/workstation/productItem/sizing/edit'
	      }
	    }
	  },
	  ping: {
	    base: '/internal/dashboard/ping'
	  },
	  tablet: {
	    base: '/internal/dashboard/tablet'
	  },
	  orderLog: {
	    track: '/internal/orderLog/track'
	  },
	  audit: {
	    barcodes: '/internal/audit/barcodes'
	  }
	};


/***/ }),

/***/ 256:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/internal/dashboard2',
	  accessDenied: '/internal/dashboard2/accessDenied',
	  order: {
	    approvalStatus: {
	      base: '/internal/dashboard2/order/approvalStatus',
	      updateBypass: '/internal/dashboard2/order/approvalStatus/updateBypass'
	    }
	  },
	  design: {
	    mockupTemplate: {
	      qc: {
	        base: '/internal/dashboard2/design/mockupTemplate/qc',
	        job: '/internal/dashboard2/design/mockupTemplate/qc/job',
	        accept: '/internal/dashboard2/design/mockupTemplate/qc/accept',
	        reject: '/internal/dashboard2/design/mockupTemplate/qc/reject'
	      }
	    },
	    artwork: {
	      hold: '/internal/dashboard2/design/artwork/hold'
	    }
	  },
	  workstation: {
	    orderPartRelease: {
	      base: '/internal/dashboard2/workstation/orderPartRelease'
	    },
	    assemblyRelease: {
	      base: '/internal/dashboard2/workstation/assemblyRelease'
	    },
	    blacklist: {
	      base: '/internal/dashboard2/workstation/blacklist',
	      search: '/internal/dashboard2/workstation/blacklist/search',
	      "delete": '/internal/dashboard2/workstation/blacklist/:id'
	    },
	    accountingReports: {
	      base: '/internal/dashboard2/workstation/accountingReports'
	    },
	    postcard: {
	      base: '/internal/dashboard2/workstation/postcard',
	      data: {
	        preview: '/internal/dashboard2/workstation/postcard/preview',
	        print: '/internal/dashboard2/workstation/postcard/print'
	      }
	    },
	    facility: {
	      base: '/internal/dashboard2/workstation/facility'
	    },
	    timeClockDashboard: {
	      base: '/internal/dashboard2/workstation/timeClockDashboard'
	    },
	    employeeShiftDetails: {
	      base: '/internal/dashboard2/workstation/employeeShiftDetails'
	    },
	    simpleActionTracker: {
	      base: '/internal/dashboard2/workstation/simpleActionTracker'
	    },
	    facilityShift: {
	      base: '/internal/dashboard2/workstation/facilityShift',
	      search: '/internal/dashboard2/workstation/facilityShift/search',
	      detail: '/internal/dashboard2/workstation/facilityShift/:shiftId'
	    },
	    orderFormRun: {
	      activeList: {
	        base: '/internal/dashboard2/workstation/orderFormRun/activeList'
	      }
	    },
	    productItem: {
	      dtg: '/internal/dashboard2/workstation/productItem/dtg'
	    },
	    qc: {
	      base: '/internal/dashboard2/workstation/qc',
	      escalated: '/internal/dashboard2/workstation/qcEscalated',
	      audit: '/internal/dashboard2/workstation/qcAudit',
	      auditManager: '/internal/dashboard2/workstation/qcAuditManager',
	      bulk: '/internal/dashboard2/workstation/qc/bulk'
	    },
	    holdList: {
	      base: '/internal/dashboard2/workstation/holdList/:type',
	      query: '/internal/dashboard2/workstation/holdList/query'
	    },
	    customization: {
	      foldSort: '/internal/dashboard2/workstation/customization/foldSort',
	      rackScan: '/internal/dashboard2/workstation/customization/rackScan'
	    },
	    dtg: {
	      printFail: {
	        base: '/internal/dashboard2/workstation/dtg/printFail',
	        base2: '/internal/dashboard2/workstation/dtg/printFail2',
	        log: '/internal/dashboard2/workstation/dtg/printFail/:barcode/log'
	      },
	      rip: {
	        hold: '/internal/dashboard2/workstation/dtg/:printId/hold/:ripId'
	      },
	      rip2: {
	        hold: '/internal/dashboard2/workstation/dtg/:ripId/hold',
	        expedite: '/internal/dashboard2/workstation/dtg/:ripId/expedite',
	        reset: '/internal/dashboard2/workstation/dtg/:ripId/reset'
	      },
	      holdList: {
	        base: '/internal/dashboard2/workstation/dtg/holdList',
	        base2: '/internal/dashboard2/workstation/dtg/holdList2'
	      },
	      orderPart: {
	        status: '/internal/dashboard2/workstation/dtg/orderPart/:barcode/status',
	        status2: '/internal/dashboard2/workstation/dtg/orderPart/:barcode/status2',
	        expedite: '/internal/dashboard2/workstation/dtg/orderPart/:barcode/expedite'
	      },
	      qc: {
	        bulk: '/internal/dashboard2/workstation/dtg/qc/bulk'
	      },
	      ripProfileManager: {
	        base: '/internal/dashboard2/workstation/dtg/ripProfileManager'
	      }
	    },
	    screenprint: {
	      qc: '/internal/dashboard2/workstation/screenprint/qc',
	      qc2: '/internal/dashboard2/workstation/screenprint/qc2',
	      setup: {
	        base: '/internal/dashboard2/workstation/screenprint/setup'
	      }
	    },
	    rack: {
	      order: {
	        activateShortPull: '/internal/dashboard2/workstation/rack/order/activateShortPull'
	      },
	      rackSort: {
	        base: '/internal/dashboard2/workstation/rack/rackSort',
	        storeInstruction: '/internal/dashboard2/workstation/rack/rackSort/storeInstruction'
	      },
	      reBin: {
	        base: '/internal/dashboard2/workstation/rack/reBin',
	        remove: '/internal/dashboard2/workstation/rack/reBin/gaylord/:gaylordId/remove',
	        shippingForms: '/internal/dashboard2/workstation/rack/reBin/rack/:rackId/shippingForms',
	        gaylords: '/internal/dashboard2/workstation/rack/reBin/gaylords'
	      },
	      reconcile: {
	        base: '/internal/dashboard2/workstation/rack/reconcile'
	      },
	      inventoryMarshal: {
	        base: '/internal/dashboard2/workstation/rack/inventoryMarshal'
	      },
	      orderPart2: {
	        base: '/internal/dashboard2/workstation/rack/orderPart2',
	        barcode: '/internal/dashboard2/workstation/rack/orderPart2/barcode/:barcode'
	      }
	    },
	    storageRack: {
	      manager: '/internal/dashboard2/workstation/storageRack/manager',
	      reconcile: '/internal/dashboard2/workstation/storageRack/reconcile',
	      binInfo: '/internal/dashboard2/workstation/storageRack/binInfo'
	    },
	    inventory: {
	      adjustment: {
	        base: '/internal/dashboard2/workstation/inventory/adjustment'
	      },
	      primeInventory: {
	        base: '/internal/dashboard2/workstation/inventory/primeInventory'
	      },
	      primeInventoryStatus: {
	        base: '/internal/dashboard2/workstation/inventory/primeInventoryStatus'
	      },
	      manualOrder: {
	        base: '/internal/dashboard2/workstation/inventory/manualOrder'
	      },
	      supplementaryFetchList: {
	        base: '/internal/dashboard2/workstation/inventory/supplementaryFetchList'
	      }
	    },
	    shipping: {
	      shortShipList: {
	        base: '/internal/dashboard2/workstation/shipping/shortShipList'
	      },
	      bulk2: {
	        base: '/internal/dashboard2/workstation/shipping/bulk2'
	      },
	      dhlManifest: {
	        base: '/internal/dashboard2/workstation/shipping/dhlManifest'
	      },
	      autobag: {
	        base: '/internal/dashboard2/workstation/shipping/autobag'
	      },
	      customSingle: {
	        base: '/internal/dashboard2/workstation/shipping/customSingle'
	      },
	      customRack: {
	        base: '/internal/dashboard2/workstation/shipping/customRack'
	      },
	      shipList2: {
	        base: '/internal/dashboard2/workstation/shipping/shipList2'
	      },
	      custom: {
	        base: '/internal/dashboard2/workstation/shipping/custom'
	      },
	      bulk: {
	        base: '/internal/dashboard2/workstation/shipping/bulk'
	      }
	    },
	    internetStatus: {
	      base: '/internal/dashboard2/workstation/internetStatus'
	    },
	    whitelistIp: {
	      base: '/internal/dashboard2/workstation/whitelistIp',
	      aws: '/internal/dashboard2/workstation/whitelistIp/aws',
	      ooShirts: '/internal/dashboard2/workstation/whitelistIp/ooShirts'
	    },
	    orderApproval: {
	      embr: {
	        digitizable: {
	          base: '/internal/dashboard2/workstation/orderApproval/embr/digitizable',
	          accept: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/accept',
	          reject: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/reject',
	          job: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/job'
	        }
	      },
	      screenprintable: {
	        base: '/internal/dashboard2/workstation/orderApproval/screenprintable',
	        accept: '/internal/dashboard2/workstation/orderApproval/screenprintable/accept',
	        reject: '/internal/dashboard2/workstation/orderApproval/screenprintable/reject',
	        job: '/internal/dashboard2/workstation/orderApproval/screenprintable/job'
	      },
	      address: {
	        base: '/internal/dashboard2/workstation/orderApproval/address',
	        accept: '/internal/dashboard2/workstation/orderApproval/address/accept',
	        reject: '/internal/dashboard2/workstation/orderApproval/address/reject',
	        job: '/internal/dashboard2/workstation/orderApproval/address/job'
	      }
	    },
	    artworkApproval: {
	      queuejobs: {
	        base: '/internal/dashboard2/workstation/artworkApproval/queuejobs',
	        query: '/internal/dashboard2/workstation/artworkApproval/queuejobs/query',
	        cancel: '/internal/dashboard2/workstation/artworkApproval/queuejobs/cancel',
	        prioritize: '/internal/dashboard2/workstation/artworkApproval/queuejobs/prioritize'
	      },
	      embr: {
	        history: '/internal/dashboard2/workstation/orderApproval/embr/digitizable/history',
	        production: {
	          base: '/internal/dashboard2/workstation/artworkApproval/embr/production',
	          job: '/internal/dashboard2/workstation/artworkApproval/embr/production/job',
	          finish: '/internal/dashboard2/workstation/artworkApproval/embr/production/finish'
	        },
	        qc: {
	          base: '/internal/dashboard2/workstation/artworkApproval/embr/qc',
	          job: '/internal/dashboard2/workstation/artworkApproval/embr/qc/job',
	          accept: '/internal/dashboard2/workstation/artworkApproval/embr/qc/accept',
	          reject: '/internal/dashboard2/workstation/artworkApproval/embr/qc/reject'
	        },
	        cs: {
	          base: '/internal/dashboard2/workstation/artworkApproval/embr/cs',
	          job: '/internal/dashboard2/workstation/artworkApproval/embr/cs/job',
	          accept: '/internal/dashboard2/workstation/artworkApproval/embr/cs/accept',
	          reject: '/internal/dashboard2/workstation/artworkApproval/embr/cs/reject'
	        }
	      },
	      screenprint: {
	        production: {
	          base: '/internal/dashboard2/workstation/artworkApproval/screenprint/production',
	          job: '/internal/dashboard2/workstation/artworkApproval/screenprint/production/job',
	          finish: '/internal/dashboard2/workstation/artworkApproval/screenprint/production/finish'
	        },
	        qc: {
	          base: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc',
	          job: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc/job',
	          accept: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc/accept',
	          reject: '/internal/dashboard2/workstation/artworkApproval/screenprint/qc/reject'
	        },
	        cs: {
	          base: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs',
	          job: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs/job',
	          accept: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs/accept',
	          reject: '/internal/dashboard2/workstation/artworkApproval/screenprint/cs/reject'
	        }
	      },
	      dtg: {
	        production: {
	          base: '/internal/dashboard2/workstation/artworkApproval/dtg/production',
	          job: '/internal/dashboard2/workstation/artworkApproval/dtg/production/job',
	          finish: '/internal/dashboard2/workstation/artworkApproval/dtg/production/finish'
	        },
	        qc: {
	          base: '/internal/dashboard2/workstation/artworkApproval/dtg/qc',
	          job: '/internal/dashboard2/workstation/artworkApproval/dtg/qc/job',
	          accept: '/internal/dashboard2/workstation/artworkApproval/dtg/qc/accept',
	          reject: '/internal/dashboard2/workstation/artworkApproval/dtg/qc/reject'
	        },
	        cs: {
	          base: '/internal/dashboard2/workstation/artworkApproval/dtg/cs',
	          job: '/internal/dashboard2/workstation/artworkApproval/dtg/cs/job',
	          accept: '/internal/dashboard2/workstation/artworkApproval/dtg/cs/accept',
	          reject: '/internal/dashboard2/workstation/artworkApproval/dtg/cs/reject'
	        }
	      }
	    },
	    embr: {
	      detail: '/internal/dashboard2/workstation/embr/:embrId/detail',
	      logs: '/internal/dashboard2/workstation/embr/:embrId/logs',
	      holdList: {
	        base: '/internal/dashboard2/workstation/embr/holdList'
	      },
	      artwork: {
	        base: '/internal/dashboard2/workstation/embr/artwork'
	      },
	      hooping: {
	        base: '/internal/dashboard2/workstation/embr/hooping'
	      },
	      hooping2: {
	        base: '/internal/dashboard2/workstation/embr/hooping2'
	      },
	      change: {
	        base: '/internal/dashboard2/workstation/embr/change'
	      },
	      threadLocator: {
	        base: '/internal/dashboard2/workstation/embr/threadLocator'
	      },
	      stitch: {
	        base: '/internal/dashboard2/workstation/embr/stitch'
	      },
	      stitch2: {
	        base: '/internal/dashboard2/workstation/embr/stitch2'
	      },
	      fail: {
	        base: '/internal/dashboard2/workstation/embr/fail',
	        log: '/internal/dashboard2/workstation/embr/fail/:barcode/log'
	      },
	      reset: '/internal/dashboard2/workstation/embr/:embrId/reset',
	      release: '/internal/dashboard2/workstation/embr/:embrId/release',
	      hold: '/internal/dashboard2/workstation/embr/:embrId/hold',
	      updateDesign: '/internal/dashboard2/workstation/embr/:printEmbrId/updateDesign',
	      expedite: '/internal/dashboard2/workstation/embr/:embrId/expedite',
	      approval: {
	        job: '/internal/dashboard2/workstation/embr/job',
	        approve: '/internal/dashboard2/workstation/embr/:embrId/approve',
	        reject: '/internal/dashboard2/workstation/embr/:embrId/reject'
	      },
	      updateColors: '/internal/dashboard2/workstation/embr/:embrId/updateColors',
	      matrix2: {
	        jobSheet: '/internal/dashboard2/workstation/embr/matrix2/jobSheet'
	      }
	    },
	    autoprint: {
	      staging: {
	        base: '/internal/dashboard2/workstation/autoprint/staging'
	      },
	      print: '/internal/dashboard2/workstation/autoprint/print',
	      printer: {
	        base: '/internal/dashboard2/workstation/autoprint/printer'
	      },
	      activeSheetList: {
	        base: '/internal/dashboard2/workstation/autoprint/activeSheetList'
	      },
	      p0manager: {
	        base: '/internal/dashboard2/workstation/autoprint/p0manager'
	      },
	      artwork: {
	        base: '/internal/dashboard2/workstation/autoprint/artwork'
	      }
	    },
	    digitization: {
	      base: '/internal/dashboard2/workstation/digitization',
	      production: {
	        base: '/internal/dashboard2/workstation/digitization/production',
	        job: '/internal/dashboard2/workstation/digitization/production',
	        finish: '/internal/dashboard2/workstation/digitization/production'
	      },
	      qc: '/internal/dashboard2/workstation/digitization/qc'
	    },
	    orderForm: {
	      base: '/internal/dashboard2/workstation/orderForm'
	    },
	    boxInfo: {
	      base: '/internal/dashboard2/workstation/boxInfo'
	    },
	    mockupTemplate: {
	      base: '/internal/dashboard2/workstation/mockupTemplate'
	    },
	    queueJobInfo: {
	      base: '/internal/dashboard2/workstation/queueJobInfo'
	    },
	    statusCheck: {
	      base: '/internal/dashboard2/workstation/statusCheck'
	    },
	    receivingExtractor: {
	      base: '/internal/dashboard2/workstation/receivingExtractor'
	    },
	    assembly: {
	      queue: '/internal/dashboard2/workstation/assembly/queue',
	      info: '/internal/dashboard2/workstation/assembly/info',
	      receiving: '/internal/dashboard2/workstation/assembly/receiving',
	      rejections: '/internal/dashboard2/workstation/assembly/rejections',
	      labeling: '/internal/dashboard2/workstation/assembly/labeling'
	    },
	    preprint: {
	      presort: '/internal/dashboard2/workstation/preprint/presort',
	      putAway: '/internal/dashboard2/workstation/preprint/putAway',
	      sort: '/internal/dashboard2/workstation/preprint/sort',
	      sortBlankOrder: '/internal/dashboard2/workstation/preprint/sortBlankOrder',
	      carting: '/internal/dashboard2/workstation/preprint/carting',
	      store: '/internal/dashboard2/workstation/preprint/store',
	      pull: '/internal/dashboard2/workstation/preprint/pull'
	    },
	    marshal: {
	      store: '/internal/dashboard2/workstation/marshal/store',
	      storeBulk: '/internal/dashboard2/workstation/marshal/storeBulk'
	    }
	  },
	  netsuite: {
	    accountingReports: {
	      enqueue: '/internal/dashboard2/netsuite/accountingReports/enqueue',
	      base: '/internal/dashboard2/netsuite/accountingReports'
	    }
	  },
	  info: {
	    viewPricing: {
	      base: '/internal/dashboard2/info/viewPricing'
	    }
	  },
	  employee: {
	    roleManager: {
	      base: '/internal/dashboard2/employee/roleManager'
	    }
	  },
	  tools: {
	    featureFlag: {
	      base: '/internal/dashboard2/tools/featureFlag',
	      gql: {
	        featureFlagById: '/internal/dashboard2/toosl/featureFlag/gql/featureFlagById/:featureFlagId',
	        featureFlagStatus: '/internal/dashboard2/tools/featureFlag/gql/featureFlagStatus/:featureFlagId',
	        searchFeatureFlags: '/internal/dashboard2/tools/featureFlag/gql/searchFeatureFlags',
	        featureFlagsByIds: '/internal/dashboard2/tools/featureFlag/gql/featureFlagsByIds',
	        createFeatureFlag: '/internal/dashboard2/tools/featureFlag/gql/createFeatureFlag',
	        updateFeatureFlagById: '/internal/dashboard2/tools/featureFlag/gql/updateFeatureFlagById/:featureFlagId',
	        deleteFeatureFlagById: '/internal/dashboard2/tools/featureFlag/gql/deleteFeatureFlagById/:featureFlagId',
	        searchFeatureFlagScopes: '/internal/dashboard2/tools/featureFlag/gql/searchFeatureFlagScopes'
	      }
	    }
	  }
	};


/***/ }),

/***/ 257:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/ecommerce',
	  auth: {
	    init: '/ecommerce/:platform/init',
	    finish: '/ecommerce/:platform/finish',
	    escapeFrame: 'ecommerce/escapeFrame'
	  },
	  health: '/ecommerce/health',
	  dashboard: {
	    base: '/ecommerce/dashboard',
	    product: {
	      base: '/ecommerce/dashboard/products',
	      link: '/ecommerce/dashboard/products/link',
	      linkShopifyAccess: '/ecommerce/dashboard/products/link/shopify/access'
	    },
	    order: {
	      base: '/ecommerce/dashboard/orders',
	      external: {
	        base: '/ecommerce/dashboard/orders/external/:platform',
	        detail: '/ecommerce/dashboard/orders/external/:platform/:orderId',
	        detailShopifyAccess: '/ecommerce/dashbaord/orders/external/detail/shopify/access'
	      }
	    },
	    unlink: {
	      base: '/ecommerce/dashboard/unlink',
	      platform: '/ecommerce/dashboard/:platform/unlink'
	    }
	  },
	  data: {
	    item: {
	      base: '/ecommerce/data/items',
	      bulkByVariantId: '/ecommerce/data/items/bulkByVariantId',
	      ecomProducts: {
	        base: '/ecommerce/data/items/ecomProducts',
	        variants: '/ecommerce/data/items/ecomProducts/:ecomProductId'
	      },
	      count: '/ecommerce/data/items/count',
	      defaults: '/ecommerce/data/items/defaults',
	      bulk: '/ecommerce/data/items/bulk',
	      detail: '/ecommerce/data/items/:itemId',
	      unlink: '/ecommerce/data/items/unlink',
	      "new": '/ecommerce/data/items/new'
	    },
	    lineItem: {
	      bulk: '/ecommerce/data/lineItem/bulk',
	      bulkByLineItemId: '/ecommerce/data/lineItem/bulkByLineItemId',
	      list: '/ecommerce/data/lineItem/list',
	      flow: '/ecommerce/data/lineItem/flow',
	      sync: '/ecommerce/data/lineItme/:platform/sync',
	      detail: '/ecommerce/data/lineItem/:lineItemId',
	      fulfill: {
	        search: '/ecommerce/lineItem/fulfill/search',
	        batch: '/ecommerce/lineItem/fulfill/batch'
	      }
	    },
	    external: {
	      products: '/ecommerce/data/:platform/shop/products',
	      orders: {
	        base: '/ecommerce/data/:platform/orders',
	        detail: '/ecommerce/data/:platform/orders/:orderId'
	      }
	    },
	    order: {
	      fetchDate: '/ecommerce/data/:platform/order/fetchDate'
	    },
	    collection: '/ecommerce/data/:platform/collection',
	    version: '/ecommerce/data/:platform/version'
	  },
	  webhooks: {
	    base: '/ecommerce/webhooks',
	    scalable: {
	      base: '/ecommerce/webhooks/scalable'
	    },
	    ecommerce: {
	      base: '/ecommerce/webhooks/:platform/:scope/:action',
	      orders: {
	        base: '/ecommerce/webhooks/orders',
	        create: '/ecommerce/webhooks/orders/create',
	        updated: '/ecommerce/webhooks/orders/updated',
	        cancelled: '/ecommerce/webhooks/orders/cancelled'
	      },
	      products: {
	        base: '/ecommerce/webhooks/products',
	        update: '/ecommerce/webhooks/products/update',
	        "delete": '/ecommerce/webhooks/products/delete'
	      }
	    }
	  }
	};


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/ecommerce/v2',
	  workshop: {
	    base: '/ecommerce/v2/workshop',
	    detail: '/ecommerce/v2/workshop/:eCommerceProductId'
	  },
	  confirmation: {
	    base: '/ecommerce/v2/confirmation',
	    detail: '/ecommerce/v2/confirmation/:eCommerceProductId'
	  },
	  mockup: {
	    base: '/ecommerce/v2/mockup'
	  },
	  submission: '/ecommerce/v2/submission/:jobId',
	  data: {
	    eCommerceProduct: {
	      base: '/ecommerce/v2/data/eCommerceProduct',
	      detail: '/ecommerce/v2/data/eCommerceProduct/:eCommerceProductId',
	      endProduct: '/ecommerce/v2/data/eCommerceProduct/:eCommerceProductId/endProduct',
	      submit: '/ecommerce/v2/data/eCommerceProduct/:eCommerceProductId/submit'
	    },
	    queueJob: '/ecommerce/v2/data/queueJob/:jobId'
	  }
	};


/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	module.exports = {
	  view: '/email/view/:jobId',
	  render: '/email/render',
	  unsubscribe: '/email/unsubscribe/:jobId'
	};


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	module.exports = {
	  machine: {
	    base: '/internal/embr/machine',
	    detail: '/internal/embr/machine/:machineName/detail',
	    stitch: '/internal/embr/machine/:machineName/stitch',
	    storage: {
	      check: '/internal/embr/machine/storage/check'
	    }
	  },
	  color: {
	    code: {
	      bulk: '/internal/embr/color/code/bulk'
	    }
	  },
	  zsk: {
	    prepareStitch: '/internal/embr/zsk/prepareStitch'
	  }
	};


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/internal/employee/',
	  detail: '/internal/employee/:employeeId',
	  track: '/internal/employee/:employeeId/track',
	  userTrack: '/internal/employee/user/track',
	  barcode: '/internal/employee/barcode/:barcode',
	  numberTrack: '/internal/employee/number/:number/track',
	  shift: {
	    base: '/internal/employee/shift',
	    edit: '/internal/employee/shift/:shiftId/edit',
	    "delete": '/internal/employee/shift/:shiftId/delete',
	    report: '/internal/employee/shift/:facility/report',
	    breaks: {
	      edit: '/internal/employee/shift/:shiftId/breaks/edit'
	    },
	    offtime: {
	      edit: '/internal/employee/shift/:shiftId/offtime/edit'
	    },
	    start: '/internal/employee/:employeeId/start',
	    end: '/internal/employee/:employeeId/end',
	    "break": '/internal/employee/:employeeId/break',
	    "return": '/internal/employee/:employeeId/return',
	    latest: '/internal/employee/:employeeId/latest'
	  },
	  fingerprint: {
	    enroll: '/internal/employee/fingerprint/number/:number/enroll',
	    verify: '/internal/employee/fingerprint/number/:number/verify'
	  },
	  employeeShift: {
	    query: '/internal/employee/employeeShift/query',
	    detail: '/internal/employee/employeeShift/:employeeShiftId'
	  },
	  employee: {
	    bulk: '/internal/employee/employee/bulk',
	    bulkByNumber: '/internal/employee/employee/bulkByNumber',
	    query: '/internal/employee/employee/query'
	  },
	  employeeLog: {
	    query: '/internal/employee/employeeLog/query',
	    detail: '/internal/employee/employeeLog/:employeeLogId',
	    bulkInsert: '/internal/employee/employeeLog/bulkInsert'
	  },
	  health: {
	    base: '/internal/employee/__health'
	  }
	};


/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	module.exports = {
	  gql: '/internal/featureFlag/gql'
	};


/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	module.exports = {
	  upload: '/internal/fileServer/upload',
	  health: '/internal/fileServer/health',
	  files: {
	    base: '/internal/fileServer/files',
	    file: '/internal/fileServer/files/:fileName'
	  }
	};


/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/graphql',
	  dashboard: '/graphql/dashboard',
	  service: '/graphql/:service',
	  dev: {
	    base: '/dev',
	    full: '/graphql/dev',
	    dashboard: '/graphql/dashboard/dev',
	    service: '/graphql/:service/dev'
	  },
	  health: {
	    base: '/graphql/__health',
	    metrics: '/graphql/__health/metrics'
	  }
	};


/***/ }),

/***/ 265:
/***/ (function(module, exports) {

	module.exports = {
	  brightstore: {
	    order: '/integrations/brightstore/order'
	  },
	  walmart: {
	    addToCart: '/integrations/walmart/addToCart'
	  }
	};


/***/ }),

/***/ 266:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/manager',
	  "new": '/manager/new',
	  order: {
	    base: '/manager/order',
	    detail: '/manager/order/:orderId',
	    cancel: '/manager/order/:orderId/cancel',
	    claim: '/manager/order/:orderId/claim',
	    changeAddress: '/manager/order/:orderId/changeAddress',
	    testWebhook: '/manager/order/:orderId/testWebhook'
	  },
	  cart: {
	    base: '/manager/cart',
	    bulk: '/manager/user/carts',
	    "delete": '/manager/user/cart/:cartId/delete'
	  },
	  reship: {
	    base: '/manager/reship',
	    list: '/manager/list',
	    detail: '/manager/reship/:reshipId/detail',
	    orderItems: '/manager/reship/:reshipId/orderItems',
	    request: '/manager/reship/:reshipId/request',
	    cancel: '/manager/reship/:reshipId/cancel',
	    view: '/manager/reship/:reshipId/view'
	  },
	  design: {
	    base: '/manager/design',
	    "new": '/manager/design/new',
	    detail: '/manager/design/:designId',
	    changeName: '/manager/design/:designId/changeName',
	    resolve: '/manager/design/:designId/resolve',
	    requestVectorization: '/manager/design/:designId/requestVectorization'
	  },
	  billing: {
	    base: '/manager/billing',
	    detail: '/manager/billing/:billingId',
	    transactions: '/manager/billing/:billingId/transactions',
	    transactionsReport: '/manager/billing/:billingId/transactionsReport',
	    balance: '/manager/billing/:billingId/balance',
	    coupons: '/manager/billing/:billingId/coupons',
	    storeCredits: '/manager/billing/:billingId/storeCredits',
	    invoice: {
	      outstanding: '/manager/billing/:billingId/invoice/outstanding',
	      detail: '/manager/billing/:billingId/invoice/:invoiceId',
	      summary: '/manager/billing/:billingId/invoice/:invoiceId/summary',
	      withdraw: '/manager/billing/:billingId/invoice/:invoiceId/withdraw',
	      createCoupon: '/manager/billing/:billingId/invoice/createCoupon'
	    },
	    pay: '/manager/billing/:billingId/pay',
	    ach: {
	      base: '/manager/billing/:billingId/ach',
	      setup: '/manager/billing/:billingId/ach/setup',
	      verify: '/manager/billing/:billingId/ach/verify',
	      "delete": '/manager/billing/:billingId/ach/delete'
	    },
	    paypal: {
	      setup: '/manager/billing/:billingId/paypal/setup',
	      details: '/manager/billing/:billingId/paypal/details',
	      confirm: '/manager/billing/:billingId/paypal/confirm'
	    },
	    creditLineApplication: {
	      base: '/manager/billing/creditApplication',
	      "new": '/manager/billing/:billingId/creditApplication',
	      apply: '/manager/billing/:billingId/creditApplication',
	      update: '/manager/billing/:billingId/creditApplication/update',
	      status: '/manager/billing/:billingId/creditApplication/status',
	      tou: '/manager/billing/creditApplication/tou'
	    },
	    payment: {
	      detail: '/manager/billing/:billingId/payment/:transactionId',
	      summary: '/manager/billing/:billingId/payment/:transactionId/summary',
	      stripe: '/manager/billing/:billingId/payment/stripe',
	      paypal: '/manager/billing/:billingId/payment/paypal',
	      ach: '/manager/billing/:billingId/payment/ach',
	      credit: '/manager/billing/:billingId/payment/credit'
	    }
	  },
	  settings: {
	    base: '/manager/settings',
	    shipping: '/manager/settings/shipping',
	    autoSwap: '/manager/settings/autoSwap'
	  },
	  claim: {
	    base: '/manager/claim',
	    detail: '/manager/claim/:claimId'
	  },
	  upload: {
	    awsPolicy: '/manager/upload/awsPolicy'
	  }
	};


/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/manager/v2',
	  alpha: {
	    detail: '/manager/v2/alpha/detail/:widgetUser/order/:orderId',
	    list: '/manager/v2/alpha/list/:widgetUser',
	    deco: {
	      detail: '/manager/v2/alpha/deco/detail/order/:orderId',
	      list: '/manager/v2/alpha/deco/list'
	    }
	  },
	  order: {
	    base: '/manager/v2/orders',
	    drafts: '/manager/v2/orders/drafts',
	    detail: '/manager/v2/orders/:orderId',
	    approval: '/manager/v2/orders/:orderId/approval',
	    confirmed: '/manager/v2/orders/:orderId/confirmed',
	    bypassApproval: '/manager/v2/orders/:orderId/bypassApproval',
	    shipment: '/manager/v2/orders/:orderId/shipping-form/:shippingFormId',
	    claim: '/manager/v2/orders/:orderId/claim',
	    placeCsv: '/manager/v2/placeCsv'
	  },
	  claim: {
	    base: '/manager/v2/claims',
	    detail: '/manager/v2/claims/:claimId'
	  },
	  settings: {
	    account: '/manager/v2/settings/account',
	    api: '/manager/v2/settings/api',
	    general: '/manager/v2/settings/general',
	    subaccounts: '/manager/v2/settings/teams'
	  },
	  design: {
	    base: '/manager/v2/designs',
	    artwork: '/manager/v2/designs/artworks',
	    generator: '/manager/v2/designs/generator/embr'
	  },
	  printable: {
	    base: '/manager/v2/printables',
	    mask: '/manager/v2/printables/mask'
	  },
	  billing: {
	    base: '/manager/v2/billing',
	    balance: '/manager/v2/billing/:billingId/balance',
	    invoice: '/manager/v2/billing/:billingId/invoice/:invoiceId',
	    invoices: '/manager/v2/billing/:billingId/invoices',
	    invoiceStatement: '/manager/v2/billing/:billingId/invoiceStatement/:invoiceId',
	    transactions: '/manager/v2/billing/:billingId/transactions',
	    statement: '/manager/v2/billing/:billingId/statement',
	    paymentMethods: '/manager/v2/billing/:billingId/paymentMethods'
	  },
	  ecommerce: {
	    base: '/manager/v2/ecommerce'
	  },
	  catalog: {
	    base: '/manager/v2/catalog'
	  },
	  data: {
	    billing: {
	      withdraw: '/manager/v2/data/billing/:billingId/invoice/:invoiceId/withdraw',
	      withdrawBreakdown: '/manager/v2/data/billing/:billingId/invoice/:invoiceId/withdrawBreakdown',
	      invoiceDetails: '/manager/v2/data/billing/:billingId/invoice/:invoiceId/invoiceDetails',
	      invoicesOutstanding: '/manager/v2/data/billing/:billingId/invoicesOutstanding',
	      invoicesBulk: '/manager/v2/data/billing/:billingId/invoicesBulk',
	      invoicesCsv: '/manager/v2/data/billing/:billingId/invoicesCsv',
	      invoicesByPo: '/manager/v2/data/billing/:billingId/invoicePo',
	      invoiceStatement: {
	        base: '/manager/v2/data/billing/:billingId/invoiceStatement',
	        bulk: '/manager/v2/data/billing/:billingId/invoiceStatement/bulk'
	      },
	      storeCredits: '/manager/v2/billing/:billingId/storeCredits',
	      creditLineApplication: '/manager/v2/billing/:billingId/creditLineApplication',
	      payment: {
	        base: '/manager/v2/data/billing/:billingId/payment',
	        ach: '/manager/v2/data/billing/:billingId/payment/ach',
	        paypal: '/manager/v2/data/billing/:billingId/payment/paypal',
	        store: '/manager/v2/data/billing/:billingId/payment/store'
	      },
	      paypal: {
	        setup: '/manager/v2/data/billing/:billingId/payment/paypal/setup',
	        details: '/manager/v2/data/billing/:billingId/payment/paypal/details'
	      },
	      ach: {
	        base: '/manager/v2/data/billing/:billingId/ach',
	        setup: '/manager/v2/data/billing/:billingId/ach/setup',
	        verify: '/manager/v2/data/billing/:billingId/ach/verify',
	        "delete": '/manager/v2/data/billing/:billingId/ach/delete'
	      },
	      paymentMethods: {
	        base: '/manager/v2/data/billing/:billingId/paymentMethods',
	        create: '/manager/v2/data/billing/:billingId/paymentMethods/create',
	        update: '/manager/v2/data/billing/:billingId/paymentMethods/update',
	        "delete": '/manager/v2/data/billing/:billingId/paymentMethods/delete'
	      },
	      transactions: {
	        history: '/manager/v2/data/billing/:billingId/transactions/history',
	        historyCsv: '/manager/v2/data/billing/:billingId/transactions/historyCsv',
	        debits: '/manager/v2/data/billing/:billingId/transactions/debits',
	        credits: '/manager/v2/data/billing/:billingId/transactions/credits',
	        storeCredits: '/manager/v2/data/billing/:billingId/transactions/storeCredits'
	      },
	      cashback: {
	        breakdown: '/manager/v2/data/billing/:billingId/cashback/breakdown'
	      }
	    },
	    order: {
	      base: '/manager/v2/data/order',
	      csv: '/manager/v2/data/order/csv',
	      trackingCsv: '/manager/v2/data/:orderId/tracking/csv',
	      placeCsv: '/manager/v2/data/order/placeCsv',
	      placeOrder: '/manager/v2/data/order/placeOrder',
	      overview: '/manager/v2/data/order/overview',
	      counts: '/manager/v2/data/order/counts',
	      bulk: '/manager/v2/data/order/bulk',
	      detail: '/manager/v2/data/order/:orderId',
	      approve: '/manager/v2/data/order/:orderId/approve',
	      change: '/manager/v2/data/order/:orderId/change',
	      address: '/manager/v2/data/order/:orderId/address',
	      addressValidate: '/manager/v2/data/order/:orderId/addressValidate',
	      shippingPrices: '/manager/v2/data/order/:orderId/shipping-prices',
	      shippingMethod: '/manager/v2/data/order/:orderId/shipping-method',
	      shippingFormParts: '/manager/v2/data/order/:orderId/shippingFormParts/:shippingFormId',
	      alpha: {
	        list: '/manager/v2/data/order/alpha/list'
	      },
	      onHold: {
	        address: '/manager/v2/data/order/onHold/address',
	        ip: '/manager/v2/data/order/onHold/ip'
	      }
	    },
	    claim: {
	      base: '/manager/v2/data/claim',
	      csv: '/manager/v2/data/claim/csv'
	    },
	    user: {
	      detail: '/manager/v2/data/users/:userId'
	    },
	    employee: {
	      arRep: '/manager/v2/data/employee/:employeeId/arRep'
	    },
	    cart: {
	      base: '/manager/v2/data/carts',
	      detail: '/manager/v2/data/carts/:cartId'
	    },
	    artwork: {
	      base: '/manager/v2/data/artwork',
	      bulk: '/manager/v2/data/artwork/bulk'
	    },
	    design: {
	      base: '/manager/v2/data/designs',
	      bulk: '/manager/v2/data/designs/bulk',
	      editName: '/manager/v2/data/designs/:designId/editName'
	    },
	    printable: {
	      base: '/manager/v2/data/printables',
	      csv: '/manager/v2/data/printables/csv',
	      editName: '/manager/v2/data/printables/:printableId/editName',
	      bulk: '/manager/v2/data/printables/bulk',
	      group: {
	        base: '/manager/v2/data/printables/group',
	        editName: '/manager/v2/data/printables/group/:printableGroupId/editName',
	        editPrintables: '/manager/v2/data/printables/group/:printableGroupId/editPrintables'
	      }
	    },
	    pricing: {
	      base: '/manager/v2/data/pricing',
	      bulk: '/manager/v2/data/pricing/bulk'
	    },
	    approval: {
	      order: {
	        base: '/manager/v2/data/approval/order',
	        changeDesign: '/manager/v2/data/approval/order/changeDesign',
	        uploadRights: '/manager/v2/data/approval/order/uploadRights'
	      },
	      artwork: {
	        base: '/manager/v2/data/approval/artwork'
	      },
	      artworkApproval: {
	        base: '/manager/v2/data/approval/artworkApproval',
	        bulk: '/manager/v2/data/approval/artworkApproval/bulk'
	      },
	      artworkConversion: {
	        base: '/manager/v2/data/approval/artworkConversion',
	        bulk: '/manager/v2/data/approval/artworkConversion/bulk'
	      }
	    },
	    event: {
	      base: '/manager/v2/data/order/:orderId/events'
	    },
	    shippingForm: {
	      detail: '/manager/v2/data/shipping-forms/:shippingFormId',
	      bulk: '/manager/v2/data/shipping-forms/bulk',
	      prices: '/manager/v2/data/shipping-forms/:shippingFormId/prices',
	      byOrderId: '/manager/v2/data/shipping-forms/:shippingFormId/byOrderId'
	    },
	    productItem: {
	      bulk: '/manager/v2/data/product-items/bulk',
	      gtin: '/manager/v2/data/product-items/gtin/:gtin',
	      bestPrices: '/manager/v2/data/product-items/bestPrices',
	      priceMap: '/manager/v2/data/product-items/priceMap'
	    },
	    externalBlankOrder: {
	      detail: '/manager/v2/data/externalBlankOrder/:externalBlankOrderId/detail',
	      bulk: '/manager/v2/data/externalBlankOrder/bulk'
	    }
	  }
	};


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	module.exports = {
	  mockupTemplate: {
	    base: '/mockupQuery/mockupTemplate',
	    detail: '/mockupQuery/mockupTemplate/id/:mockupTemplateId',
	    byIdentifier: '/mockupQuery/mockupTemplate/byIdentifier/:identifier',
	    bulkByIdentifier: '/mockupQuery/mockupTemplate/bulkByIdentifier'
	  }
	};


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	module.exports = {
	  view: '/mockupServer/view/:templateIdentifier/:color/:size',
	  render: '/mockupServer/render/:templateIdentifier/:color/:designId/:size.jpg',
	  done: '/mockupServer/done',
	  clippingMask: '/mockupServer/clippingMask/:templateIdentifier',
	  v2: {
	    view: '/mockupServer/v2/view/:templateIdentifier/:side/:color/:size',
	    preview: '/mockupServer/v2/preview/:templateIdentifier/:side/:color/:size'
	  }
	};


/***/ }),

/***/ 270:
/***/ (function(module, exports) {

	module.exports = {
	  mockupTemplate: {
	    byIdentifier: '/mockupTools/mockupTemplate/byIdentifier/:identifier'
	  }
	};


/***/ }),

/***/ 271:
/***/ (function(module, exports) {

	module.exports = {
	  accountingReports: {
	    enqueue: '/netsuite/accountingReports/enqueue',
	    base: '/netsuite/accountingReports'
	  },
	  wms: {
	    order: {
	      submit: '/netsuite/wms/order/submit',
	      fulfill: '/netsuite/wms/order/fulfill'
	    }
	  }
	};


/***/ }),

/***/ 272:
/***/ (function(module, exports) {

	module.exports = {
	  cart: {
	    create: '/order/cart/create',
	    base: '/order/cart',
	    products: '/order/cart/:cartId/products',
	    shipping: '/order/cart/:cartId/shipping',
	    review: '/order/cart/:cartId/review',
	    detail: '/order/cart/:cartId',
	    patch: '/order/cart/:cartId/patch',
	    quote: '/order/cart/:cartId/quote',
	    place: '/order/cart/:cartId/place'
	  },
	  csv: {
	    template: '/order/csv/template.csv',
	    upload: '/order/csv/:cartId/upload'
	  },
	  order: {
	    confirm: '/order/:orderId/confirm',
	    base: '/order/order',
	    shopify: '/order/shopify',
	    ecommerce: '/order/ecommerce'
	  },
	  upload: {
	    awsPolicy: '/order/upload/awsPolicy'
	  },
	  artwork: {
	    render: {
	      artwork: {
	        base: '/order/artwork/render.png'
	      },
	      design: {
	        base: '/order/artwork/design/:designId/render.png'
	      },
	      proof: {
	        base: '/order/artwork/proof/render.png',
	        design: '/order/artwork/proof/design/:designId/render.png'
	      }
	    }
	  },
	  data: {
	    validateAddress: '/order/data/validateAddress',
	    billing: '/order/data/billing/:billingId'
	  }
	};


/***/ }),

/***/ 273:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/order/v2',
	  integrations: {
	    walmart: {
	      configurator: '/order/v2/integrations/walmart/configurator'
	    },
	    util: {
	      crop: '/order/v2/integrations/util/crop',
	      fit: '/order/v2/integrations/util/fit'
	    }
	  },
	  cart: {
	    base: '/order/v2/cart',
	    detail: '/order/v2/cart/:cartId',
	    checkout: {
	      base: '/order/v2/cart/:cartId/checkout',
	      quantity: '/order/v2/cart/:cartId/checkout/quantity',
	      shippingMethod: '/order/v2/cart/:cartId/checkout/shippingMethod',
	      review: '/order/v2/cart/:cartId/checkout/review'
	    },
	    confirmation: {
	      base: '/order/v2/cart/:cartId/confirmation'
	    },
	    printable: {
	      base: '/order/v2/cart/:cartId/printable',
	      detail: '/order/v2/cart/:cartId/printable/:printableId',
	      family: '/order/v2/cart/:cartId/printable/:printableId/family',
	      category: '/order/v2/cart/:cartId/printable/:printableId/category',
	      design: '/order/v2/cart/:cartId/printable/:printableId/design'
	    },
	    fromOrder: '/order/v2/cart/:orderId/fromOrder'
	  },
	  mockup: {
	    design: '/order/v2/mockup/design'
	  },
	  data: {
	    mockup: {
	      email: '/order/v2/data/mockup/email',
	      design: '/order/v2/data/mockup/:designId/design.png'
	    },
	    cart: {
	      base: '/order/v2/data/cart',
	      detail: '/order/v2/data/cart/:cartId',
	      address: {
	        base: '/order/v2/data/cart/:cartId/address',
	        update: '/order/v2/data/cart/:cartId/address/update'
	      },
	      share: '/order/v2/data/cart/:cartId/share',
	      place: '/order/v2/data/cart/:cartId/place',
	      quote: '/order/v2/data/cart/:cartId/quote',
	      finalize: '/order/v2/data/cart/:cartId/finalize'
	    },
	    csv: {
	      template: '/order/v2/data/csv/template',
	      upload: '/order/v2/data/csv/:cartId/upload'
	    },
	    shippingMethod: {
	      base: '/order/v2/data/shippingMethod'
	    },
	    address: {
	      base: '/order/v2/data/address',
	      validate: '/order/v2/data/address/validate',
	      save: '/order/v2/data/:userId/address/save',
	      bulk: '/order/v2/data/:userId/address/bulk'
	    },
	    order: {
	      detail: '/order/v2/data/order/:orderId'
	    },
	    dystar: {
	      detail: '/order/v2/data/dystar'
	    },
	    design: {
	      bulk: '/order/v2/data/design/bulk',
	      accessory: '/order/v2/data/design/accessory',
	      artwork: '/order/v2/data/design/artwork',
	      search: '/order/v2/data/design/search',
	      name: {
	        design: '/order/v2/data/design/name/design',
	        artwork: '/order/v2/data/design/name/artwork'
	      },
	      embr: {
	        colors: '/order/v2/data/design/embr/colors'
	      }
	    },
	    product: {
	      base: '/order/v2/data/product',
	      truckable: '/order/v2/data/product/:identifier/truckable',
	      prices: '/order/v2/data/product/:identifier/prices'
	    }
	  },
	  billing: {
	    balance: '/order/v2/data/billing/:billingId/balance'
	  },
	  shipping: '/order/v2/data/shipping',
	  proxy: {
	    router: {
	      sla: {
	        product: '/order/v2/proxy/router/sla/product/:productIdentifier',
	        productDetailed: '/order/v2/proxy/router/sla/productDetailed/:productIdentifier',
	        productItemBulk: '/order/v2/proxy/router/sla/productItemBulk'
	      },
	      order: {
	        base: '/order/v2/proxy/router/order'
	      }
	    },
	    shipping: {
	      times: '/order/v2/proxy/shipping/times'
	    }
	  }
	};


/***/ }),

/***/ 274:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/order/v3'
	};


/***/ }),

/***/ 275:
/***/ (function(module, exports) {

	module.exports = {
	  reroute: '/orderform/reroute',
	  thirdParty: {
	    mww: {
	      wrongAddress: '/orderform/thirdparty/mww/invalid/address',
	      validateAddress: '/orderform/thirdparty/mww/address/validate',
	      fixOrderFormAddress: '/orderform/thirdparty/mww/fixaddress'
	    }
	  }
	};


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

	module.exports = {
	  shipping: {
	    shortShip: '/packingSlip/shipping/shortShip.pdf'
	  }
	};


/***/ }),

/***/ 277:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/ping'
	};


/***/ }),

/***/ 278:
/***/ (function(module, exports) {

	module.exports = {
	  products: {
	    base: '/v2/products',
	    bulk: '/v2/products/bulk',
	    sizes: '/v2/products/sizes',
	    search: '/v2/products/search',
	    full: '/v2/products/full',
	    detail: '/v2/products/:identifier',
	    availability: '/v2/products/:identifier/availability',
	    tags: '/v2/products/:identifier/tags',
	    items: '/v2/products/:identifier/items',
	    eligibility: '/v2/products/:identifier/eligibility'
	  },
	  categories: {
	    base: '/v2/categories',
	    full: '/v2/categories/full',
	    detail: '/v2/categories/:identifier'
	  },
	  order: {
	    base: '/v2/order',
	    facility: '/v2/order/facility',
	    detail: '/v2/order/:orderId',
	    design: '/v2/order/:orderId/design',
	    cancelItem: '/v2/order/:orderId/cancelItem',
	    changeAddress: '/v2/order/:orderId/changeAddress',
	    changeWhitelabel: '/v2/order/:orderId/changeWhitelabel',
	    changeName: '/v2/order/:orderId/changeName',
	    changeShippingMethod: '/v2/order/:orderId/changeShippingMethod',
	    changeDesign: '/v2/order/:orderId/changeDesign',
	    reprint: '/v2/order/:orderId/reprint',
	    status: '/v2/order/:orderId/status'
	  },
	  reship: {
	    list: '/v2/reship',
	    detail: '/v2/reship/:reshipId',
	    request: '/v2/reship/:reshipId/request',
	    cancel: '/v2/reship/:reshipId/cancel'
	  },
	  quote: {
	    base: '/v2/quote',
	    bulk: '/v2/quote/bulk',
	    token: '/v2/quote/:orderToken',
	    route: '/v2/quote/facility/route'
	  },
	  design: {
	    base: '/v2/design',
	    bulk: '/v2/design/bulk',
	    detail: '/v2/design/:designId',
	    search: '/v2/design/search',
	    note: '/v2/design/:designId/note',
	    approval: {
	      order: {
	        revise: '/v2/design/:designId/approval/order/revise'
	      }
	    }
	  },
	  status: {
	    log: '/internal/status/log',
	    qc: '/internal/status/qc',
	    externalLog: '/internal/status/externalLog',
	    design: '/internal/status/design',
	    shippingWorkstation: '/internal/status/shippingWorkstation'
	  },
	  customization: {
	    base: '/v2/customization'
	  },
	  webhook: {
	    dispute: {
	      base: '/v2/print/webhook/dispute'
	    },
	    inboundEmail: {
	      base: '/v2/print/webhook/inboundEmail'
	    },
	    dtg2go: {
	      base: '/v2/print/webhook/dtg2go'
	    }
	  },
	  billing: {
	    balance: '/v2/billing/balance',
	    invoice: {
	      base: '/v2/billing/invoice',
	      detail: '/v2/billing/invoice/:invoiceId',
	      pay: {
	        paypal: '/v2/billing/invoice/:invoiceId/pay/paypal'
	      }
	    }
	  },
	  v3: {
	    shipping: {
	      base: '/v3/shipping',
	      thirdPartyShip: '/v3/shipping/thirdPartyShip',
	      option: {
	        base: '/v3/shipping/option'
	      }
	    },
	    tracking: '/v3/tracking/:trackingNumber',
	    address: {
	      validate: '/v3/address/validate',
	      validateMWW: '/v3/address/validateMWW'
	    },
	    event: {
	      base: '/v3/event',
	      detail: '/v3/event/:eventId'
	    },
	    order: {
	      base: '/v3/order',
	      facility: '/v3/order/facility',
	      detail: '/v3/order/:orderId',
	      changeAddress: '/v3/order/:orderId/changeAddress',
	      reprint: '/v3/order/:orderId/reprint',
	      item: {
	        base: '/v3/order/:orderId/item/:itemIndex',
	        event: '/v3/order/:orderId/item/:itemIndex/event'
	      },
	      event: {
	        base: '/v3/order/:orderId/event'
	      },
	      approval: {
	        base: '/v3/order/:orderId/approval'
	      },
	      updateProcessedDesigns: '/v3/order/:orderId/updateProcessedDesigns'
	    },
	    quote: {
	      base: '/v3/quote',
	      token: '/v3/quote/:orderToken'
	    },
	    mockup: {
	      base: '/v3/mockup',
	      blank: '/v3/mockup/blank/:template/:color.png',
	      clippingMask: '/v3/mockup/clippingMask/:template.png'
	    },
	    mockupTemplate: {
	      base: '/v3/mockup-template',
	      detail: '/v3/mockup-template/id/:mockupTemplateId',
	      byIdentifier: '/v3/mockup-template/byIdentifier',
	      bulkByIdentifier: '/v3/mockup-template/bulkByIdentifier'
	    },
	    artwork: {
	      base: '/v3/artwork',
	      search: '/v3/artwork/search',
	      detail: '/v3/artwork/:artworkId',
	      bulk: '/v3/artwork/bulk',
	      rights: '/v3/artwork/:artworkId/rights',
	      update: {
	        name: '/v3/artwork/:artworkId/update/name'
	      },
	      "delete": '/v3/artwork/:artworkId/delete',
	      actions: '/v3/artwork/:artworkId/actions',
	      design: {
	        "case": '/v3/artwork/design/case',
	        mug: '/v3/artwork/design/mug',
	        screenprint: '/v3/artwork/design/screenprint',
	        dtg: '/v3/artwork/design/dtg',
	        poster: '/v3/artwork/design/poster',
	        embr: '/v3/artwork/design/embr',
	        sublimation: '/v3/artwork/design/sublimation'
	      },
	      printability: {
	        base: '/v3/artwork/printability',
	        detail: '/v3/artwork/printability/:printabilityId',
	        bulk: '/v3/artwork/printability/bulk'
	      },
	      conversion: {
	        base: '/v3/artwork/conversion',
	        detail: '/v3/artwork/conversion/:conversionId',
	        bulk: '/v3/artwork/conversion/bulk',
	        embr: '/v3/artwork/:artworkId/conversion/embr'
	      }
	    },
	    products: {
	      detail: '/v3/products/:identifier',
	      filters: '/v3/products/filters',
	      search: '/v3/products/search',
	      rushQuantity: '/v3/products/rushQuantity'
	    },
	    categories: {
	      base: '/v3/categories',
	      detail: '/v3/categories/:identifier'
	    },
	    design: {
	      base: '/v3/design',
	      detail: '/v3/design/:designId'
	    },
	    invoice: {
	      base: '/v3/invoice',
	      detail: '/v3/invoice/:invoiceId'
	    },
	    billing: {
	      balance: '/v3/billing/balance'
	    },
	    customization: {
	      base: '/v3/customization'
	    },
	    printable: {
	      base: '/v3/printable',
	      detail: '/v3/printable/detail/:printableId',
	      bulk: '/v3/printable/bulk'
	    },
	    vendors: {
	      base: '/v3/vendors/:partner',
	      detail: '/v3/vendors/:partner/:identifier'
	    },
	    screenprint3pf: {
	      vendor: '/v3/screenprint3pf/vendors/:identifier',
	      vendors: '/v3/screenprint3pf/vendors'
	    }
	  },
	  proxy: {
	    artwork: {
	      data: {
	        colors: {
	          base: '/proxy/artwork/data/colors'
	        },
	        image: {
	          base: '/proxy/artwork/data/image'
	        }
	      }
	    },
	    infringement: {
	      detect: {
	        base: '/proxy/infringement/detect'
	      }
	    }
	  },
	  health: {
	    base: '/internal/__health',
	    metrics: '/internal/__health/metrics/'
	  }
	};


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	module.exports = {
	  print: {
	    raw: {
	      base: '/printer/raw',
	      bulk: '/printer/raw/bulk'
	    },
	    template: {
	      base: '/printer/template',
	      bulk: '/printer/template/bulk'
	    },
	    url: {
	      base: '/printer/url',
	      bulk: '/printer/url/bulk'
	    }
	  },
	  types: '/printer/types',
	  updater: {
	    update: '/printer/updater/update'
	  }
	};


/***/ }),

/***/ 280:
/***/ (function(module, exports) {

	module.exports = {
	  base: '/promoStandards',
	  inventory: {
	    base: '/promoStandards/inventory',
	    v_1_2_1: '/promoStandards/inventory/v_1_2_1',
	    v_2_0_0: '/promoStandards/inventory/v_2_0_0'
	  },
	  invoice: {
	    base: '/promoStandards/invoice',
	    v_0_0_1: '/promoStandards/invoice/v_0_0_1'
	  },
	  mediaContent: {
	    base: '/promoStandards/mediaContent',
	    v_1_1_0: '/promoStandards/mediaContent/v_1_1_0'
	  },
	  shipmentNotification: {
	    base: '/promoStandards/shipmentNotification',
	    v_1_0_0: '/promoStandards/shipmentNotification/v_1_0_0'
	  },
	  orderStatus: {
	    base: '/promoStandards/orderStatus',
	    v_1_0_0: '/promoStandards/orderStatus/v_1_0_0'
	  },
	  purchaseOrder: {
	    base: '/promoStandards/purchaseOrder',
	    v_1_0_0: '/promoStandards/purchaseOrder/v_1_0_0'
	  },
	  configuration: {
	    base: '/promoStandards/configuration',
	    v_1_0_0: '/promoStandards/configuration/v_1_0_0'
	  },
	  productData: {
	    base: '/promoStandards/productData',
	    v_1_0_0: '/promoStandards/productData/v_1_0_0'
	  }
	};


/***/ }),

/***/ 281:
/***/ (function(module, exports) {

	module.exports = {
	  artwork: {
	    holdList: '/query/artwork/holdList',
	    uploadImage: '/query/artwork/uploadImage',
	    hold: '/query/artwork/hold',
	    release: '/query/artwork/release'
	  },
	  autoPrinter: {
	    search: '/query/autoPrinter/search',
	    create: '/query/autoPrinter/create',
	    detail: '/query/autoPrinter/detail/:autoPrinterId'
	  },
	  autoprintSheet: {
	    detail: '/query/autoprintSheet/detail/:autoprintSheetId',
	    family: '/query/autoprintSheet/family/:autoprintSheetId',
	    status: '/query/autoprintSheet/status/:autoprintSheetId',
	    barcode: '/query/autoprintSheet/barcode/:barcode',
	    search: '/query/autoprintSheet/search',
	    next: '/query/autoprintSheet/next',
	    priorityCount: '/query/autoprintSheet/priorityCount',
	    prioritize: '/query/autoprintSheet/prioritize/:autoprintSheetId',
	    unprioritize: '/query/autoprintSheet/unprioritize/:autoprintSheetId',
	    stageByRip: '/query/autoprintSheet/stageByRip',
	    stageByOrderPart: '/query/autoprintSheet/stageByOrderPart',
	    priorityQueue: '/query/autoprintSheet/priorityQueue',
	    immediatePrint: '/query/autoprintSheet/immediatePrint/:autoprintSheetId'
	  },
	  autoprintRip: {
	    detail: '/query/autoprintRip/detail/:autoprintRipId',
	    bulkById: '/query/autoprintRip/bulkById'
	  },
	  blankOrderItem: {
	    createManual: '/query/blankOrderItem/createManual',
	    findActiveByOrderPart: '/query/blankOrderItem/findActiveByOrderPart/:orderPartId',
	    cancelByOrderPart: '/query/blankOrderItem/cancelByOrderPart',
	    bulkCancel: '/query/blankOrderItem/bulkCancel'
	  },
	  orderPartRejection: {
	    bulkCancel: '/query/orderPartRejection/bulkCancel',
	    bulkByOrderPartId: '/query/orderPartRejection/bulkByOrderPartId/:orderPartId'
	  },
	  box: {
	    barcode: '/query/box/barcode/:barcode',
	    bulkById: '/query/box/bulkById',
	    location: '/query/box/location/:location',
	    orderPartIds: '/query/box/orderPartIds',
	    updateLocation: '/query/box/updateLocation/:boxId',
	    markMissing: '/query/box/markMissing/:boxId',
	    remove: '/query/box/remove/:boxId',
	    create: '/query/box/create',
	    storeInstruction: '/query/box/storeInstruction/:boxId'
	  },
	  health: {
	    base: '/query/__health',
	    metrics: '/query/__health/metrics'
	  },
	  rack: {
	    shipping: {
	      marshalOrderPartsByBarcode: '/query/rack/shipping/:shippingFormId/marshalOrderPartsByBarcode',
	      transfer: '/query/rack/shipping/:rackId/bin/:bin/transfer'
	    },
	    bulkByBarcode: '/query/rack/bulkByBarcode'
	  },
	  customization: {
	    orderPart: {
	      status: '/query/customization/orderPart/:orderPartId/status'
	    },
	    shippingForm: {
	      status: '/query/customization/shippingForm/:shippingFormId/status'
	    },
	    assemblyItem: {
	      status: '/query/customization/assemblyItem/:assemblyItemId/status'
	    }
	  },
	  printEmbr: {
	    hold: '/query/printEmbr/hold'
	  },
	  ripProfile: {
	    detail: '/query/ripProfile/:ripProfileId',
	    byRipProfileGroupId: '/query/ripProfile/ripProfileGroup/:ripProfileGroupId',
	    bulkById: '/query/ripProfile/bulkById',
	    search: '/query/ripProfile/-/search',
	    create: '/query/ripProfile/create',
	    update: '/query/ripProfile/:ripProfileId/update',
	    "delete": '/query/ripProfile/:ripProfileId/delete'
	  },
	  ripProfileGroup: {
	    detail: '/query/ripProfileGroup/:ripProfileGroupId',
	    bulkById: '/query/ripProfileGroup/bulkById',
	    create: '/query/ripProfileGroup/create',
	    search: '/query/ripProfileGroup/-/search',
	    update: '/query/ripProfileGroup/:ripProfileGroupId/update',
	    "delete": '/query/ripProfileGroup/:ripProfileGroupId/delete',
	    configuration: '/query/ripProfileGroup/:ripProfileGroupId/configurationSetting'
	  },
	  storageRack: {
	    base: '/query/storageRack',
	    storeInstruction: '/query/storageRack/storeInstruction',
	    store: '/query/storageRack/store',
	    labelData: '/query/storageRack/labelData/:rackId',
	    clear: '/query/storageRack/clear',
	    locationByOrderPart: '/query/storageRack/locationByOrderPart',
	    shippingForms: '/query/storageRack/shippingForms/:rackId',
	    shippingStatus: '/query/storageRack/shippingStatus/:rackId',
	    findByShippingFormId: '/query/storageRack/findByShippingFormId/:shippingFormId'
	  },
	  storageBin: {
	    findByRackId: '/query/storageBin/findByRackId/:rackId'
	  },
	  preprintStoreBin: {
	    pullList: '/query/preprintStoreBin/pullList',
	    pull: '/query/preprintStoreBin/pull',
	    "return": '/query/preprintStoreBin/return',
	    forcePull: '/query/preprintStoreBin/forcePull'
	  },
	  orderForm: {
	    detail: '/query/orderForm/:orderFormId',
	    history: '/query/orderForm/:orderFormId/history',
	    shipStatus: '/query/orderForm/:orderFormId/shipStatus'
	  },
	  orderFormRun: {
	    detail: '/query/orderFormRun/:orderFormRunId',
	    barcode: '/query/orderFormRun/barcode/:barcode',
	    orderForm: '/query/orderFormRun/orderForm/:orderFormId',
	    qcStatus: '/query/orderFormRun/qcStatus/:orderFormRunId',
	    itemStatus: '/query/orderFormRun/itemStatus/:orderFormRunId',
	    screenprint: {
	      qcComplete: '/query/orderFormRun/qcComplete/:orderFormRunId',
	      qcIncomplete: '/query/orderFormRun/qcIncomplete/:orderFormRunId'
	    },
	    shipping: {
	      shipComplete: '/query/orderFormRun/shipComplete/:orderFormRunId'
	    },
	    search: '/query/orderFormRun/-/search',
	    pressSetup: '/query/orderFormRun/pressSetup/:orderFormRunId',
	    qcBulkApprove: '/query/orderFormRun/qcBulkApprove/:orderFormRunId',
	    bulkMarshalComplete: '/query/orderFormRun/bulkMarshalComplete/:orderFormRunId'
	  },
	  orderPart: {
	    prioritize: '/query/orderPart/prioritize',
	    ripStatus: '/query/orderPart/:orderPartId/ripStatus',
	    stockStatus: '/query/orderPart/:orderPartId/stockStatus',
	    rejectItem: '/query/orderPart/:orderPartId/rejectItem',
	    status: '/query/orderPart/:orderPartId/status',
	    artworkId: '/query/orderPart/artworkId/:artworkId',
	    specialInstruction: '/query/orderPart/:orderPartBarcode/specialInstruction',
	    convertToDtg: '/query/orderPart/convertToDtg',
	    statusUpdate: '/query/orderPart/statusUpdate',
	    bulkByStatus: '/query/orderPart/bulkByStatus'
	  },
	  orderPartItem: {
	    count: '/query/orderPartItem/count'
	  },
	  printPart: {
	    bulkByIdentifiers: '/query/printPart/bulkByIdentifiers',
	    bulkByUserId: '/query/printPart/bulkByUserId/:userId'
	  },
	  shippingForm: {
	    switchFacility: '/query/shippingForm/:shippingFormId/switchFacility',
	    qcAudit: {
	      kickOutForm: '/query/shippingForm/:shippingFormId/qcAudit/kickOutForm',
	      markAudited: '/query/shippingForm/:shippingFormId/qcAudit/markAudited'
	    },
	    serviceCarrier: '/query/shippingForm/:shippingFormId/serviceCarrier'
	  },
	  fulfillment: {
	    getNext: '/query/fulfillment/getNext',
	    decrementStock: '/query/fulfillment/decrementStock'
	  },
	  data: {
	    artwork: {
	      detail: '/query/data/artwork/:artworkId',
	      bulk: '/query/data/artwork/bulk'
	    },
	    artworkConversion: {
	      detail: '/query/data/artworkConversion/:conversionId',
	      search: '/query/data/artworkConversion/search',
	      bulk: '/query/data/artworkConversion/bulk'
	    },
	    autoPrint: {
	      detail: 'query/data/autoPrint/:autoPrintId'
	    },
	    autoPrintSheet: {
	      detail: 'query/data/autoPrintSheet/:autoPrintSheetId'
	    },
	    productItem: {
	      search: '/query/data/productItem/search',
	      detail: '/query/data/productItem/:productItemId',
	      bulk: '/query/data/productItem/bulk',
	      product: '/query/data/productItem/product/:productId',
	      gtin: '/query/data/productItem/gtin/:gtin',
	      code: '/query/data/productItem/code/:code'
	    },
	    product: {
	      detail: '/query/data/product/:productId',
	      bulk: '/query/data/product/bulk',
	      all: '/query/data/product/all',
	      search: '/query/data/product/search',
	      bulkOoProductIds: '/query/data/product/bulkOoProductIds',
	      identifier: '/query/data/product/identifier/:productIdentifier',
	      legacy: '/query/data/product/legacy/:ooProductId'
	    },
	    order: {
	      detail: '/query/data/order/:orderId',
	      bulk: '/query/data/order/bulk',
	      breakdown: '/query/data/order/breakdown',
	      reference: '/query/data/reference/:referenceId',
	      stuck: '/query/data/order/stuck',
	      printing: '/query/data/order/printing',
	      flow: '/query/data/order/flow',
	      query: '/query/data/order/query',
	      shipment: {
	        group: '/query/data/order/:orderId/shipment/group'
	      },
	      tracking: '/query/data/order/tracking/:trackingNumber',
	      checkReference: '/query/data/order/checkReference/:checkReference'
	    },
	    orderEvent: {
	      query: '/query/data/orderEvent/query'
	    },
	    employee: {
	      all: '/query/data/employee/all',
	      search: '/query/data/employee/search',
	      upsert: '/query/data/employee/upsert',
	      present: '/query/data/employee/present'
	    },
	    employeeLog: {
	      search: '/query/data/employeeLog/search',
	      performance: '/query/data/employeeLog/performance'
	    },
	    employeeShift: {
	      search: '/query/data/employeeShift/search'
	    },
	    user: {
	      base: '/query/data/user',
	      internal: '/query/data/user/internal',
	      search: '/query/data/user/search',
	      bulk: '/query/data/user/bulk',
	      detail: '/query/data/user/:userId',
	      orders: '/query/data/user/:userId/orders',
	      designs: '/query/data/user/:userId/designs',
	      productCount: '/query/data/user/:userId/productCount',
	      salesRep: '/query/data/user/salesRep',
	      linkLead: '/query/data/user/:userId/lead/:leadId/link',
	      affiliationGroups: '/query/data/user/affiliationGroups',
	      referrer: '/query/data/user/referrer',
	      subUsers: '/query/data/user/subUsers',
	      activate: '/query/data/user/:userId/activate',
	      deactivate: '/query/data/user/:userId/deactivate'
	    },
	    orderForm: {
	      reference: '/query/data/orderForm/reference/:referenceId',
	      bulk: '/query/data/orderForm/bulk',
	      referenceBulk: '/query/data/orderForm/referenceBulk',
	      operationHold: '/query/data/orderForm/:orderFormId/operationHold'
	    },
	    design: {
	      detail: '/query/data/design/:designId',
	      bulk: '/query/data/design/bulk',
	      orders: '/query/data/design/:designId/orders'
	    },
	    printPart: {
	      base: '/query/data/printPart',
	      detail: '/query/data/printPart/:printPartId',
	      bulk: '/query/data/printPart/bulk'
	    },
	    report: {
	      query: '/query/data/report/query'
	    },
	    queueJob: {
	      detail: '/query/data/queueJob/:jobId',
	      bulk: '/query/data/queueJob/bulk',
	      clear: '/query/data/queueJob/clear'
	    },
	    pricing: {
	      base: '/query/data/pricing',
	      detail: '/query/data/pricing/:pricingId'
	    },
	    shippingForm: {
	      detail: '/query/data/shippingForm/:shippingFormId',
	      bulk: '/query/data/shippingForm/bulk',
	      bulkById: '/query/data/shippingForm/bulkById',
	      bulkByOrderFormId: '/query/data/shippingForm/bulkByOrderFormId',
	      bulkOrderDetails: '/query/data/shippingForm/bulkOrderDetails',
	      children: '/query/data/shippingForm/:shippingFormId/children',
	      byOrderId: '/query/data/shippingForm/byOrderId/:orderId'
	    },
	    tracking: {
	      bulk: '/query/data/tracking/bulk'
	    },
	    billing: {
	      detail: '/query/data/billing/:billingId',
	      transactions: '/query/data/billing/:billingId/transactions',
	      balance: '/query/data/billing/:billingId/balance'
	    },
	    setting: {
	      base: '/query/data/setting',
	      cartId: '/query/data/setting/cartId',
	      palletId: '/query/data/setting/palletId',
	      casePrinting: '/query/data/setting/casePrinting',
	      qcAudit: '/query/data/setting/qcAudit',
	      orderApprovalUsers: '/query/data/setting/orderApprovalUsers',
	      facilityCapacity: '/query/data/setting/facilityCapacity',
	      facilityMinimumThroughput: '/query/data/setting/facilityMinimumThroughput',
	      facilityPriority: '/query/data/setting/facilityPriority'
	    },
	    facilityCapacity: {
	      create: '/query/data/facilityCapacity/create'
	    },
	    rack: {
	      base: '/query/data/racks/:rackId',
	      name: '/query/data/racks/name/:rackName',
	      query: '/query/data/racks/query/:facility',
	      bulkBarcodes: '/query/data/racks/bulkBarcode'
	    },
	    orderPart: {
	      statusCount: '/query/data/orderPart/statusCount',
	      detail: '/query/data/orderPart/:orderPartId',
	      bulk: '/query/data/orderPart/bulk',
	      bulkByBarcode: '/query/data/orderPart/bulkByBarcode',
	      barcode: '/query/data/orderPart/barcode/:barcode',
	      query: '/query/data/orderPart/query',
	      bulkBarcodes: '/query/data/orderPart/bulkBarcode',
	      images: '/query/data/orderPart/:orderPartId/images',
	      personalization: '/query/data/orderPart/:orderPartId/personalization',
	      bulkFormIds: '/query/data/orderPart/bulkFormIds',
	      shippingFormId: '/query/data/orderPart/shippingForm/:shippingFormId',
	      ooOrderId: '/query/data/orderPart/ooOrderId/:ooOrderId',
	      orderId: '/query/data/orderPart/orderId/:orderId',
	      bulkStoredStatus: '/query/data/orderPart/bulkStoredStatus',
	      counter: '/query/data/orderPart/:orderPartId/counter',
	      ripId: '/query/data/orderPart/ripId/:ripId',
	      ripIdBulk: '/query/data/orderPart/ripIdBulk',
	      orderPartItem: '/query/data/orderPart/:orderPartId/orderPartItem'
	    },
	    claim: {
	      base: '/query/data/claim',
	      count: '/query/data/claim/count',
	      search: '/query/data/claim/search',
	      detail: '/query/data/claim/:claimId',
	      status: '/query/data/claim/status/:status',
	      report: '/query/data/claim/report'
	    },
	    orderPartRejection: {
	      base: '/query/data/orderPartRejection',
	      byType: '/query/data/orderPartRejection/byType/:type'
	    },
	    shopifyItem: {
	      bulkByVariantId: '/query/data/shopifyItem/bulkByVariantId'
	    },
	    shopifyLineItem: {
	      bulkByShopifyLineItemId: '/query/data/shopifyLineItem/bulkByShopifyLineItemId'
	    },
	    salesReportSetting: {
	      base: '/query/data/salesReportSetting'
	    },
	    salesReps: {
	      base: '/query/data/salesReps'
	    },
	    inventoryLog: {
	      query: '/query/data/inventoryLog/query'
	    },
	    inventoryRack: {
	      base: '/query/data/inventoryRack/:rackId',
	      query: '/query/data/inventoryRack/query/:facility'
	    },
	    rip2: {
	      hold: '/query/data/rip2/hold'
	    },
	    invoice: {
	      byOrderId: '/query/data/byOrderId/billing/:billingId/orderId/:orderId'
	    }
	  },
	  orderLog: {
	    latest: '/query/orderLog/latest'
	  },
	  employeeShift: {
	    detail: '/query/employeeShift/detail/:employeeShiftId',
	    logs: '/query/employeeShift/logs/:employeeShiftId',
	    aggregateScans: '/query/employeeShift/aggreagateScans'
	  },
	  assembly: {
	    assemblyItem: {
	      barcode: '/query/assembly/assemblyItem/barcode/:barcode',
	      create: '/query/assembly/assemblyItem/create',
	      detail: '/query/assembly/assemblyItem/detail/:assemblyItemId',
	      history: '/query/assembly/assemblyItem/history/:barcode',
	      pendingRejectionApproval: '/query/assembly/assemblyItem/pendingRejectionApproval',
	      shipmentStatus: '/query/assembly/assemblyItem/shipmentStatus/:assemblyItemId',
	      status: {
	        item: '/query/assembly/assemblyItem/status/item',
	        items: '/query/assembly/assemblyItem/status/items'
	      },
	      assemblyQueueJob: '/query/assembly/assemblyItem/assemblyQueueJob/:assemblyItemId'
	    },
	    assemblyQueue: {
	      count: '/query/assembly/assemblyQueue/count',
	      bulkCount: '/query/assembly/assemblyQueue/bulkCount',
	      positions: '/query/assembly/assemblyQueue/positions',
	      update: '/query/assembly/assemblyQueue/update'
	    }
	  },
	  mockupTemplate: {
	    base: '/query/mockupTemplate',
	    bulk: '/query/mockupTemplate/bulk',
	    search: '/query/mockupTemplate/search',
	    byIdentifier: '/query/mockupTemplate/byIdentifier',
	    bulkByIdentifier: '/query/mockupTemplate/bulkByIdentifier'
	  },
	  boxRack: {
	    search: '/query/boxRack/search'
	  },
	  externalBlankOrder: {
	    detail: '/query/externalBlankOrder/detail/:externalBlankOrderId',
	    bulk: '/query/externalBlankOrder/bulk'
	  },
	  inventoryBlankOrder: {
	    base: '/query/inventoryBlankOrder',
	    barcode: '/query/inventoryBlankOrder/barcode/:barcode',
	    edit: '/query/inventoryBlankOrder/:inventoryBlankOrderId/edit',
	    search: '/query/inventoryBlankOrder/search',
	    cancel: '/query/inventoryBlankOrder/cancel',
	    itemCount: '/query/inventoryBlankOrder/itemCount',
	    receive: '/query/inventoryBlankOrder/receive'
	  },
	  embr: {
	    matrix2: {
	      matrixCode: '/query/embr/matrix2/matrixCode/:matrixCode',
	      colorCodes: '/query/embr/matrix2/colorCodes',
	      lock: '/query/embr/matrix2/lock'
	    }
	  },
	  external: {
	    inkpop: {
	      order: {
	        orderReleased: '/query/external/inkpop/order/orderReleased/:spOrderId'
	      }
	    }
	  },
	  shipping: {
	    label: '/query/shipping/:formId/label'
	  }
	};


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

	module.exports = {
	  base: 'sanmar',
	  views: {
	    demo: {
	      design: '/sanmar/views/demo/design',
	      customer: {
	        orders: {
	          base: '/sanmar/views/demo/customer/orders',
	          detail: '/sanmar/views/demo/customer/orders/:orderId',
	          approval: '/sanmar/views/demo/customer/orders/:orderId/approval'
	        }
	      },
	      vendor: {
	        orders: {
	          base: '/sanmar/views/demo/vendor/orders',
	          detail: '/sanmar/views/demo/vendor/orders/:orderId'
	        },
	        invoices: {
	          base: '/sanmar/views/demo/vendor/manager'
	        }
	      }
	    }
	  },
	  widget: {
	    base: '/sanmar/widget/base.js',
	    demo: '/sanmar/widget/demo.html',
	    test: '/sanmar/widget/test'
	  },
	  data: {
	    design: {
	      base: '/sanmar/data/design/'
	    }
	  }
	};


/***/ }),

/***/ 283:
/***/ (function(module, exports) {

	module.exports = {
	  invoice: '/statement/billing/:billingId/invoice/:invoiceId',
	  billing: '/statement/billing/:billingId',
	  mockup: {
	    design: '/statement/mockup/design'
	  }
	};


/***/ }),

/***/ 284:
/***/ (function(module, exports) {

	module.exports = {
	  update: '/updater/update/:module',
	  start: '/updater/start/:module',
	  register: '/updater/register'
	};


/***/ }),

/***/ 285:
/***/ (function(module, exports) {

	module.exports = {
	  capture: {
	    base: '/webcam/capture/',
	    options: '/webcam/capture/options'
	  }
	};


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

	module.exports = {
	  home: {
	    index: '/',
	    pricing: '/pricing',
	    screenprinting: '/screenprint',
	    dtg: '/dtg',
	    tshirt: '/',
	    sublimation: '/sublimation',
	    shopify: '/shopify',
	    woocommerce: '/woocommerce',
	    "case": '/sublimation',
	    mug: '/sublimation',
	    contact: '/contact'
	  },
	  company: {
	    about: '/company/about',
	    terms: '/company/terms',
	    privacy: '/company/privacy'
	  },
	  auth: {
	    login: '/auth/login',
	    logout: '/auth/logout',
	    addSubUsers: '/auth/addSubUsers',
	    register: '/auth/register',
	    registerSubUser: '/auth/registerSubUser',
	    reset: '/auth/reset',
	    changePassword: '/auth/change',
	    forgot: '/auth/forgot',
	    facebook: {
	      login: '/auth/facebook/login',
	      callback: '/auth/facebook/callback'
	    },
	    google: {
	      login: '/auth/google/login',
	      callback: '/auth/google/callback'
	    },
	    success: '/auth/success',
	    assume: '/auth/assume/:userId',
	    unassume: '/auth/unassume',
	    crmUpdate: '/auth/crmUpdate',
	    totp: {
	      user: '/auth/totp/user'
	    },
	    coupa: '/auth/coupa',
	    twilio: {
	      createVerificationSms: '/auth/createVerificationSms'
	    }
	  },
	  policies: {
	    resellerLicense: '/policies/resellerLicense',
	    productionPrinters: '/policies/productionPrinters',
	    moduleVersions: '/policies/moduleVersions'
	  },
	  catalog: {
	    base: '/_catalog',
	    product: '/_catalog#'
	  },
	  docs: {
	    base: '/docs/'
	  },
	  services: {
	    base: '/services'
	  },
	  press: {
	    base: '/press'
	  },
	  status: {
	    base: '/status',
	    secret: '/status/secret'
	  }
	};


/***/ }),

/***/ 287:
/***/ (function(module, exports) {

	module.exports = {
	  home: {
	    base: '/',
	    screenprint: '/screenprint',
	    dtg: '/dtg',
	    sublimation: '/sublimation',
	    poster: '/posters',
	    embroidery: '/embroidery',
	    woocommerce: '/woocommerce',
	    shopify: '/shopify',
	    api: '/api',
	    pricing: '/pricing',
	    catalog: '/catalog',
	    jobs: '/jobs',
	    careers: {
	      base: '/careers',
	      data: {
	        positions: '/careers/data/positions/'
	      }
	    },
	    auth: {
	      register: '/auth/v2/register',
	      login: '/auth/v2/login'
	    }
	  }
	};


/***/ }),

/***/ 407:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 411:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 412:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "82592831f81a44b26d9a33e6df27f67e.png";

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "3c05bf4df0fd4c74e48807a7c011acac.png";

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "87d57d22108b5e9333853abc4d00fc4b.png";

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c19c1502fe189cb922bde7e1e120e720.png";

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "562debf350e384a5219db70fe289a740.png";

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "52764ee9f90c0bd9e9c210501bed61cc.png";

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "becc7c4944e1f8070fc2f1645ebf067c.png";

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "09882d13e3d3d21e60bb74d9f087c4bb.png";

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA2CAYAAABwUEEXAAAAAXNSR0IArs4c6QAAA2ZJREFUaAXtWstqFEEUtc34xkSJBsSFiCjo0k9w4UbcBFzHICKSgPgL7sSV4FrBjSCCLl35Bb4WPggxKm5ERRONGGNM2nNgarh951pdGU1PV3cXFF330VXn1K2+XV0zyTqjpGl6AeqdhilW1WySJFc1+PVaUSe51uRbAZG+BZ8vAX5lcxkBoFM+UCHk+bx88nVSRhvy1sY8XC04jRtO2w1dzKpB8DyrCTDy+7SygvIAOO3VvJqEJ2bkPtq/UY+hbhX62Js/QOABKvPAcUdGR/4pkttDGBedQ0Wui21eTyQfne2HkBi2wEFPirwnxvYAeO0G8E0SvCZ/Xhor1B4ElwnNp2oR1vy8cq3Jc9lfNqbnHHQ7DH2sqjkAv6bBt5AFF7QSySHVusjlFDz5Cs8UnfAyxrYwhrlYtgwl13FX5y0h5Ld5e4jYWOuEl1iBwzI/AP0Gy9bWHcX1kMdetOkFBnzkGXQJz/w7bTeXPRxntKOTMTFH0D7o5JJcDwPHM+DmJAQXkzwIbkYP1iMxDP0oqlsx39CeRu1X4erj2QPxjAL3PK6zqLqsYGL4cZMpjkRGiU5CTm9/4qbr6PRj5uYCBeAcwXDjqPwe8ZX/fnp7p5/EybQ9/m0fa5/NWto+f2d7iYFfOaGfV+B4g/Gf94IhhPxNdHwFVe4EH/cy2BreI/HwLIJ4b+SNF0KezzZ3S+65WkGbs12m8hZgiIuF3+xM5L8o+ApPbycNhyGlk7u8eSy1rn2y8i9UBJ5l8PiKQd1PbMQrv094SHNRg+IM7dJKQ5b75CXDXgaVDAjxSpkrXAfUfJeXgUghGPQm5y5GZWRPoMqlXgiYNRzkO/q+h8p80PkJSye8KTw/3CLmJgv4xFS4t+er+bUErSO/B4mBxLVe3hNjm4l9P4BnPtY0ybEYmQVg5v6/i5te9gH9VMeFkXebA8mqapPCd35XHuMB5iXJmm08HyFfdfq2Mstz4Nn8J0dGSCc8aXPtM64R0fV0CNYQ8nJrG9JnGXyCMFctsa1q4v8WeZ6OSBuPi06uquf+OnMr+0FAkB85HbUk2FEiM77vCGgg+0sxhvZnzcECXetl35C3lkQddE3k6xBli2MTeWtW6qAz3/M5xN1/2nLcCjcHbWklql7I82x8QnYSa7t55mON3L/i/gP6uKJY/uGTuAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 567:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAABsCAYAAABNetEMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3xJREFUeNrsneFt2kAUgI+K/2WDeIPw30K4G3QD6AQlE4QNQieos0E6QWxF/CcbkA3IBM47ca1ct7YPczY+/H2SFSEsB9993Htnnx+jLMuULWE4m8qfiQIfOGy3LzubHccnHngj25z29YJUtshmx0+0FSABIAEgASABNJkdlPEq24rmvAh6xnbbBwn0nDShP7onDGcHwgGQE4CDnECGk0j+PtMUV8dc+jZjJADCASABIAEgAdjPDmref5Rtn3u9lO2GZvOCN9ni3Gs9C5w3kSDOXwk000kk8IO99N0613frMgkIB4AEgARgkRNsCneppjSZN0yl75Lc66CpBLe0pbd8VpYrwwkHgASABIAE8Dsx1Nl/aptxmoQD+s+7bHbPIpqHFiObnc2Ug2cR/WAnfWvVr4QDQAJw99xBYO5SQfcEfZFA316+pz8IB4AEgASABIAE4DGjU0rYnYtMI3X5u51isWodut5DtN2+HK5qJDACJAhghV7Ms7nGcJAoViqdwkK+OPHVSGBOBgGaibD2PieQk9C1jB5qdvuhjre0h4gOk99r9vnSZjmg0Ym1jfUHcX0r+ZucYDzkr7sZKReOD5v6civ5bugCaKQNlur43OfgrhM8yslvFORFSIckQWpOGv7mqzo+TTwICRDg/6PB4RJtcwkJdBjY0+WlIiRdhwVXi0qKBRG0zWVXBskD6okrZmFakMSyrTuVoFgQoazO8ZvtT7IMnCfZflaMFvm2js6VwHk4kA8VqPJnE57oX+vc4FfJ286X/LeREwQV7yV0sTW7ii+a0x8jG5tfOLON09MzJSAhdCCB6Ye6L1SxPkFlTjBxPMQEFcMc+YA9595LoT4B9Ps6ASABIAH0jrqLRa+FBIX6BP5QrE+gE/abJhKsCmVtE0V9Am+mmPlFJWaZ2j3hAMgJAAmgYWK4NHep8skF+EGxcEjUVIIFbekt1oVDCAeABIAEgASABHCcHZjLwiObnbls7BUpZW2BcAAnhANHx5nkriwGNGvr6EWkf9q+LxLoKiTP9E1nPLg8GOEAkACQAJAAkAAazQ5WFlOSpWIdQtvcqfpfOju0IoHNs4SFlUjQDjuXdQ0JB4AEgASABIAEgASABIAEgASABIAEgASABIAEgASABIAE8A/jLv9ZGM4ympyRAJAAkACQAJAABjQ7SGjW1tm7PNiHAAMAIVjPpfaoED4AAAAASUVORK5CYII="

/***/ })

});


// WEBPACK FOOTER //
// 46188630104d0948eb23.app.js